

(function (t) {
    var e,
        a = t("body"),
        o = t(document),
        i = (t("html"), t(window));
    o.ready(() => {
        o.ajaxStart(() => {
            n.isAjaxLoading = !0;
        }),
            o.ajaxStop(() => {
                n.isAjaxLoading = !1;
            }),
            n.ready(),
            // Bind header interactions as soon as DOM is ready (do not wait for window.onload / images)
            n.initQuickCart(),
            n.headerSidebarSearch(),
            n.headerStickySearchForm(),
            (window.quick_view.show || window.quick_view.show_mb) && n.initQuickView(),
            window.innerWidth < 1025 && (n.menuSidebarMobile(), n.menuSidebarMobileToggle());
    }),
        (window.onload = function () {
            n.init();
        });
    var n = {
        haloTimeout: null,
        isAjaxLoading: !1,
        ready: function () {
            this.loaderScript(),
                this.loaderProductBlock(),
                navigator.userAgent.match(/Mac OS X.*(?:Safari|Chrome)/) && !navigator.userAgent.match(/Chrome/)
                    ? document.body.classList.add("safari")
                    : document.body.classList.add("chrome"),
                typeof InstallTrigger < "u" && document.body.classList.add("firefox"),
                /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && document.body.classList.add("iOS"),
                a.hasClass("template-product") && this.loaderRecommendationsBlock(),
                t("[data-product-tab-block]").length && this.clickedActiveProductTabs(),
                a.hasClass("product-card-layout-07") && this.calculateTranslateYHeight(),
                (window.sharedFunctions = {
                    setLocalStorageProductForWishlist: this.setLocalStorageProductForWishlist,
                    checkNeedToConvertCurrency: this.checkNeedToConvertCurrency,
                    productBlockSilder: this.productBlockSilder,
                    calculateTranslateYHeight: this.calculateTranslateYHeight,
                    productCountdownCard: n.productCountdownCard,
                    swapHoverVideoProductCard: n.swapHoverVideoProductCard,
                    updateSidebarCart: n.updateSidebarCart,
                });
        },
        init: function () {
            this.initMultiTab(),
                this.initMultiTabMobile(),
                this.productBlockInfiniteScroll(),
                this.initGlobalCheckbox(),
                this.initColorSwatch(),
                this.initAddToCart(),
                this.initQuickShop(),
                this.initQuickCart(),
                this.initNotifyInStock(),
                this.initCompareProduct(),
                this.initWishlist(),
                this.initAskAnExpert(),
                this.initHeader(),
                this.headerLanguageCurrency(),
                this.headerMasonry(),
                this.initLiveChat(),
                this.headerSidebarSearch(),
                this.headerStickySearchForm(),
                this.initCountdown(),
                this.collectionCountdown(),
                this.handleScrollDown(),
                this.initVideoPopup(),
                this.swapHoverVideoProductCard(),
                this.initDynamicBrowserTabTitle(),
                this.initWarningPopup(),
                this.clickIconScrollSection(),
                this.specialBanner(),
                this.formMessage(),
                this.typingAnimation(),
                this.spotlightproductSlider(),
                this.doBeforeMegaMenuProductBlock(),
                t(".lookbook-carousel").length && this.lookbookCarousel(),
                (window.quick_view.show || window.quick_view.show_mb) && this.initQuickView(),
                window.innerWidth < 1025 && (this.menuSidebarMobile(), this.menuSidebarMobileToggle());
            const e2 = document.querySelectorAll(".media--loading-effect img"),
                o2 = document.getElementById("main-collection-product-grid");
            let s;
            (e2.length > 0 || o2) && this.initLazyloadObserver(e2, o2),
                a.hasClass("show_effect_close") &&
                    (this.backgroundOverlayHoverEffect(), this.backgroundOverlayHoverEffect1()),
                a.hasClass("template-cart") && (this.updateGiftWrapper(), this.activeCheckboxStickyCartMobile()),
                (a.hasClass("template-product") || t(".product-details").hasClass("featured-product")) &&
                    (this.initProductView(t(".halo-productView")),
                    this.initProductBundle(),
                    this.articleGallery(),
                    this.toggleSidebarMobile(),
                    this.initCollapseSidebarBlock(),
                    this.initCategoryActive(),
                    this.productCustomInformation(),
                    this.iconZoomClickMobile(),
                    this.productBlockSilderSidebar()),
                (a.hasClass("template-blog") || a.hasClass("template-article")) &&
                    (this.initCollapseSidebarBlock(),
                    this.initCategoryActive(),
                    this.toggleSidebarMobile(),
                    this.initBlogMasonry(),
                    this.productBlockSilderSidebar(),
                    this.productBlockSilderArticle()),
                a.hasClass("template-article") && this.articleGallery(),
                (a.hasClass("template-collection") || a.hasClass("template-search")) &&
                    (this.initCollapseSidebarBlock(),
                    this.initCategoryActive(),
                    this.toggleSidebarMobile(),
                    this.productBlockSilderSidebar(),
                    this.initInfiniteScrolling(),
                    this.initQuickShopProductList()),
                a.hasClass("template-list-collections") &&
                    (this.toggleSidebarMobile(), this.productBlockSilderSidebar()),
                a.hasClass("template-collection") &&
                    t(".collection-express-order").length &&
                    (this.toggleVariantsForExpressOrder(), this.initExpressOrderAddToCart()),
                a.hasClass("product-card-layout-08") && n.productCountdownCard(),
                n.checkScrollLayoutForRecenlyViewed(),
                (s = window.innerWidth > 1024),
                i.on("resize", () => {
                    this.headerSidebarSearch(),
                        this.specialBanner(),
                        this.specialBannerSlider(),
                        this.unsymmetricalSlider(),
                        this.doBeforeMegaMenuProductBlock(),
                        window.innerWidth > 1024
                            ? document.body.classList.remove("menu_open")
                            : s &&
                              ((s = !1),
                              this.menuSidebarMobile(),
                              this.menuSidebarMobileToggle(),
                              this.initMultiTab(),
                              this.initMultiTabMobile());
                });
        },
        checkNeedToConvertCurrency: function () {
            return (
                (window.show_multiple_currencies &&
                    typeof Currency < "u" &&
                    Currency.currentCurrency != shopCurrency) ||
                window.show_auto_currency
            );
        },
        loaderScript: function () {
            var e2 = function () {
                var e3 = t("[data-loader-script]");
                e3.length > 0 &&
                    e3.each((e4, a2) => {
                        var o2 = t(a2),
                            i2 = o2.data("loader-script"),
                            s = a2.getBoundingClientRect().top;
                        o2.hasClass("is-load") ||
                            (s < window.innerHeight + 100 &&
                                (n.buildScript(i2), t('[data-loader-script="' + i2 + '"]').addClass("is-load")));
                    });
            };
            e2(), window.addEventListener("scroll", e2);
        },
        buildScript: function (t2) {
            var e2 = document.createElement("script");
            (e2.src = t2), document.body.appendChild(e2);
        },
        buildStyleSheet: function (t2, e2) {
            if (t2 == "") return;
            const a2 = document.createElement("link");
            (a2.rel = "stylesheet"), (a2.type = "text/css"), (a2.href = t2), e2.parentNode.insertBefore(a2, e2);
        },
        loaderProductBlock: function () {
            o.ajaxStart(() => {}),
                o.ajaxStop(() => {}),
                (this.productBlock = document.querySelectorAll("[data-product-block]")),
                (this.observer = new IntersectionObserver(
                    (e2, o2) => {
                        e2.forEach((e3) => {
                            if (e3.isIntersecting) {
                                const u = t(e3.target);
                                if (u.hasClass("ajax-loaded")) return;
                                var o3 = u.data("collection"),
                                    i2 = u.data("layout"),
                                    s = u.data("limit"),
                                    r = u.data("image-ratio"),
                                    c = u.data("swipe"),
                                    l = u.attr("sectionId"),
                                    d = u.attr("hasCountdown");
                                o3 != null && o3 != null
                                    ? t.ajax({
                                          type: "get",
                                          url: window.routes.root + "/collections/" + o3,
                                          cache: !1,
                                          data: {
                                              view: "ajax_product_block",
                                              constraint:
                                                  "limit=" +
                                                  s +
                                                  "+layout=" +
                                                  i2 +
                                                  "+sectionId=" +
                                                  l +
                                                  "+imageRatio=" +
                                                  r +
                                                  "+swipe=" +
                                                  c +
                                                  "+hasCountdown=" +
                                                  d,
                                          },
                                          beforeSend: function () {
                                              u.addClass("ajax-loaded");
                                          },
                                          success: function (e4) {
                                              if (o3 != "") {
                                                  const a2 = n.handleResponse(t(e4), 0, s);
                                                  i2 == "grid"
                                                      ? u.find(".products-grid").html(a2)
                                                      : i2 == "slider"
                                                        ? u.find(".products-carousel").html(a2)
                                                        : i2 == "scroll" && u.find(".products-flex").html(a2),
                                                      u
                                                          .find(
                                                              ".card-product .variants-popup-content .selector-wrapper .swatch-element"
                                                          )
                                                          .each(function () {
                                                              const e5 = t(this).find("input"),
                                                                  a3 = t(this).find("label");
                                                              e5.attr({
                                                                  id: (e5.attr("id") || "") + l,
                                                                  name: (e5.attr("name") || "") + l,
                                                              }),
                                                                  a3.attr("for", (a3.attr("for") || "") + l);
                                                          }),
                                                      u.find(".card-product").each(function () {
                                                          const e5 = t(this).find(".variants-popup-content form"),
                                                              a3 = t(this).find(".card-action form"),
                                                              o4 = t(this).find(".variants-popup-content select"),
                                                              i3 = t(this).find(".card-action form button"),
                                                              n2 = t(this).find(
                                                                  ".variants-popup-content .product-card__button2 button"
                                                              );
                                                          e5.attr("id", (e5.attr("id") || "") + l),
                                                              a3.attr("id", (a3.attr("id") || "") + l),
                                                              o4.attr("id", (o4.attr("id") || "") + l),
                                                              i3.attr(
                                                                  "data-form-id",
                                                                  (i3.attr("data-form-id") || "") + l
                                                              ),
                                                              n2.attr(
                                                                  "data-form-id",
                                                                  (n2.attr("data-form-id") || "") + l
                                                              );
                                                      });
                                              }
                                          },
                                          complete: function () {
                                              if (
                                                  (i2 == "slider" && n.productBlockSilder(u),
                                                  u.hasClass("special-banner__product") &&
                                                      i2 == "grid" &&
                                                      window.innerWidth < 1200 &&
                                                      (u
                                                          .find(".special-banner__products--grid")
                                                          .addClass("products-carousel"),
                                                      n.productBlockSilder(u)),
                                                  u.hasClass("halo-block-unsymmetrical") &&
                                                      i2 == "grid" &&
                                                      window.innerWidth < 1200 &&
                                                      n.unsymmetricalSlider(u),
                                                  window.compare.show)
                                              ) {
                                                  var e4 = t("[data-compare-link]");
                                                  n.setLocalStorageProductForCompare(e4);
                                              }
                                              n.swapHoverVideoProductCard(),
                                                  window.wishlist.show && n.setLocalStorageProductForWishlist(),
                                                  n.checkNeedToConvertCurrency() &&
                                                      Currency.convertAll(
                                                          window.shop_currency,
                                                          t("#currencies .active").attr("data-currency"),
                                                          "span.money",
                                                          "money_format"
                                                      ),
                                                  t("body").hasClass("cursor-fixed__show") &&
                                                      (window.sharedFunctionsAnimation.onEnterButton(),
                                                      window.sharedFunctionsAnimation.onLeaveButton()),
                                                  a.hasClass("product-card-layout-08") && n.productCountdownCard();
                                          },
                                      })
                                    : (u.addClass("ajax-loaded"),
                                      i2 == "slider" && n.productBlockSilder(u),
                                      n.checkNeedToConvertCurrency() &&
                                          Currency.convertAll(
                                              window.shop_currency,
                                              t("#currencies .active").attr("data-currency"),
                                              "span.money",
                                              "money_format"
                                          ));
                            }
                        });
                    },
                    { rootMargin: "0px 0px 200px 0px" }
                )),
                this.productBlock.forEach((t2) => {
                    this.observer.observe(t2);
                });
        },
        handleResponse: (t2, e2, a2) => (t2 = t2.splice(e2, a2)),
        loaderRecommendationsBlock: function () {
            n.buildRecommendationBlock();
        },
        headerMasonry: function () {
            var $masonryElements = t(".menu-dropdown__wrapper [data-masonry]");
            if ($masonryElements.length && $.fn.masonry) {
                $masonryElements.masonry({
                    columnWidth: ".grid-sizer",
                    itemSelector: "[data-gridItem]",
                });
            }
        },
        initLiveChat: function () {
            t(".live-wrapper-icon").on("click", function (e2) {
                t(this).parent().toggleClass("live_help--active");
            }),
                a.on("click", function (e2) {
                    t(".live_help").hasClass("live_help--active") &&
                        t(event.target).closest(".live_help").length === 0 &&
                        (e2.preventDefault(), t(".live_help").removeClass("live_help--active"));
                });
        },
        initHeader: function () {
            const t2 = document.querySelectorAll('[class*="section-header"]');
            if (t2) {
                let e2 = t2.length + 20;
                t2.forEach((t3) => {
                    t3.classList.contains("section-header-mobile") ||
                        (t3.setAttribute("data-index", e2), (t3.style.zIndex = e2), e2--);
                });
                const a2 = document.querySelector(".header-basic--transparent");
                if (a2 && document.body.classList.contains("template-index")) {
                    const t3 = a2.offsetHeight,
                        e3 = document.querySelector('.header-navigation[class*="--transparent"]');
                    e3 && ((e3.style.top = `${t3}px`), e3.classList.add("has-top"));
                }
            }
        },
        headerLanguageCurrency: function () {
            if (!document.querySelector(".header-language_currency")) return;
            const t2 = document.querySelectorAll('[class*="section-header-"]');
            document.addEventListener("click", (e2) => {
                const a2 = e2.target,
                    o2 = a2.closest(".header-language_currency"),
                    i2 = o2?.querySelector(".top-language-currency"),
                    n2 = o2?.querySelector(".dropdown-currency"),
                    s = o2?.querySelector(".dropdown-language");
                a2.matches(".header-language_currency") || a2.closest(".header-language_currency")
                    ? (a2.matches(".icon-languageCurrency") || a2.closest(".icon-languageCurrency")
                          ? i2?.classList.toggle("show")
                          : (!a2.matches(".top-language-currency") && !a2.closest(".top-language-currency")) ||
                            document.querySelector(".icon-languageCurrency") ||
                            i2?.classList.toggle("show"),
                      (a2.matches(".halo-top-currency") || a2.closest(".halo-top-currency")) &&
                          (s?.classList.remove("show"), n2?.classList.toggle("show")),
                      (a2.matches(".halo-top-language") || a2.closest(".halo-top-language")) &&
                          (n2?.classList.remove("show"), s?.classList.toggle("show")),
                      a2.matches(".dropdown-menu .dropdown-item") &&
                          (n2?.classList.remove("show"), s?.classList.remove("show")))
                    : t2.forEach((t3) => {
                          t3.querySelector(".top-language-currency")?.classList.remove("show"),
                              t3.querySelector(".dropdown-currency")?.classList.remove("show"),
                              t3.querySelector(".dropdown-language")?.classList.remove("show");
                      });
            });
        },
        headerSidebarSearch: function () {
            t(".header-top .header__search .search_details"),
                t("#search-form-mobile .halo-sidebar-wrapper .search_details");
            var e2 = t(".header-top .header__search"),
                a2 = t("#search-form-mobile .halo-sidebar-wrapper"),
                o2 = t(".search_details"),
                i2 = t(".header-top .header__search predictive-search"),
                n2 = t("#search-form-mobile .halo-sidebar-wrapper predictive-search");
            i2.length === 0 && (i2 = t(".header-top .header__search .search_details")),
                n2.length === 0 && (n2 = t("#search-form-mobile .halo-sidebar-wrapper .search_details")),
                window.innerWidth < 1025
                    ? (t(".header").hasClass("header-01") && i2.appendTo(a2),
                      t("#search-form-mobile .search_details").attr("open", "true"),
                      o.off("click.searchMobileOpen").on("click.searchMobileOpen", "[data-search-mobile]", (e3) => {
                          e3.preventDefault(),
                              "function" == typeof window.fiabilaOpenMobileSearch
                                  ? window.fiabilaOpenMobileSearch()
                                  : t("body").addClass("open_search_mobile");
                      }),
                      o.off("click.searchMobileClose").on("click.searchMobileClose", "[data-search-close-sidebar], .background-overlay", (e3) => {
                          e3.preventDefault(),
                              "function" == typeof window.fiabilaCloseMobileSearch
                                  ? window.fiabilaCloseMobileSearch()
                                  : t("body").removeClass("open_search_mobile");
                      }))
                    : (t(".header").hasClass("header-01") && n2.appendTo(e2),
                      o2.removeAttr("open"),
                      o.off("click.searchDesktopClose").on("click.searchDesktopClose", ".search-modal__close-button", (e3) => {
                          t(".search_details").removeAttr("open"), t("body").removeClass("open_search_menu");
                      }),
                      o.off("click.searchDesktopOpen").on("click.searchDesktopOpen", "[data-search-menu]", (e3) => {
                          e3.preventDefault(), t("body").addClass("open_search_menu");
                      }));
        },
        headerStickySearchForm: function () {
            var e2 = "[data-search-sticky-form]",
                a2 = "[data-search-menu-sticky-form] .icon-search",
                o2 = "[data-search-menu-sticky-form] .icon-search-custom";
            t(window).width() > 1025 &&
                (t(document)
                    .off("click.toggleSearch", e2)
                    .on("click.toggleSearch", e2, function (e3) {
                        e3.preventDefault(),
                            e3.stopPropagation(),
                            t("body").addClass("sticky-search-open"),
                            t(".search_details").attr("open", "true");
                    }),
                t(document)
                    .off("click.hideSearch")
                    .on("click.hideSearch", function (e3) {
                        var a3 = t(".search-modal__form"),
                            o3 = t(".quickSearchResultsWrap");
                        !t("body").hasClass("sticky-search-open") ||
                            a3.has(e3.target).length ||
                            o3.has(e3.target).length ||
                            t(e3.target).hasClass("search-modal__content") ||
                            t(e3.target).closest(".search-modal__content").length != 0 ||
                            (t("body").removeClass("sticky-search-open"),
                            t('[class*="section-header-"]').removeClass("sticky-search-menu-open"),
                            t(".search_details").removeAttr("open"));
                    }),
                t(document)
                    .off("click.toggleSearch", a2)
                    .on("click.toggleSearch", a2, function (e3) {
                        e3.preventDefault(),
                            e3.stopPropagation(),
                            t(e3.target).closest('[class*="section-header-"]').addClass("sticky-search-menu-open"),
                            t(e3.target).closest(".section-header-navigation").css("z-index", "101"),
                            t(".search_details").attr("open", "true");
                    }),
                t(document)
                    .off("click.toggleSearch", o2)
                    .on("click.toggleSearch", o2, function (e3) {
                        t(e3.target).closest('[class*="section-header-"]').addClass("sticky-search-menu-custom-open");
                    }),
                t(document)
                    .off("click.hideSearchSticky")
                    .on("click.hideSearchSticky", function (e3) {
                        var o3 = t(".header-navigation .search-modal__form"),
                            i2 = t(".header-navigation .quickSearchResultsWrap");
                        if (
                            t('[class*="section-header-"]').hasClass("sticky-search-menu-open") &&
                            !o3.has(e3.target).length &&
                            !i2.has(e3.target).length &&
                            !t(e3.target).hasClass("search-modal__content") &&
                            t(e3.target).closest(".search-modal__content").length == 0
                        ) {
                            const e4 = t(a2).closest(".section-header-navigation"),
                                o4 = e4.data("index");
                            t('[class*="section-header-"]').removeClass("sticky-search-menu-open"),
                                e4.css("z-index", o4),
                                t(".header-navigation .search_details").removeAttr("open"),
                                i2.hasClass("is-show") && i2.removeClass("is-show").addClass("hidden");
                        }
                        t(e3.target).closest(".search-modal__content").length === 0 &&
                            (t("body").removeClass("open_search_menu"),
                            t('[class*="section-header-"]').removeClass("sticky-search-menu-custom-open"));
                    }));
        },
        menuSidebarMobile: function () {
            if (n._menuSidebarBound) return;
            n._menuSidebarBound = !0;
            var e2 = t(".mobileMenu-toggle"),
                i2 = t(".halo-sidebar-close, .background-overlay");
            const n2 = () => {
                a.addClass("menu_open"),
                    t(".list-menu-loading").remove(),
                    window.mobile_menu == "default" &&
                        (t("#navigation-mobile .site-nav-mobile.nav .header__inline-menu").length ||
                            t(".header .header__inline-menu").appendTo("#navigation-mobile .site-nav-mobile.nav")),
                    t("#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text").length ||
                        t(".header-top--wrapper .header-top--right .free-shipping-text").appendTo(
                            "#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"
                        ),
                    t("#navigation-mobile .site-nav-mobile.nav-account .customer-service-text").length ||
                        t(".header-top--wrapper .header-top--right .customer-service-text").appendTo(
                            "#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"
                        ),
                    t("#navigation-mobile .site-nav-mobile.nav-account .header__location").length ||
                        t(".header-top--wrapper .header-top--right .header__location").appendTo(
                            "#navigation-mobile .site-nav-mobile.nav-account .wrapper-links"
                        ),
                    t("#navigation-mobile .top-language-currency").length ||
                        (t(".header").hasClass("header-03")
                            ? t(".header .header-bottom-right .top-language-currency").appendTo(
                                  "#navigation-mobile .site-nav-mobile.nav-currency-language"
                              )
                            : t(".header").hasClass("header-05")
                              ? t(".header .header-top--left .top-language-currency").appendTo(
                                    "#navigation-mobile .site-nav-mobile.nav-currency-language"
                                )
                              : t(".header .header-language_currency .top-language-currency").appendTo(
                                    "#navigation-mobile .site-nav-mobile.nav-currency-language"
                                ));
            };
            document.body.matches(".menu_open") && n2(),
                o.off("click.toggleCurrencyLanguage").on("click.toggleCurrencyLanguage", ".mobileMenu-toggle, [data-mobile-menu]", (t2) => {
                    t2.preventDefault(), n2();
                }),
                i2.off("click.toggleCloseCurrencyLanguage").on("click.toggleCloseCurrencyLanguage", () => {
                    a.removeClass("menu_open"),
                        t("#navigation-mobile")
                            .off("transitionend.toggleCloseMenu")
                            .on("transitionend.toggleCloseMenu", () => {
                                a.hasClass("menu_open") ||
                                    (t(".header .header__inline-menu").length ||
                                        (t(".header").hasClass("header-03") ||
                                        t(".header").hasClass("header-04") ||
                                        t(".header").hasClass("header-07") ||
                                        t(".header").hasClass("header-08")
                                            ? t(
                                                  "#navigation-mobile .site-nav-mobile.nav .header__inline-menu"
                                              ).appendTo(".header .header-bottom--wrapper .header-bottom-left")
                                            : t(
                                                  "#navigation-mobile .site-nav-mobile.nav .header__inline-menu"
                                              ).appendTo(".header .header-bottom--wrapper")),
                                    t(".header-top--wrapper .header-top--right .free-shipping-text").length ||
                                        t(".header-04").hasClass("style_2") ||
                                        t(
                                            "#navigation-mobile .site-nav-mobile.nav-account .free-shipping-text"
                                        ).insertBefore(".header-top--wrapper .header-top--right .header__group"),
                                    t(".header-top--wrapper .header-top--right .header__location").length ||
                                        t(
                                            "#navigation-mobile .site-nav-mobile.nav-account .header__location"
                                        ).insertBefore(".header-top--wrapper .header-top--right .header__group"),
                                    t(".header-top--wrapper .header-top--right .customer-service-text").length ||
                                        (t(".header").hasClass("header-03")
                                            ? t(
                                                  "#navigation-mobile .site-nav-mobile.nav-account .customer-service-text"
                                              ).insertBefore(
                                                  ".header-top--wrapper .header-top--right .header__group .header__icon--wishlist"
                                              )
                                            : t(
                                                  "#navigation-mobile .site-nav-mobile.nav-account .customer-service-text"
                                              ).insertBefore(
                                                  ".header-top--wrapper .header-top--right .top-language-currency"
                                              )),
                                    t(".header-language_currency .top-language-currency").length ||
                                        (t(".header").hasClass("header-03") || t(".header").hasClass("header-04")
                                            ? t("#navigation-mobile .site-nav-mobile .top-language-currency").appendTo(
                                                  ".header .header-bottom--wrapper .header-bottom-right .header-language_currency"
                                              )
                                            : t(".header").hasClass("header-05")
                                              ? t(
                                                    "#navigation-mobile .site-nav-mobile .top-language-currency"
                                                ).appendTo(
                                                    ".header .header-top--wrapper .header-top--left .header-language_currency"
                                                )
                                              : t(
                                                    "#navigation-mobile .site-nav-mobile .top-language-currency"
                                                ).insertBefore(".header .header-language_currency .header__search")));
                            });
                }),
                o.on("click", ".halo-sidebar-close", function (t2) {
                    t2.preventDefault(), t2.stopPropagation(), a.removeClass("menu_open");
                });
        },
        menuSidebarMobileToggle: function () {
            if (n._menuToggleBound) return;
            n._menuToggleBound = !0;
            a.on("click", ".site-nav-mobile .list-menu .menu_mobile_link", function (e2) {
                if (!e2.currentTarget.classList.contains("list-menu__item--end")) {
                    e2.preventDefault(), e2.stopPropagation();
                    var a2 = t(this),
                        o2 = a2.parent(),
                        i2 = a2.parent().find("ul.list-menu--disclosure-1");
                    o2.removeClass("is-hidden").addClass("is-open").removeClass("d-none"),
                        i2.off("transitionend.toggleMenuLink1").on("transitionend.toggleMenuLink1", () => {
                            !o2.hasClass("is-open") ||
                                o2.hasClass("is-hidden") ||
                                o2.hasClass("d-none") ||
                                o2.siblings().removeClass("is-open").addClass("is-hidden").removeClass("d-none");
                        });
                }
            }),
                a.on("click", ".site-nav-mobile .list-menu .menu_mobile_link_2", function (e2) {
                    e2.preventDefault(), e2.stopPropagation();
                    var a2 = t(this),
                        o2 = (a2 = t(this)).parent().parent(),
                        i2 = a2.parent().find("ul.list-menu--disclosure-2"),
                        n2 = a2.parent().parent().parent().parent().parent().parent();
                    o2.removeClass("is-hidden").addClass("is-open").removeClass("d-none"),
                        i2.off("transitionend.toggleMenuLink2").on("transitionend.toggleMenuLink2", () => {
                            !o2.hasClass("is-open") ||
                                o2.hasClass("is-hidden") ||
                                o2.hasClass("d-none") ||
                                (o2.addClass("d-none"),
                                o2.siblings().removeClass("is-open").addClass("is-hidden").removeClass("d-none"),
                                n2.animate({ scrollTop: 0 }, 0));
                        }),
                        (t(".menu-dropdown").hasClass("megamenu_style_5") ||
                            t(".menu-dropdown").hasClass("megamenu_style_4") ||
                            t(".menu-dropdown").hasClass("megamenu_style_3") ||
                            t(".menu-dropdown").hasClass("megamenu_style_2") ||
                            t(".menu-dropdown").hasClass("megamenu_style_1")) &&
                            a2.parents(".menu-dropdown").animate({ scrollTop: 0 }, 0),
                        a2.parents(".menu-dropdown").addClass("is-overflow");
                }),
                a.on("click", ".nav-title-mobile", function (e2) {
                    e2.preventDefault(), e2.stopPropagation();
                    var a2 = t(this),
                        o2 = a2.parent().parent().parent().parent(".is-open"),
                        i2 = a2.parent().parent().parent(".is-open"),
                        n2 = a2.parent().parent(".is-open");
                    o2.siblings().removeClass("is-hidden"),
                        o2.removeClass("is-open").removeClass("d-none"),
                        i2.siblings().removeClass("is-hidden"),
                        i2.removeClass("is-open").removeClass("d-none"),
                        n2.siblings().removeClass("is-hidden"),
                        n2.removeClass("is-open").removeClass("d-none"),
                        t(".menu-dropdown").removeClass("is-overflow");
                }),
                window.mobile_menu != "default" &&
                    o.on("click", "[data-mobile-menu-tab]", (t2) => {
                        t2.preventDefault(), t2.stopPropagation();
                        var e2 = t2.currentTarget.closest("li"),
                            a2 = t2.currentTarget.dataset.target;
                        e2.classList.contains("is-active") ||
                            document
                                .querySelector("[data-navigation-tab-mobile]")
                                .querySelectorAll("li")
                                .forEach((t3) => {
                                    t3 != e2
                                        ? t3.classList.remove("is-active")
                                        : (t3.classList.add("is-active"),
                                          document.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((t4) => {
                                              t4.getAttribute("id") == a2
                                                  ? (t4.classList.remove("is-hidden"), t4.classList.add("is-visible"))
                                                  : (t4.classList.remove("is-visible"), t4.classList.add("is-hidden"));
                                          }));
                                });
                    }),
                t(document).on("click", "[data-navigation-mobile] .no-megamenu .menu-lv-1__action", (e2) => {
                    const a2 = t(e2.currentTarget).attr("href").split("#")[1];
                    a2 != null &&
                        a2 != "" &&
                        t(`#${a2}`).length &&
                        (t("body").removeClass("menu_open"),
                        t("html, body").animate({ scrollTop: t(`#${a2}`).offset().top }, 700));
                });
        },
        setCookie(t2, e2, a2) {
            const o2 = new Date();
            o2.setTime(o2.getTime() + 24 * a2 * 60 * 60 * 1e3);
            const i2 = "expires=" + o2.toUTCString();
            document.cookie = t2 + "=" + e2 + ";" + i2 + ";path=/";
        },
        initMultiTab: function () {
            let e2,
                o2,
                s = !0;
            (e2 = !!document.body.matches(".shopify-design-mode")), (o2 = !!document.body.matches(".menu_open"));
            const r = () => {
                    s && ((s = !1), n.initMobileMenuDefault(d));
                },
                c = () => {
                    s && ((s = !1), n.initMultiTabMobile());
                };
            if (t("[data-menu-tab]").length > 0) {
                var l = t("[data-menu-tab] li.is-active").data("load-page"),
                    d = window.routes.root + `/search?type=product&q=${l}&view=ajax_mega_menu`;
                a.hasClass("template-index"),
                    i.width() < 1025 &&
                        (window.mobile_menu == "default"
                            ? window.addEventListener(
                                  "load",
                                  () => {
                                      e2 || o2
                                          ? r()
                                          : document.body.addEventListener(
                                                "click",
                                                () => {
                                                    r();
                                                },
                                                !1
                                            );
                                  },
                                  !1
                              )
                            : window.addEventListener(
                                  "load",
                                  () => {
                                      e2 || o2
                                          ? c()
                                          : document.body.addEventListener(
                                                "click",
                                                () => {
                                                    c();
                                                },
                                                !1
                                            );
                                  },
                                  !1
                              ));
            } else
                (d = window.routes.root + "/search?view=ajax_mega_menu"),
                    i.width() < 1025 &&
                        (window.mobile_menu == "default"
                            ? window.addEventListener(
                                  "load",
                                  () => {
                                      r();
                                  },
                                  !1
                              )
                            : window.addEventListener(
                                  "load",
                                  () => {
                                      e2 || o2
                                          ? c()
                                          : document.body.addEventListener(
                                                "click",
                                                () => {
                                                    c();
                                                },
                                                !1
                                            );
                                  },
                                  !1
                              ));
        },
        initMobileMenuDefault: function (e2) {
            const a2 = t("[data-navigation-mobile]"),
                o2 = t("#HeaderNavigation [data-navigation]"),
                i2 = o2.attr("style") != null ? o2.attr("style") : o2.closest("#HeaderNavigation").attr("style");
            if (a2.find(".header__inline-menu, .header__menu-vertical").length) {
                t(".list-menu-loading").remove();
                return;
            }
            t(".list-menu-loading").remove(),
                a2.append(
                    `<nav class="header__inline-menu" data-navigation role="navigation" style="${i2 ?? ""}">${o2.html() != null ? o2.html() : ""}</nav>`
                );
            const s = t(".top-language-currency"),
                r = t("#navigation-mobile .nav-currency-language");
            r.text().trim() == "" && s.length > 0 && r.append(`<div class="top-language-currency">${s.html()}</div>`);
            const c = document.querySelector(".header-nav-vertical-menu .vertical-menu .header__menu-vertical");
            if (c) {
                document.querySelector(".halo-sidebar.halo-sidebar_menu").classList.add("has-menu-vertical");
                const t2 = document.querySelector(
                        ".header-nav-vertical-menu .vertical-menu .categories-title__button .title"
                    ).innerHTML,
                    e3 = document.querySelector(".site-nav-mobile.nav"),
                    a3 = e3.querySelector(".menu-heading-mobile"),
                    o3 = document.createElement("span");
                o3.classList.add("title"),
                    (o3.innerHTML = t2),
                    a3.appendChild(o3),
                    e3.appendChild(c),
                    document
                        .querySelector(".site-nav-mobile.nav .header__menu-vertical")
                        .classList.add("header__inline-menu");
                const i3 = document.querySelectorAll(".site-nav-mobile.nav .menu-heading-mobile .title"),
                    n2 = document.querySelectorAll(".site-nav-mobile.nav .header__inline-menu");
                i3[0].classList.add("is-active"),
                    n2[0].classList.add("is-active"),
                    i3.forEach((t3, e4) => {
                        t3.addEventListener("click", () => {
                            i3.forEach((t4) => t4.classList.remove("is-active")),
                                t3.classList.add("is-active"),
                                n2.forEach((t4) => t4.classList.remove("is-active")),
                                n2[e4].classList.add("is-active");
                        });
                    });
            }
            if (window.innerWidth < 1025) {
                var l = t(".menu-lv-item.has-megamenu");
                l.length > 0 &&
                    l.on("click", function (e3) {
                        var a3,
                            o3 = t(this).find(".menu-dropdown__block--content .products-carousel"),
                            i3 = o3.data("product"),
                            s2 = o3.data("collection");
                        o3.hasClass("megamenu_1")
                            ? i3 && (a3 = window.routes.root + "/products/" + i3)
                            : o3.hasClass("megamenu_5") && s2 && (a3 = window.routes.root + "/collections/" + s2),
                            a3 && n.renderMegaMenuProductBlock(o3, a3);
                    });
            }
        },
        initMultiTabMobile: function () {
            if (i.width() < 1025 && window.mobile_menu == "custom") {
                var e2 = !0,
                    a2 = t('[data-section-type="menu"]'),
                    o2 = t("[data-navigation-mobile]"),
                    s = t("[data-navigation-tab-mobile]");
                const i2 = () => {
                    if (e2) {
                        e2 = !1;
                        const i3 = document.createElement("div"),
                            n2 = document.createElement("ul");
                        Object.assign(n2, { className: "menu-tab list-unstyled" }),
                            n2.setAttribute("role", "menu"),
                            a2.each((t2, e3) => {
                                var a3 = e3.querySelector("template").content.firstElementChild.cloneNode(!0);
                                t2 == 0 ? a3.classList.add("is-visible") : a3.classList.add("is-hidden"),
                                    i3.appendChild(a3);
                            }),
                            i3.querySelectorAll('[id^="MenuMobileListSection-"]').forEach((t2, e3) => {
                                var a3 = t2.dataset.heading,
                                    o3 = t2.getAttribute("id"),
                                    i4 = document.createElement("li");
                                Object.assign(i4, { className: "item" }),
                                    i4.setAttribute("role", "menuitem"),
                                    e3 == 0 && i4.classList.add("is-active"),
                                    (i4.innerHTML = `<a class="link" href="#" data-mobile-menu-tab data-target="${o3}">${a3}</a>`),
                                    n2.appendChild(i4);
                            }),
                            t(".list-menu-loading").remove(),
                            s.html(n2),
                            o2.html(i3.innerHTML);
                    }
                };
                if (t(".header-nav-plain .header-language_currency").length > 0) {
                    const e3 = t(".top-language-currency"),
                        a3 = t("#navigation-mobile .nav-currency-language");
                    a3.text().trim() == "" &&
                        e3.length > 0 &&
                        a3.append(`<div class="top-language-currency">${e3.html()}</div>`);
                }
                document.body.matches(".menu_open") && i2(),
                    document.body.addEventListener(
                        "click",
                        () => {
                            i2();
                        },
                        !1
                    );
            }
            if (window.innerWidth < 1025) {
                var r = t(".menu-lv-item.has-megamenu");
                r.length > 0 &&
                    r.on("click", function (e3) {
                        var a3,
                            o3 = t(this).find(".menu-dropdown__block--content .products-carousel"),
                            i2 = o3.data("product"),
                            s2 = o3.data("collection");
                        o3.hasClass("megamenu_1")
                            ? i2 && (a3 = window.routes.root + "/products/" + i2)
                            : o3.hasClass("megamenu_5") && s2 && (a3 = window.routes.root + "/collections/" + s2),
                            a3 && n.renderMegaMenuProductBlock(o3, a3);
                    });
            }
        },
        initMenu: function (e2) {
            t(".header").hasClass("header-04") ||
                fetch(e2)
                    .then((t2) => t2.text())
                    .then((t2) => {
                        const e3 = document.createElement("div");
                        e3.innerHTML = t2;
                        const a2 = e3.querySelector("#HeaderNavigation");
                        a2 &&
                            a2.innerHTML.trim().length &&
                            (document.querySelector("#HeaderNavigation").innerHTML = a2.innerHTML);
                    })
                    .catch((t2) => {
                        console.error(t2);
                    });
        },
        clickedActiveProductTabs: function () {
            (this.productBlock = document.querySelectorAll("[data-product-tab-block]")),
                (this.observer = new IntersectionObserver(
                    (e2, a2) => {
                        e2.forEach((e3) => {
                            if (e3.isIntersecting) {
                                const l = t(e3.target);
                                if (l.hasClass("ajax-loaded")) return;
                                var a3 = l.find(".list-product-tabs"),
                                    o2 = a3.find("[data-product-tabTop]"),
                                    i2 = l.find("[data-product-TabContent]"),
                                    s = l.data("limit"),
                                    r = a3.find(".tab-links.active"),
                                    c = l.find(".product-tabs-content .tab-content.active");
                                l.hasClass("ajax-loaded") ||
                                    n.doAjaxProductTabs(
                                        r.data("href"),
                                        c.find(".loading"),
                                        c.find(".products-load"),
                                        l.attr("sectionid"),
                                        s,
                                        l
                                    ),
                                    o2.off("click").on("click", function (e4) {
                                        if ((e4.preventDefault(), e4.stopPropagation(), !t(this).hasClass("active"))) {
                                            const e5 = t(this),
                                                a4 = t(e5.data("target"));
                                            o2.removeClass("active"),
                                                i2.removeClass("active"),
                                                a4.hasClass("loaded") ||
                                                    n.doAjaxProductTabs(
                                                        e5.data("href"),
                                                        a4.find(".loading"),
                                                        a4.find(".products-load"),
                                                        l.attr("sectionid"),
                                                        s
                                                    ),
                                                e5.addClass("active"),
                                                a4.addClass("active"),
                                                a4.find(".slick-slider").slick("refresh");
                                        }
                                    });
                            }
                        });
                    },
                    { threshold: 0.1 }
                )),
                this.productBlock.forEach((t2) => {
                    this.observer.observe(t2);
                });
        },
        doAjaxProductTabs: function (e2, a2, o2, i2, s, r) {
            t.ajax({
                type: "get",
                url: e2,
                data: { constraint: `sectionId=${e2}+limit=${s}` },
                beforeSend: function () {
                    r?.addClass("ajax-loaded");
                },
                success: function (a3) {
                    if ((o2.parent().addClass("loaded"), e2 != "?view=ajax_product_block")) {
                        if (t(a3).text().trim() === "") c(o2);
                        else {
                            const e3 = n.handleResponse(t(a3), 0, s);
                            o2.html(e3),
                                window.wishlist.show && n.setLocalStorageProductForWishlist(),
                                n.checkNeedToConvertCurrency() &&
                                    Currency.convertAll(
                                        window.shop_currency,
                                        t("#currencies .active").attr("data-currency"),
                                        "span.money",
                                        "money_format"
                                    );
                        }
                        n.swapHoverVideoProductCard();
                    }
                },
                complete: function () {
                    o2.hasClass("products-carousel") && n.productBlockSilder(o2.parent()),
                        t("body").hasClass("cursor-fixed__show") &&
                            (window.sharedFunctionsAnimation.onEnterButton(),
                            window.sharedFunctionsAnimation.onLeaveButton());
                },
                error: function (t2, e3) {
                    c(o2);
                },
            });
            const c = (t2) => {
                t2.html('<p class="loading center">Sorry, there are no products in this collection</p>');
            };
        },
        lookbookCarousel: function () {
            var e2 = t(".lookbook-carousel"),
                a2 = e2.data("item-to-show"),
                o2 = e2.data("item-dots"),
                i2 = e2.data("item-dots-mb"),
                n2 = e2.data("item-arrows"),
                s = e2.data("item-arrows-mb");
            if (
                (e2.length > 0 &&
                    e2.not(".slick-initialized") &&
                    e2.slick({
                        mobileFirst: !0,
                        adaptiveHeight: !0,
                        vertical: !1,
                        infinite: !0,
                        slidesToShow: a2,
                        slidesToScroll: a2,
                        arrows: s,
                        dots: i2,
                        autoplay: !1,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [{ breakpoint: 1024, settings: { arrows: n2, dots: o2 } }],
                    }),
                e2.hasClass("enable_counter_number"))
            ) {
                var r = e2.find(".slick-next");
                e2.closest(".special-banner__item--lookbook_banner").find(".products-counter-number").appendTo(r),
                    e2.on("afterChange", (t2) => {
                        var a3 = e2.find(".slick-current").data("slick-index");
                        e2.find("#count-image").text(a3 + 1);
                    });
            }
            t("body").hasClass("cursor-fixed__show") &&
                (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
        },
        productBlockSilder: function (e2) {
            var a2 = e2.find(".products-carousel"),
                o2 = a2.data("item-to-show"),
                i2 = a2.data("item-dots"),
                n2 = a2.data("item-dots-mb"),
                s = a2.data("item-arrows"),
                r = a2.data("item-arrows-mb"),
                c = a2.data("infinite"),
                l = a2.find(".swatch .swatch-label"),
                d = document.body.classList.contains("product-card-layout-06");
            if (a2.length > 0) {
                if (a2.hasClass("slick-initialized")) return;
                if (a2.not(".slick-initialized")) {
                    if (
                        (d &&
                            a2.on("init", () => {
                                const t2 = a2.find(".product .card-action").eq(0).height();
                                a2.find(".slick-list").css("padding-bottom", t2 + "px"),
                                    a2.attr("data-slider-padding-bottom", t2);
                            }),
                        a2.hasClass("enable_progress_bar"))
                    ) {
                        var u = e2.find(".scrollbar-thumb");
                        a2.on("init", (t2, e3) => {
                            var a3 = (e3.currentSlide / (e3.slideCount - o2)) * 100 + "%";
                            u.css("--percent", a3);
                        });
                    }
                    if (
                        (a2.slick({
                            mobileFirst: !0,
                            adaptiveHeight: !0,
                            vertical: !1,
                            infinite: c,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: r,
                            dots: n2,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [
                                {
                                    breakpoint: 1599,
                                    settings: {
                                        arrows: s,
                                        dots: i2,
                                        get slidesToShow() {
                                            return (this.slidesToShow = o2 != null && o2 !== "" ? o2 : 1);
                                        },
                                        get slidesToScroll() {
                                            return (this.slidesToScroll =
                                                o2 != null &&
                                                o2 !== "" &&
                                                o2 !== 2.5 &&
                                                o2 !== 3.5 &&
                                                o2 !== 4.5 &&
                                                o2 !== 5.5
                                                    ? o2
                                                    : 1);
                                        },
                                        get initialSlide() {
                                            return (this.initialSlide = o2 == 5.5 ? 0.5 : 0);
                                        },
                                    },
                                },
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        arrows: s,
                                        dots: i2,
                                        get slidesToShow() {
                                            return o2 != null && o2 !== ""
                                                ? o2 == 5 || o2 == 6
                                                    ? (this.slidesToShow = o2 - 1)
                                                    : a2.parents(".collection-column-2").length
                                                      ? (this.slidesToShow = 2)
                                                      : (this.slidesToShow = o2)
                                                : (this.slidesToShow = 1);
                                        },
                                        get slidesToScroll() {
                                            return o2 != null &&
                                                o2 !== "" &&
                                                o2 !== 2.5 &&
                                                o2 !== 3.5 &&
                                                o2 !== 4.5 &&
                                                o2 !== 5.5
                                                ? o2 == 5 || o2 == 6
                                                    ? (this.slidesToScroll = o2 - 1)
                                                    : a2.parents(".collection-column-2").length
                                                      ? (this.slidesToScroll = 2)
                                                      : (this.slidesToScroll = o2)
                                                : (this.slidesToScroll = 1);
                                        },
                                        get initialSlide() {
                                            return (this.initialSlide = o2 == 5.5 ? 0.5 : 0);
                                        },
                                    },
                                },
                                {
                                    breakpoint: 991,
                                    settings: {
                                        arrows: r,
                                        dots: n2,
                                        get slidesToShow() {
                                            return a2.hasClass("has__banner_tab") ||
                                                a2.parents(".product-block-has__banner").length
                                                ? a2.parents(".product-block-has__banner").length &&
                                                  a2.parents(".product-block-has__banner").data("width-banner") > 40
                                                    ? (this.slidesToShow = 2)
                                                    : (this.slidesToShow = o2 == 2.5 ? 2 : 3)
                                                : a2.parents(".collection-column-2").length
                                                  ? (this.slidesToShow = 2)
                                                  : (this.slidesToShow = o2 == 1 ? o2 : o2 == 3.5 || o2 == 4.5 ? 3 : 4);
                                        },
                                        get slidesToScroll() {
                                            return a2.hasClass("has__banner_tab") ||
                                                a2.parents(".product-block-has__banner").length
                                                ? a2.parents(".product-block-has__banner").length &&
                                                  a2.parents(".product-block-has__banner").data("width-banner") > 40
                                                    ? (this.slidesToScroll = 2)
                                                    : (this.slidesToScroll = o2 == 2.5 ? 2 : 3)
                                                : a2.parents(".collection-column-2").length
                                                  ? (this.slidesToScroll = 2)
                                                  : (this.slidesToScroll =
                                                        o2 == 1 ? o2 : o2 == 3.5 || o2 == 4.5 ? 3 : 4);
                                        },
                                        get initialSlide() {
                                            return (this.initialSlide = o2 == 5.5 ? 0.5 : 0);
                                        },
                                    },
                                },
                                {
                                    breakpoint: 767,
                                    arrows: r,
                                    dots: n2,
                                    settings: {
                                        get slidesToShow() {
                                            return a2.hasClass("has__banner_tab") ||
                                                a2.parents(".product-block-has__banner").length
                                                ? (this.slidesToShow = 2)
                                                : (this.slidesToShow = o2 == 1 ? o2 : o2 == 3.5 || o2 == 4.5 ? 2 : 3);
                                        },
                                        get slidesToScroll() {
                                            return a2.hasClass("has__banner_tab") ||
                                                a2.parents(".product-block-has__banner").length
                                                ? (this.slidesToScroll = 2)
                                                : (this.slidesToScroll = o2 == 1 ? o2 : o2 == 3.5 || o2 == 4.5 ? 2 : 3);
                                        },
                                        get initialSlide() {
                                            return (this.initialSlide = o2 == 5.5 ? 0.5 : 0);
                                        },
                                    },
                                },
                                {
                                    breakpoint: 320,
                                    arrows: r,
                                    dots: n2,
                                    settings: {
                                        get slidesToShow() {
                                            return o2 == 1
                                                ? a2.hasClass("special-banner__products--slider") ||
                                                  a2.hasClass("special-banner__products--grid")
                                                    ? (this.slidesToShow = 2)
                                                    : (this.slidesToShow = o2)
                                                : (this.slidesToShow = o2 == 2.5 || o2 == 3.5 || o2 == 4.5 ? 1 : 2);
                                        },
                                        get slidesToScroll() {
                                            return (this.slidesToScroll =
                                                o2 == 1 ? o2 : o2 == 2.5 || o2 == 3.5 || o2 == 4.5 ? 1 : 2);
                                        },
                                    },
                                },
                            ],
                        }),
                        a2.hasClass("enable_progress_bar") &&
                            a2.on("afterChange", (t2, e3, a3) => {
                                var i3 = (a3 / (e3.slideCount - o2)) * 100 + "%";
                                u.css("--percent", i3);
                            }),
                        a2.hasClass("enable_counter_number"))
                    ) {
                        var p = a2.find(".slick-next");
                        a2
                            .closest(".halo-block, .special-banner__product, .cust-prod-widget__product")
                            .find(".products-counter-number")
                            .appendTo(p),
                            a2.on("afterChange", (t2) => {
                                var i3 = a2.find(".slick-current").data("slick-index") + o2,
                                    n3 = e2.data("limit");
                                i3 > n3 && (i3 = n3), a2.find("#count-image").text(i3);
                            });
                    }
                    t("body").hasClass("cursor-fixed__show") &&
                        (window.sharedFunctionsAnimation.onEnterButton(),
                        window.sharedFunctionsAnimation.onLeaveButton());
                }
            }
            l.length &&
                a2.on("click", ".swatch .swatch-label", function () {
                    setTimeout(() => {
                        var e3 = (function () {
                            var e4 = 0;
                            return (
                                a2.find(".slick-slide").each(function () {
                                    var a3 = t(this).outerHeight();
                                    a3 > e4 && (e4 = a3);
                                }),
                                e4
                            );
                        })();
                        a2.find(".slick-list").css({ height: e3 + "px", transition: "500ms ease" });
                    }, 50);
                });
        },
        productBlockInfiniteScroll: function () {
            t("[data-product-block], [data-product-tab-block]").each((e2, a2) => {
                var o2 = t(a2),
                    i2 = o2.find("[data-product-infinite]");
                i2.length > 0 &&
                    i2.find(".button").on("click", (e3) => {
                        var a3 = t(e3.target);
                        if (a3.hasClass("view-all")) window.location = a3.data("href");
                        else {
                            e3.preventDefault(), e3.stopPropagation(), a3.addClass("is-loading");
                            var i3 = a3.attr("data-collection"),
                                s = a3.attr("data-limit"),
                                r = a3.attr("data-swipe"),
                                c = a3.attr("data-total"),
                                l = a3.attr("data-image-ratio"),
                                d = a3.attr("sectionId"),
                                u = parseInt(a3.attr("data-page"));
                            n.doProductBlockInfiniteScroll(i3, c, s, r, l, d, u, a3, o2);
                        }
                    });
            });
        },
        doProductBlockInfiniteScroll: function (e2, a2, o2, i2, s, r, c, l, d) {
            t.ajax({
                type: "get",
                url: window.routes.root + "/collections/" + e2,
                cache: !1,
                data: {
                    view: "ajax_product_block",
                    constraint: "limit=" + o2 + "+page=" + c + "+sectionId=" + r + "+imageRatio=" + s + "+swipe=" + i2,
                },
                beforeSend: function () {},
                success: function (o3) {
                    const i3 = l.closest(".tab-content").length
                        ? l.closest(".tab-content").find(".products-grid")
                        : l.closest(".halo-block-content").find(".products-grid");
                    let s2 = i3.find(".product").length;
                    const r2 = n.handleResponse(t(o3), s2, i3.data("products-to-show"));
                    if ((i3.append(r2), s2 + r2.length < t(o3).length)) {
                        var d2 = window.button_load_more.default;
                        l.removeClass("is-loading"), l.attr("data-page", c + 1), l.find("span").text(d2);
                    } else
                        Number(a2) > t(o3).length && t(o3).length <= s2 + r2.length
                            ? ((d2 = window.button_load_more.view_all),
                              l.find("span").text(d2),
                              l.removeClass("is-loading"),
                              l.attr("data-href", window.routes.root + "/collections/" + e2).addClass("view-all"))
                            : ((d2 = window.button_load_more.no_more),
                              l.find("span").text(d2),
                              l.removeClass("is-loading"),
                              l.attr("disabled", "disabled"));
                },
                complete: function () {
                    n.checkNeedToConvertCurrency() &&
                        Currency.convertAll(
                            window.shop_currency,
                            t("#currencies .active").attr("data-currency"),
                            "span.money",
                            "money_format"
                        );
                },
            });
        },
        doBeforeMegaMenuProductBlock: function () {
            var e2 = t(".menu-lv-item.has-megamenu");
            e2.length > 0 &&
                window.innerWidth > 1025 &&
                e2.mouseenter(function () {
                    var e3,
                        a2 = t(this).find(".menu-dropdown__block--content .products-carousel"),
                        o2 = a2.data("product"),
                        i2 = a2.data("collection");
                    a2.hasClass("megamenu_1")
                        ? o2 && (e3 = window.routes.root + "/products/" + o2)
                        : a2.hasClass("megamenu_5") && i2 && (e3 = window.routes.root + "/collections/" + i2),
                        e3 && n.renderMegaMenuProductBlock(a2, e3);
                });
        },
        renderMegaMenuProductBlock: function (e2, a2) {
            var o2 = e2;
            if (!o2.hasClass("ajax-loaded")) {
                var i2 = o2.data("row");
                t.ajax({
                    type: "GET",
                    url: a2,
                    cache: !1,
                    data: {
                        view: "ajax_product_card_mega_menu",
                        constraint: `limit=${i2}+sectionId=list-result-block`,
                    },
                    beforeSend: () => {
                        o2.addClass("ajax-loaded");
                    },
                    success: (e3) => {
                        if (o2.hasClass("megamenu_1")) o2.html(e3);
                        else if (o2.hasClass("megamenu_5")) {
                            const a3 = n.handleResponse(t(e3), 0, i2);
                            o2.html(a3), n.productMenuSlider(o2);
                        }
                        n.checkNeedToConvertCurrency() &&
                            Currency.convertAll(
                                window.shop_currency,
                                t("#currencies .active").attr("data-currency"),
                                "span.money",
                                "money_format"
                            );
                    },
                    complete: () => {
                        n.checkNeedToConvertCurrency() &&
                            Currency.convertAll(
                                window.shop_currency,
                                t("#currencies .active").attr("data-currency"),
                                "span.money",
                                "money_format"
                            );
                    },
                });
            }
        },
        productMenuSlider: function (t2) {
            var e2 = t2,
                a2 = e2.data("row");
            e2.length > 0 &&
                e2.not(".slick-initialized") &&
                e2.slick({
                    mobileFirst: !0,
                    adaptiveHeight: !0,
                    vertical: !1,
                    infinite: !1,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: !1,
                    dots: !0,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                        { breakpoint: 1500, settings: { slidesToShow: a2, slidesToScroll: 1, dots: !1 } },
                    ],
                });
        },
        buildRecommendationBlock: function () {
            if (document.querySelector("[data-recommendations-block]") != null) {
                var e2 = document.querySelector("[data-recommendations-block]"),
                    o2 = e2.dataset.layout;
                (swipe = e2.dataset.swipe),
                    new IntersectionObserver(
                        ((i2, s) => {
                            const r = e2.querySelector(".wrapper-container");
                            if (
                                !i2[0].isIntersecting ||
                                e2.dataset.recommendationsLoaded === "true" ||
                                e2.dataset.recommendationsLoading === "true"
                            )
                                return;
                            if (
                                e2.innerHTML.trim() != "" &&
                                !r.classList.contains("product-recommendations-loading")
                            ) {
                                e2.dataset.recommendationsLoaded = "true",
                                    o2 == "slider" && n.productBlockSilder(t(e2)),
                                    s.disconnect();
                                return;
                            }
                            e2.dataset.recommendationsLoading = "true",
                                r.classList.add("has-product"),
                                fetch(e2.dataset.url)
                                    .then((t2) => t2.text())
                                    .then((i3) => {
                                        const s2 = document.createElement("div");
                                        s2.innerHTML = i3;
                                        const r2 = s2.querySelector("[data-recommendations-block]");
                                        if (r2 && r2.innerHTML.trim().length) {
                                            if (
                                                ((e2.innerHTML = r2.innerHTML),
                                                !t(e2).find(".product-item").eq(0).data("json-product"))
                                            )
                                                return t(e2).remove();
                                            o2 == "slider" && n.productBlockSilder(t(e2)),
                                                t(e2)
                                                    .find(".product-item")
                                                    .each(async (e3, a2) => {
                                                        var o3 = t(a2),
                                                            i5 = o3.data("product-id"),
                                                            s3 = o3.data("json-product").handle;
                                                        await t.ajax({
                                                            type: "get",
                                                            url:
                                                                window.routes.root +
                                                                "/products/" +
                                                                s3 +
                                                                "?view=ajax_variant_quantity",
                                                            beforeSend: function () {},
                                                            success: function (t2) {
                                                                const e4 = new DOMParser().parseFromString(
                                                                    t2,
                                                                    "text/html"
                                                                );
                                                                if (
                                                                    e4.querySelector(
                                                                        `[data-quantity-product-id="${i5}"]`
                                                                    )
                                                                ) {
                                                                    const t3 = JSON.parse(
                                                                        e4.querySelector(
                                                                            `[data-quantity-product-id="${i5}"]`
                                                                        ).innerHTML
                                                                    );
                                                                    window[`quick_view_inven_array_${i5}`] = t3;
                                                                }
                                                            },
                                                            error: function (e4, a3) {
                                                                n.showWarning(t.parseJSON(e4.responseText).description);
                                                            },
                                                            complete: function () {},
                                                        });
                                                    });
                                            const i4 = e2.querySelectorAll(".media--loading-effect img");
                                            if ((this.observeImageLazyloaded(i4), window.compare.show)) {
                                                var c = t("[data-compare-link]");
                                                n.setLocalStorageProductForCompare(c);
                                            }
                                            window.wishlist.show && n.setLocalStorageProductForWishlist(),
                                                t("body").hasClass("cursor-fixed__show") &&
                                                    (window.sharedFunctionsAnimation.onEnterButton(),
                                                    window.sharedFunctionsAnimation.onLeaveButton()),
                                                a.hasClass("product-card-layout-08") && n.productCountdownCard(),
                                                this.calculateTranslateYHeight();
                                            e2.dataset.recommendationsLoaded = "true",
                                                r.classList.remove("product-recommendations-loading"),
                                                s.disconnect();
                                        }
                                    })
                                    .catch((t2) => {
                                        console.error(t2);
                                    })
                                    .finally(() => {
                                        e2.dataset.recommendationsLoading = "false";
                                    });
                        }).bind(e2),
                        { threshold: 0.25 }
                    ).observe(e2);
            }
        },
        initVideoPopup: function () {
            t(".video-open-popup").length &&
                (t(".video-open-popup .video-button")
                    .off("click")
                    .on("click", function () {
                        let e2 = t(this).attr("data-type"),
                            o2 = t(this).attr("data-src");
                        const i2 = `<div class="fluid-width-video-wrapper" style="padding-top: ${t(this).attr("aspect_ratio")}">
                                    ${
                                        e2 == "youtube"
                                            ? `<iframe
                                            id="player"
                                            type="text/html"
                                            width="100%"
                                            frameborder="0"
                                            webkitAllowFullScreen
                                            mozallowfullscreen
                                            allowFullScreen
                                            src="https://www.youtube.com/embed/${o2}?autoplay=1&mute=1">
                                        </iframe>`
                                            : `<iframe 
                                            src="https://player.vimeo.com/video/${o2}?autoplay=1&mute=1" 
                                            class="js-vimeo" 
                                            allow="autoplay; 
                                            encrypted-media" 
                                            webkitallowfullscreen 
                                            mozallowfullscreen 
                                            allowfullscreen">
                                        </iframe>`
                                    }
                                </div>`;
                        t("[data-popup-video]").find(".halo-popup-content").html(i2), a.addClass("video-show");
                    }),
                t("[data-popup-video], [data-popup-video] .halo-popup-close, .background-overlay").on(
                    "click",
                    function (e2) {
                        let o2 = t("[data-popup-video] .halo-popup-content");
                        o2.is(e2.target) ||
                            o2.has(e2.target).length ||
                            (a.removeClass("video-show"), t("[data-popup-video] iframe").remove());
                    }
                ));
        },
        swapHoverVideoProductCard: function () {
            window.innerWidth > 1200 &&
                (t(".product-item .card:not(.has-first-video)").mouseenter(function () {
                    var e2 = t(this).find("video"),
                        a2 = t(this).find("video").get(0);
                    e2.length > 0 && a2.play();
                }),
                t(".product-item .card:not(.has-first-video)").mouseleave(function () {
                    var e2 = t(this).find("video"),
                        a2 = t(this).find("video").get(0);
                    e2.length > 0 && a2.pause();
                })),
                (t.fn.isInViewport = function () {
                    let e2 = t(this).offset().top,
                        a2 = e2 + t(this).outerHeight(),
                        o2 = t(window).scrollTop(),
                        i2 = o2 + t(window).height();
                    return a2 > o2 && e2 < i2;
                }),
                t(".product-item .card.has-first-video").each(function () {
                    let e2 = t(this).find("video"),
                        a2 = t(this).find("img:first-child"),
                        o2 = t(this).find("video").get(0);
                    const i2 = () => {
                            a2.length > 0 && a2.css("opacity", "0"),
                                e2.length > 0 && (e2.css("opacity", "1"), o2.play());
                        },
                        n2 = () => {
                            e2.length > 0 && o2.pause();
                        };
                    t(this).isInViewport() ? i2() : n2(),
                        window.addEventListener("scroll", () => {
                            t(this).isInViewport() ? i2() : n2();
                        });
                });
        },
        initGlobalCheckbox: function () {
            o.on("change", ".global-checkbox--input", (e2) => {
                var a2 = e2.target.getAttribute("data-target");
                e2.target.checked ? t(a2).attr("disabled", !1) : t(a2).attr("disabled", !0);
            }),
                o.on("click", "[data-term-condition]", (t2) => {
                    t2.preventDefault(), t2.stopPropagation(), a.addClass("term-condition-show");
                }),
                o.on("click", "[data-close-term-condition-popup]", (t2) => {
                    t2.preventDefault(), t2.stopPropagation(), a.removeClass("term-condition-show");
                }),
                o.on("click", (e2) => {
                    setTimeout(() => {
                        a.hasClass("cart-sidebar-show") &&
                            t(e2.target).closest("[data-term-condition-popup]").length === 0 &&
                            a.removeClass("term-condition-show"),
                            a.hasClass("term-condition-show") &&
                                t(e2.target).closest("[data-term-condition-popup]").length === 0 &&
                                a.removeClass("term-condition-show");
                    }, 10);
                });
        },
        initColorSwatch: function () {
            o.ready(function () {
                t(".card .swatch-label.is-active").trigger("click");
            }),
                o.on("click", ".card .swatch-label", (e2) => {
                    var o2 = t(e2.currentTarget),
                        i2 = o2.attr("title").replace(/^\s+|\s+$/g, ""),
                        s = o2.closest(".product-item"),
                        r = s.data("json-product"),
                        c = s.find(".card-title"),
                        l = s.find("[data-btn-addtocart]"),
                        d = s.find(".card-product [data-btn-addtocart]"),
                        u = o2.data("variant-id"),
                        p = s.find("a").attr("href"),
                        h = o2.data("with-one-option"),
                        m = o2.data("variant-img"),
                        w = [];
                    const f =
                        '<svg class="icon icon-cart" viewBox="0 0 286.74 356.73">                  <g data-name="Layer 1">                    <path d="m286.33,277.03l-.17-3.91c-.81-18.73-1.83-37.7-2.83-56.05l-.79-14.51c-.43-8.13-.9-16.26-1.37-24.4l-.24-4.18c-.84-14.79-1.71-30.08-2.35-45.1-.93-21.43-14.62-35.84-34.07-35.86h-20.65c-.42-20.33-5.78-38.81-15.94-54.94C189.14,8.27,157.22-5.8,126.6,2.23c-27.48,7.21-46.98,26.7-57.96,57.94-3.5,9.98-5.33,20.76-5.56,32.86h-9.52c-4.59,0-9.05-.01-12.39,0-16.64.12-30.01,12.35-31.79,29.06-1.42,13.39-2.1,27.29-2.7,39.55-.24,4.97-.5,9.95-.77,14.91-1.22,21.28-2.24,39.94-3.13,57.07-.29,5.45-.6,10.9-.92,16.36l-.02.3c-.82,13.9-1.67,28.28-1.82,42.5-.18,16.51,5.81,32.31,16.86,44.5,11.15,12.29,26.39,19.35,41.81,19.37,22.45.05,49.37.08,82.32.08s60.43-.02,87.24-.08c28.28-.04,53.63-23.49,57.72-53.39,1.19-8.74.78-17.61.37-26.23ZM63.13,130.98c.09,7.97,4.99,13.59,11.92,13.67h.12c6.97,0,11.9-5.57,11.99-13.53.04-3.2.04-6.33.04-9.63v-2.53s112.59,0,112.59,0v10.76c0,4.95,1.26,8.81,3.76,11.51,2.07,2.2,4.95,3.4,8.33,3.45h.11c5.72-.08,11.83-4.11,11.85-15.16v-10.77c.83-.01,1.68-.03,2.55-.04h.62c7.1-.1,15.15-.2,20.48.19,3.7.28,6.59,4.2,6.87,9.32.68,12.51,1.41,26.28,2.28,43.33l.1,2.01c.67,12.86,1.34,25.72,2.04,38.59.31,5.58.6,11.17.87,16.76.91,17.56,1.84,35.72,3.19,53.79,1.49,20.32-4.18,34.05-17.84,43.2-5.16,3.45-10.88,5.2-17.01,5.2h-15.06c-45.58.05-104.28.1-154.01-.02-9.16-.02-18.22-4.27-24.85-11.68-6.63-7.39-10.18-16.92-10-26.83.28-14.29,1.14-29.09,1.9-42.15.31-5.37.62-10.74.91-16.1.54-10.41,1.12-20.81,1.69-31.22l.07-1.28c.21-3.92.43-7.85.65-11.77.22-3.94.44-7.88.65-11.82.15-2.9.3-5.8.45-8.7.15-2.9.3-5.79.45-8.7.51-10.04,1.11-21.71,1.81-33.09.33-5.43,3.75-8.98,8.7-9.05,2.69-.04,6.15-.06,10-.06h11.79v3.83c0,1.68-.01,3.34,0,5h-.06l.04,3.54Zm24.05-38.1c.01-6.61,1.06-13.49,3.19-20.92,4.62-16.13,13.13-28.65,25.29-37.21,18.23-12.86,40.54-12.15,58.21,1.84,15.57,12.32,25.91,35.07,25.84,56.29h-112.53Z"></path>                  </g>                </svg>';
                    o2.parents(".swatch").find(".swatch-label").removeClass("is-active"),
                        o2.addClass("is-active"),
                        c.hasClass("card-title-change")
                            ? a.hasClass("style_2_text_color_varriant")
                                ? c.find("[data-change-title]").text(i2)
                                : c.find("[data-change-title]").text(" - " + i2)
                            : a.hasClass("style_2_text_color_varriant")
                              ? c.addClass("card-title-change").append("<span data-change-title>" + i2 + "</span>")
                              : c.addClass("card-title-change").append("<span data-change-title> - " + i2 + "</span>");
                    const v = r.variants.find((t2) => t2.id === u);
                    if (v.compare_at_price > v.price) {
                        s.find(".price").addClass("price--on-sale"),
                            s
                                .find(".price__sale .price-item--regular")
                                .html(Shopify.formatMoney(v.compare_at_price, window.money_format)),
                            s
                                .find(".price__sale .price-item--sale")
                                .html(Shopify.formatMoney(v.price, window.money_format));
                        const t2 = `(-${Math.round((100 * (v.compare_at_price - v.price)) / v.compare_at_price)}%)`;
                        s.find(".price__label_sale .label_sale").html(t2);
                    } else
                        s.find(".price__regular .price-item").html(Shopify.formatMoney(v.price, window.money_format)),
                            v.compare_at_price == null &&
                                (s.find(".price").removeClass("price--on-sale"),
                                s.find(".price__sale .price-item--regular").html(""));
                    if (
                        (s
                            .find("a:not(.single-action):not(.number-showmore):not(.vendor-text)")
                            .attr("href", p.split("?variant=")[0] + "?variant=" + u),
                        h != null)
                    ) {
                        var g = o2.data("quantity");
                        s.find('[name="id"]').val(h),
                            g > 0
                                ? window.notify_me.show
                                    ? l.removeClass("is-notify-me").addClass("is-visible")
                                    : l.removeClass("is-soldout").addClass("is-visible")
                                : window.notify_me.show
                                  ? l.removeClass("is-visible").addClass("is-notify-me")
                                  : l.removeClass("is-visible").addClass("is-soldout"),
                            l.hasClass("is-soldout") || l.hasClass("is-notify-me")
                                ? l.hasClass("is-notify-me")
                                    ? a.hasClass("product-card-layout-08")
                                        ? d.html(f).prop("disabled", !1)
                                        : l.text(window.notify_me.button)
                                    : a.hasClass("product-card-layout-08")
                                      ? d.html(f).prop("disabled", !0)
                                      : l.text(window.variantStrings.soldOut).prop("disabled", !0)
                                : a.hasClass("product-card-layout-08")
                                  ? d.html(f).prop("disabled", !1)
                                  : l.text(window.variantStrings.addToCart).prop("disabled", !1);
                    } else
                        r != null && window.quick_shop.show && n.checkStatusSwatchQuickShop(s, r),
                            s
                                .find('.swatch-element[data-value="' + i2 + '"]')
                                .find(".single-label")
                                .trigger("click");
                    if ((r.media != null && (w = r.media.filter((t2, e3) => e3.alt === i2)), w.length > 0)) {
                        if (w.length > 1) var b = 2;
                        else b = w.length;
                        for (var C = 0; C < b; C++) s.find(".card-media img:eq(" + C + ")").attr("srcset", w[C].src);
                    } else m && s.find(".card-media img:nth-child(1)").attr("srcset", m).attr("data-srcset", m);
                    n.checkNeedToConvertCurrency() &&
                        Currency.convertAll(
                            window.shop_currency,
                            t("#currencies .active").attr("data-currency"),
                            "span.money",
                            "money_format"
                        );
                }),
                o.on("click", ".item-swatch-more .number-showmore", (e2) => {
                    t(e2.target).closest(".swatch").hasClass("show--more")
                        ? (t(e2.target).closest(".swatch").removeClass("show--more"),
                          t(e2.target).find("span:eq(0)").text("+"))
                        : (t(e2.target).closest(".swatch").addClass("show--more"),
                          t(e2.target).find("span:eq(0)").text("-"));
                });
        },
        checkPreOrderOfVariant: function (e2, a2, o2) {
            const i2 = e2.id,
                s = (t2, e3, a3) => {
                    const o3 = t2.parents(".product-item").find("[data-quickshop-popup]").length > 0;
                    e3.inventory_management == null
                        ? t2
                              .text(o3 ? window.variantStrings.add : window.variantStrings.addToCart)
                              .prop("disabled", !1)
                              .removeClass("is-notify-me")
                              .addClass("button--pre-untrack")
                        : e3.available && a3 <= 0
                          ? t2
                                .text(window.variantStrings.preOrder)
                                .prop("disabled", !1)
                                .removeClass("is-notify-me")
                                .addClass("button--pre-untrack")
                          : (t2.removeClass("button--pre-untrack"),
                            a3 > 0
                                ? window.notify_me.show
                                    ? t2.removeClass("is-notify-me").addClass("is-visible")
                                    : t2.removeClass("is-soldout").addClass("is-visible")
                                : window.notify_me.show
                                  ? t2.removeClass("is-visible").addClass("is-notify-me").prop("disabled", !1)
                                  : t2.removeClass("is-visible").addClass("is-soldout").prop("disabled", !0),
                            t2.hasClass("is-soldout") || t2.hasClass("is-notify-me")
                                ? t2.hasClass("is-notify-me")
                                    ? t2
                                          .text(window.notify_me.button)
                                          .prop("disabled", !1)
                                          .removeClass("btn-unavailable")
                                    : t2.text(window.variantStrings.soldOut).prop("disabled", !0)
                                : t2
                                      .text(o3 ? window.variantStrings.add : window.variantStrings.addToCart)
                                      .prop("disabled", !1));
                },
                r = `quick_view_inven_array_${o2.id}`;
            var c = window[r];
            if (c != null) {
                var l = c[i2],
                    d = parseInt(l);
                s(a2, e2, d);
            } else
                t.ajax({
                    type: "get",
                    url: window.routes.root + "/products/" + o2.handle + "?view=ajax_quick_shop_data",
                    beforeSend: function () {},
                    success: function (t2) {
                        window[r] = JSON.parse(t2.split("=")[1]);
                        var o3 = window[r][i2],
                            n2 = parseInt(o3);
                        s(a2, e2, n2);
                    },
                    error: function (e3, a3) {
                        n.showWarning(t.parseJSON(e3.responseText).description);
                    },
                    complete: function () {},
                });
        },
        initQuickShop: function () {
            window.quick_shop.show &&
                (o.on("click", "[data-quickshop-popup]", (e2) => {
                    e2.preventDefault(), e2.stopPropagation();
                    var s = t(e2.target),
                        r = s.parents(".product-item"),
                        c = r.data("json-product"),
                        l = r.find(".variants-popup");
                    const d = document.querySelector(".halo-quick-view-popup");
                    if (
                        (!document.body.matches(".qv-loaded", ".qs3-loaded") &&
                            d &&
                            (n.buildStyleSheet(d.dataset.urlStyleProduct, d),
                            document.body.classList.add("qs3-loaded")),
                        a.hasClass("quick_shop_option_1") &&
                            (t(".productListing").hasClass("productList") || n.appendProductQuickShopOption2(r)),
                        r.hasClass("quickshop-popup-show"))
                    )
                        n.initAddToCartQuickShop(s, l);
                    else {
                        if (
                            (t(".product-item").removeClass("quickshop-popup-show"), a.hasClass("quick_shop_option_2"))
                        ) {
                            var u = r.find(".card-media").outerHeight(!0),
                                p = l.find(".variants");
                            a.hasClass("product-card-layout-02")
                                ? i.width() > 1024
                                    ? (p.css("max-height", u - 114 + "px"), p.css("min-height", u - 114 + "px"))
                                    : (p.css("max-height", u - 70 + "px"), p.css("min-height", u - 70 + "px"))
                                : a.hasClass("product-card-layout-04")
                                  ? i.width() > 1024
                                      ? (p.css("max-height", u - 116 + "px"), p.css("min-height", u - 116 + "px"))
                                      : (p.css("max-height", u - 70 + "px"), p.css("min-height", u - 70 + "px"))
                                  : i.width() > 1024
                                    ? (p.css("max-height", u - 74 + "px"), p.css("min-height", u - 74 + "px"))
                                    : (p.css("max-height", u - 20 + "px"), p.css("min-height", u - 20 + "px")),
                                p[0].scrollHeight > p[0].clientHeight && p.addClass("scrollable"),
                                t(".productListing").hasClass("productList") || n.appendProductQuickShopOption2(r);
                        } else if (a.hasClass("quick_shop_option_3")) {
                            const e4 = s.data("product-handle");
                            t(".productListing").hasClass("productList") || n.updateContentQuickshopOption3(e4),
                                o.on("click", "[data-close-quick-shop-popup]", (t2) => {
                                    t2.preventDefault(), t2.stopPropagation(), a.removeClass("quickshop-popup-show");
                                }),
                                o.off("click.quickShopOverlay").on("click.quickShopOverlay", (e5) => {
                                    a.hasClass("quickshop-popup-show") &&
                                        t(e5.target).closest("[data-quickshop-popup-option-3]").length === 0 &&
                                        a.removeClass("quickshop-popup-show");
                                });
                        } else if (a.hasClass("quick_shop_bulk")) {
                            const e4 = s.data("product-handle");
                            t(".productListing").hasClass("productList") || n.updateContentQuickBulk(e4, s),
                                o.on("click", "[data-close-quick-shop-popup]", (t2) => {
                                    t2.preventDefault(), t2.stopPropagation(), a.removeClass("quickshop-popup-show");
                                }),
                                o.off("click.quickShopOverlay").on("click.quickShopOverlay", (e5) => {
                                    a.hasClass("quickshop-popup-show") &&
                                        t(e5.target).closest("[data-halo-quick-bulk-popup]").length === 0 &&
                                        a.removeClass("quickshop-popup-show");
                                });
                        }
                        a.hasClass("quick_shop_bulk") ||
                            (a.hasClass("quick_shop_option_3")
                                ? t(".productListing").hasClass("productList") &&
                                  (i.width() < 767 ? n.appendToListViewModal(r) : r.addClass("quickshop-popup-show"))
                                : i.width() < 767 && t(".productListing").hasClass("productList")
                                  ? n.appendToListViewModal(r)
                                  : r.addClass("quickshop-popup-show")),
                            r.find(".swatch-label.is-active").trigger("click"),
                            n.checkStatusSwatchQuickShop(r, c);
                        let e3 = !1;
                        a.hasClass("quick_shop_option_1") && i.width() < 767 && (e3 = !0),
                            a.hasClass("quick_shop_option_2") ||
                            e3 ||
                            (t("productListing").hasClass("productList") &&
                                !t(".card-swatch").hasClass("quick_shop_type_3"))
                                ? (i.width() < 767
                                      ? t(".productListing").hasClass("productList")
                                          ? l.find(".selector-wrapper").each((e4, a2) => {
                                                t(a2)
                                                    .find(".swatch-element:not(.soldout):not(.unavailable)")
                                                    .eq("0")
                                                    .find(".single-label")
                                                    .trigger("click");
                                            })
                                          : t("#halo-card-mobile-popup .variants-popup")
                                                .find(".selector-wrapper")
                                                .each((e4, a2) => {
                                                    t(a2)
                                                        .find(".swatch-element:not(.soldout):not(.unavailable)")
                                                        .eq("0")
                                                        .find(".single-label")
                                                        .trigger("click");
                                                })
                                      : l.find(".selector-wrapper").each((e4, a2) => {
                                            t(a2)
                                                .find(".swatch-element:not(.soldout):not(.unavailable)")
                                                .eq("0")
                                                .find(".single-label")
                                                .trigger("click");
                                        }),
                                  t(".productListing").hasClass("productList") || a.addClass("quick_shop_popup_mobile"))
                                : l.find(".selector-wrapper:not(.option-color)").each((e4, a2) => {
                                      t(a2)
                                          .find(".swatch-element:not(.soldout):not(.unavailable)")
                                          .eq("0")
                                          .find(".single-label")
                                          .trigger("click");
                                  });
                    }
                    n.checkNeedToConvertCurrency() &&
                        Currency.convertAll(
                            window.shop_currency,
                            t("#currencies .active").attr("data-currency"),
                            "span.money",
                            "money_format"
                        );
                }),
                o.on("click", "[data-cancel-quickshop-popup]", (e2) => {
                    e2.preventDefault(), e2.stopPropagation();
                    var i2 = t(e2.currentTarget).parents(".product-item"),
                        n2 = o.find("#halo-card-mobile-popup");
                    i2.removeClass("quickshop-popup-show"),
                        o.find(".quickshop-popup-show").removeClass("quickshop-popup-show"),
                        a.removeClass("quickshop-list-view-show"),
                        (a.hasClass("quick_shop_option_1") || a.hasClass("quick_shop_option_2")) &&
                            (a.removeClass("quick_shop_popup_mobile"), n2.removeClass("show"));
                }),
                o.on("click", (e2) => {
                    t(e2.target).closest("[data-quickshop-popup]").length === 0 &&
                        t(e2.target).closest(".variants-popup").length === 0 &&
                        t(e2.target).closest(".card-swatch").length === 0 &&
                        t(e2.target).closest("[data-warning-popup]").length === 0 &&
                        (t(".product-item").removeClass("quickshop-popup-show"),
                        a.hasClass("quick_shop_option_2") && a.removeClass("quick_shop_popup_mobile"));
                }),
                n.changeSwatchQuickShop());
        },
        appendToListViewModal: function (e2) {
            const i2 = o.find("#list-view-popup"),
                n2 = e2.clone();
            i2.find(".halo-popup-content").empty(), i2.find(".halo-popup-content").append(n2);
            const s = i2.find("[data-quickshop] .card-information .variants-popup form").eq("0"),
                r = s.attr("id") + "-mobile",
                c = s.find(".single-option"),
                l = s.find(".single-label"),
                d = (i2.find(".card-product"), i2.find(".variants-popup")),
                u = i2.find("[data-btn-addtocart]");
            d.removeClass("card-list__hidden");
            let p = { selected1: !1, selected2: !1, selected3: !1 };
            s.attr("id", r),
                u.attr("data-form-id", u.attr("data-form-id") + "-mobile"),
                c.each((e3, a2) => {
                    t(a2).attr("id", t(a2).attr("id") + "-mobile"),
                        t(a2).attr("name", t(a2).attr("name") + "-mobile"),
                        a2.checked && t(a2).trigger("change");
                }),
                l.each((e3, a2) => {
                    t(a2).attr("for", t(a2).attr("for") + "-mobile");
                    const o2 = t(a2).closest(".selector-wrapper");
                    t(a2).closest(".swatch-element").hasClass("available") &&
                        (o2.hasClass("selector-wrapper-1") && !p.selected1
                            ? ((p.selected1 = !0), t(a2).trigger("click"))
                            : o2.hasClass("selector-wrapper-2") && !p.selected2
                              ? ((p.selected2 = !0), t(a2).trigger("click"))
                              : o2.hasClass("selector-wrapper-3") &&
                                !p.selected3 &&
                                ((p.selected3 = !0), t(a2).trigger("click")));
                }),
                a.addClass("quickshop-list-view-show"),
                t(".background-overlay")
                    .off("click.closeListViewModal")
                    .on("click.closeListViewModal", () => {
                        a.removeClass("quickshop-list-view-show");
                    });
        },
        changeSwatchQuickShop: function () {
            o.on("change", "[data-quickshop] .single-option", (e2) => {
                var o2,
                    s,
                    r = t(e2.target),
                    c = r.parents(".product-item"),
                    l = c.data("json-product"),
                    d = c.find("[data-btn-addtocart]"),
                    u = c.find(".option-color").data("option-position"),
                    p = r.closest("[data-option-index]").data("option-index"),
                    h = c.find(".swatch-element"),
                    m = r.val(),
                    w = c.find("[name=id]");
                if (t(".productListing").hasClass("productList"))
                    var f = c.find(".card-information .selector-wrapper-1").find("input:checked").val(),
                        v = c.find(".card-information .selector-wrapper-2").find("input:checked").val(),
                        g = c.find(".card-information .selector-wrapper-3").find("input:checked").val();
                else
                    (f = c.find(".selector-wrapper-1").find("input:checked").val()),
                        (v = c.find(".selector-wrapper-2").find("input:checked").val()),
                        (g = c.find(".selector-wrapper-3").find("input:checked").val());
                switch (
                    (a.hasClass("quick_shop_option_2") && t(".productListing").hasClass("productList")
                        ? (f = c.find(".selector-wrapper-1").eq("1").find("input:checked").val())
                        : t(".productListing").hasClass("productList") && i.width() < 767
                          ? ((f = c.find(".selector-wrapper-1").eq("1").find("input:checked").val()),
                            (v = c.find('[data-option-index="1"]').eq("1").find("input:checked").val()))
                          : (f = c.find(".selector-wrapper-1").eq("0").find("input:checked").val()),
                    l != null && (o2 = l.variants),
                    h.removeClass("soldout"),
                    h.find('input[type="radio"]').prop("disabled", !1),
                    p)
                ) {
                    case 0:
                        (b = o2.find((t2) =>
                            u == 1
                                ? g != null
                                    ? t2.option2 == m && t2.option1 == v && t2.option3 == g
                                    : t2.option2 == m && t2.option1 == v
                                : u == 2
                                  ? t2.option3 == m && t2.option1 == v
                                  : t2.option1 == m && t2.option2 == v
                        )) != null
                            ? (s = b)
                            : (s = o2.find((t2) =>
                                  u == 1 ? t2.option2 == m : u == 2 ? t2.option3 == m : t2.option1 == m
                              ));
                        break;
                    case 1:
                        (b = o2.find((t2) =>
                            u == 1
                                ? t2.option2 == f && t2.option1 == m && t2.option3 == v
                                : u == 2
                                  ? t2.option3 == f && t2.option1 == m && t2.option2 == v
                                  : t2.option1 == f && t2.option2 == m && t2.option3 == v
                        )) != null
                            ? (s = b)
                            : (s = o2.find((t2) =>
                                  u == 1
                                      ? t2.option2 == f && t2.option1 == m
                                      : u == 2
                                        ? t2.option3 == f && t2.option1 == m
                                        : t2.option1 == f && t2.option2 == m
                              ));
                        break;
                    case 2:
                        var b;
                        (b = o2.find((t2) =>
                            u == 1
                                ? t2.option2 == f && t2.option1 == v && t2.option3 == m
                                : u == 2
                                  ? t2.option3 == f && t2.option1 == v && t2.option2 == m
                                  : t2.option1 == f && t2.option2 == v && t2.option3 == m
                        )) != null && (s = b);
                }
                if (s != null) {
                    w.val(s.id);
                    var C = r.val();
                    r.parents(".selector-wrapper").find(".form-label span").text(C),
                        s.available
                            ? (c.find("[data-btn-addtocart]").removeClass("btn-unavailable"),
                              c.find("[data-quickshop] quickshop-update-quantity").removeClass("disabled"),
                              c.find("[data-btn-addtocart]").attr("data-available", "true"))
                            : (c.find("[data-btn-addtocart]").addClass("btn-unavailable"),
                              c.find("[data-quickshop] quickshop-update-quantity").addClass("disabled"),
                              c.find("[data-btn-addtocart]").attr("data-available", "false")),
                        n.checkNeedToConvertCurrency() &&
                            Currency.convertAll(
                                window.shop_currency,
                                t("#currencies .active").attr("data-currency"),
                                "span.money",
                                "money_format"
                            ),
                        !a.hasClass("quick_shop_option_2") && !a.hasClass("quick_shop_option_3") && i.width(),
                        a.hasClass("quick_shop_option_2") &&
                            i.width() < 767 &&
                            (t('.halo-popup-wrapper .card-product__wrapper [data-option-index="0"] .swatch-element')
                                .length == 1 &&
                                t('.halo-popup-wrapper .card-product__wrapper [data-option-index="0"] .swatch-element')
                                    .eq("0")
                                    .find(".single-label")
                                    .trigger("click"),
                            t(
                                '.halo-product-list-view-popup .product-options-wrapper .product-item .card-information [data-option-index="0"] .swatch-element'
                            ).length == 1 &&
                                t(
                                    '.halo-product-list-view-popup .product-options-wrapper .product-item .card-information [data-option-index="0"] .swatch-element'
                                )
                                    .eq("0")
                                    .find(".single-label")
                                    .trigger("click")),
                        n.checkStatusSwatchQuickShop(c, l),
                        n.checkPreOrderOfVariant(s, d, l);
                }
            });
        },
        checkStatusSwatchQuickShop: function (e2, o2) {
            var n2,
                s = e2.find(".card-variant"),
                r = e2.find("[data-option-index]"),
                c = e2.find(".option-color").data("option-position"),
                l = e2.find('[data-option-index="0"]').find("input:checked").val(),
                d = e2.find('[data-option-index="1"]').find("input:checked").val(),
                u = e2.find('[data-option-index="2"]').find("input:checked").val(),
                p = e2.data("product-id");
            if (a.hasClass("quick_shop_option_2")) {
                var h = e2.find(".card-media").outerHeight(!0);
                u != null
                    ? a.hasClass("product-card-layout-01")
                        ? h < 310
                            ? t("[data-quickshop]").addClass("active_option_3")
                            : t("[data-quickshop]").removeClass("active_option_3")
                        : h < 370
                          ? t("[data-quickshop]").addClass("active_option_3")
                          : t("[data-quickshop]").removeClass("active_option_3")
                    : i.width() > 1024
                      ? a.hasClass("product-card-layout-05")
                          ? h < 350 && d != null
                              ? t("[data-quickshop]").addClass("active_option_3")
                              : t("[data-quickshop]").removeClass("active_option_3")
                          : a.hasClass("product-card-layout-01")
                            ? h < 310 && d != null
                                ? t("[data-quickshop]").addClass("active_option_3")
                                : t("[data-quickshop]").removeClass("active_option_3")
                            : h < 370 && d != null
                              ? t("[data-quickshop]").addClass("active_option_3")
                              : t("[data-quickshop]").removeClass("active_option_3")
                      : a.hasClass("product-card-layout-01")
                        ? h < 310
                            ? l != null || d != null
                                ? t("[data-quickshop]").removeClass("active_option_3")
                                : t("[data-quickshop]").addClass("active_option_3")
                            : t("[data-quickshop]").removeClass("active_option_3")
                        : h < 370
                          ? l != null || d != null
                              ? t("[data-quickshop]").removeClass("active_option_3")
                              : t("[data-quickshop]").addClass("active_option_3")
                          : t("[data-quickshop]").removeClass("active_option_3");
            }
            if (
                (a.hasClass("quick_shop_option_2") && t(".productListing").hasClass("productList")
                    ? (l = e2.find('[data-option-index="0"]').eq("1").find("input:checked").val())
                    : t(".productListing").hasClass("productList") && i.width() < 767
                      ? ((l = e2.find('[data-option-index="0"]').eq("1").find("input:checked").val()),
                        (d = e2.find('[data-option-index="1"]').eq("1").find("input:checked").val()))
                      : (l = e2.find('[data-option-index="0"]').eq("0").find("input:checked").val()),
                o2 != null && (n2 = o2.variants),
                r.each((e3, a2) => {
                    var o3 = t(a2).data("option-index"),
                        i2 = t(a2).find(".swatch-element");
                    switch (o3) {
                        case 0:
                            i2.each((e4, a3) => {
                                var o4 = t(a3),
                                    i3 = o4.data("value"),
                                    s2 = n2.find((t2) =>
                                        c == 1
                                            ? t2.option2 == i3 && t2.available
                                            : c == 2
                                              ? t2.option3 == i3 && t2.available
                                              : t2.option1 == i3 && t2.available
                                    ),
                                    r2 = n2.find((t2) =>
                                        c == 1 ? t2.option2 == i3 : c == 2 ? t2.option3 == i3 : t2.option1 == i3
                                    );
                                s2 == null
                                    ? r2 == null
                                        ? (o4.removeClass("soldout available").addClass("unavailable"),
                                          o4.find('input[type="radio"]').prop("checked", !1))
                                        : (o4
                                              .removeClass("unavailable available")
                                              .addClass("soldout")
                                              .find(".single-action")
                                              .attr("data-variant-id", r2.title),
                                          o4.find('input[type="radio"]').prop("disabled", !1))
                                    : (o4.removeClass("soldout unavailable").addClass("available"),
                                      o4.find('input[type="radio"]').prop("disabled", !1));
                            });
                            break;
                        case 1:
                            i2.each((e4, a3) => {
                                var o4 = t(a3),
                                    i3 = o4.data("value"),
                                    s2 = n2.find((t2) =>
                                        c == 1
                                            ? t2.option2 == l && t2.option1 == i3 && t2.available
                                            : c == 2
                                              ? t2.option3 == l && t2.option1 == i3 && t2.available
                                              : t2.option1 == l && t2.option2 == i3 && t2.available
                                    ),
                                    r2 = n2.find((t2) =>
                                        c == 1
                                            ? t2.option2 == l && t2.option1 == i3
                                            : c == 2
                                              ? t2.option3 == l && t2.option1 == i3
                                              : t2.option1 == l && t2.option2 == i3
                                    );
                                s2 == null
                                    ? r2 == null
                                        ? (o4.removeClass("soldout available").addClass("unavailable"),
                                          o4.find('input[type="radio"]').prop("checked", !1))
                                        : (o4
                                              .removeClass("unavailable available")
                                              .addClass("soldout")
                                              .find(".single-action-selector")
                                              .attr("data-variant-id", r2.title),
                                          o4.find('input[type="radio"]').prop("disabled", !1))
                                    : (o4.removeClass("soldout unavailable").addClass("available"),
                                      o4.find('input[type="radio"]').prop("disabled", !1));
                            });
                            break;
                        case 2:
                            i2.each((e4, a3) => {
                                var o4 = t(a3),
                                    i3 = o4.data("value"),
                                    s2 = n2.find((t2) =>
                                        c == 1
                                            ? t2.option2 == l && t2.option1 == d && t2.option3 == i3 && t2.available
                                            : c == 2
                                              ? t2.option3 == l && t2.option1 == d && t2.option2 == i3 && t2.available
                                              : t2.option1 == l && t2.option2 == d && t2.option3 == i3 && t2.available
                                    ),
                                    r2 = n2.find((t2) =>
                                        c == 1
                                            ? t2.option2 == l && t2.option1 == d && t2.option3 == i3
                                            : c == 2
                                              ? t2.option3 == l && t2.option1 == d && t2.option2 == i3
                                              : t2.option1 == l && t2.option2 == d && t2.option3 == i3
                                    );
                                s2 == null
                                    ? r2 == null
                                        ? (o4.removeClass("soldout available").addClass("unavailable"),
                                          o4.find('input[type="radio"]').prop("checked", !1))
                                        : (o4
                                              .removeClass("unavailable available")
                                              .addClass("soldout")
                                              .find(".single-action-selector")
                                              .attr("data-variant-id", r2.title),
                                          o4.find('input[type="radio"]').prop("disabled", !1))
                                    : (o4.removeClass("unavailable soldout").addClass("available"),
                                      o4.find('input[type="radio"]').prop("disabled", !1));
                            });
                    }
                }),
                s.find(".selector-wrapper:not(.option-color)").each((e3, a2) => {
                    var o3 = t(a2);
                    o3.find(".swatch-element").find("input:checked").length < 1 &&
                        (o3.find(".swatch-element.available").length > 0
                            ? o3.find(".swatch-element.available").eq("0").find(".single-label").trigger("click")
                            : o3.find(".swatch-element.soldout").eq("0").find(".single-label").trigger("click"));
                }),
                a.hasClass("quick_shop_option_2"))
            ) {
                var m = e2.find("[data-quickshop]").eq(1).find('[name="id"]').val(),
                    w = window[`quick_view_inven_array_${p}`];
                if (w != null) {
                    var f = w[m],
                        v = parseInt(f),
                        g = e2.find('input[name="quantity"]').eq(0);
                    g.attr("data-inventory-quantity", v), g.val() > v && (v > 0 ? g.val(v) : g.val(1));
                }
            }
        },
        initAddToCartQuickShop: function (t2, e2) {
            var a2 = e2.find('[name="id"]').val();
            n.actionAddToCart(t2, a2, 1);
        },
        initAddToCart: function () {
            o.off("click.addToCart").on("click.addToCart", "[data-btn-addtocart]", (e2) => {
                e2.preventDefault(), e2.stopPropagation();
                var a2 = t(e2.target);
                if (
                    (a2.parents(".product-item"),
                    o.find("#halo-card-mobile-popup"),
                    o.find(".quickshop-popup-show"),
                    a2.closest("product-form").length > 0)
                ) {
                    var i2 = a2.closest("form");
                    n.actionAddToCart2(a2, i2);
                } else if (a2.hasClass("is-notify-me") || a2.hasClass("is-soldout"))
                    a2.hasClass("is-notify-me") && n.notifyInStockPopup(a2);
                else {
                    var s = a2.parents("form"),
                        r = s.find('[name="id"]').val(),
                        c = s.find('[name="quantity"]').val(),
                        l = s.find('[name="quantity"]').eq(0);
                    c == null && (c = 1),
                        t(".recipient-form").length > 0
                            ? t("#product-add-to-cart").trigger("click")
                            : n.actionAddToCart(a2, r, c, l);
                }
            }),
                o.on("click", "[data-close-add-to-cart-popup]", (t2) => {
                    t2.preventDefault(), t2.stopPropagation(), a.removeClass("add-to-cart-show");
                }),
                o.on("click", (e2) => {
                    a.hasClass("add-to-cart-show") &&
                        t(e2.target).closest("[data-add-to-cart-popup]").length === 0 &&
                        a.removeClass("add-to-cart-show");
                });
        },
        actionAddToCart: function (e2, i2, s, r) {
            window.variantStrings.submit,
                window.variantStrings.addingToCart,
                window.variantStrings.addedToCart,
                e2.hasClass("button-text-change") && e2.text(),
                e2.addClass("is-loading"),
                a.hasClass("quick-view-show")
                    ? Shopify.addItem(
                          i2,
                          s,
                          e2,
                          () => {
                              switch (window.after_add_to_cart.type) {
                                  case "cart":
                                      n.redirectTo(window.routes.cart);
                                      break;
                                  case "quick_cart":
                                      window.quick_cart.show
                                          ? Shopify.getCart((o2) => {
                                                window.quick_cart.type == "popup" ||
                                                    (a.addClass("cart-sidebar-show"), n.updateSidebarCart(o2)),
                                                    o2.item_count >= 100 &&
                                                        a
                                                            .find(".cart-count-bubble [data-cart-count]")
                                                            .text(window.cartStrings.item_99),
                                                    e2.removeClass("is-loading"),
                                                    t(".background-overlay").removeClass("hold");
                                            })
                                          : (n.showWarning(window.after_add_to_cart.message_2),
                                            e2.removeClass("is-loading"),
                                            n.showWarning(window.after_add_to_cart.message_2),
                                            Shopify.getCart((t2) => {
                                                a.find("[data-cart-count]").text(t2.item_count),
                                                    t2.item_count >= 100 &&
                                                        a
                                                            .find(".cart-count-bubble [data-cart-count]")
                                                            .text(window.cartStrings.item_99),
                                                    t2.item_count == 1
                                                        ? a.find("[data-cart-text]").text(window.cartStrings.item)
                                                        : a.find("[data-cart-text]").text(window.cartStrings.items);
                                            }));
                                      break;
                                  case "popup_cart_1":
                                      Shopify.getCart((o2) => {
                                          n.updatePopupCart(o2, 1, i2),
                                              a.addClass("add-to-cart-show"),
                                              a.removeClass("quick-view-show"),
                                              e2.removeClass("is-loading"),
                                              o2.item_count >= 100 &&
                                                  a
                                                      .find(".cart-count-bubble [data-cart-count]")
                                                      .text(window.cartStrings.item_99),
                                              t(".background-overlay").removeClass("hold");
                                      });
                              }
                          },
                          r
                      )
                    : a.hasClass("template-cart")
                      ? Shopify.addItem(
                            i2,
                            s,
                            e2,
                            () => {
                                n.redirectTo(window.routes.cart);
                            },
                            r
                        )
                      : Shopify.addItem(
                            i2,
                            s,
                            e2,
                            () => {
                                switch (
                                    (e2.removeClass("is-loading"),
                                    a.hasClass("quickshop-popup-show") &&
                                        a.hasClass("quick_shop_option_3") &&
                                        (a.removeClass("quickshop-popup-show"),
                                        t(".quickshop-popup-show").removeClass("quickshop-popup-show")),
                                    a.hasClass("quickshop-list-view-show") && a.removeClass("quickshop-list-view-show"),
                                    a.hasClass("show-mobile-options") &&
                                        (a.removeClass("show-mobile-options"),
                                        t(".background-overlay").addClass("hold")),
                                    ((a.hasClass("quick_shop_popup_mobile") && a.hasClass("quick_shop_option_1")) ||
                                        a.hasClass("quick_shop_option_2")) &&
                                        (a.removeClass("quick_shop_popup_mobile"),
                                        o.find("#halo-card-mobile-popup").removeClass("show"),
                                        o.find(".quickshop-popup-show").each((e3, a2) => {
                                            t(a2).removeClass("quickshop-popup-show");
                                        })),
                                    window.after_add_to_cart.type)
                                ) {
                                    case "cart":
                                        n.redirectTo(window.routes.cart);
                                        break;
                                    case "quick_cart":
                                        window.quick_cart.show
                                            ? Shopify.getCart((o2) => {
                                                  window.quick_cart.type == "popup" ||
                                                      (a.addClass("cart-sidebar-show"), n.updateSidebarCart(o2)),
                                                      e2.removeClass("is-loading"),
                                                      t(".background-overlay").removeClass("hold"),
                                                      o2.item_count >= 100 &&
                                                          a
                                                              .find(".cart-count-bubble [data-cart-count]")
                                                              .text(window.cartStrings.item_99);
                                              })
                                            : (n.showWarning(window.after_add_to_cart.message_2),
                                              Shopify.getCart((t2) => {
                                                  a.find("[data-cart-count]").text(t2.item_count),
                                                      t2.item_count >= 100 &&
                                                          a
                                                              .find(".cart-count-bubble [data-cart-count]")
                                                              .text(window.cartStrings.item_99),
                                                      t2.item_count == 1
                                                          ? a.find("[data-cart-text]").text(window.cartStrings.item)
                                                          : a.find("[data-cart-text]").text(window.cartStrings.items);
                                              }));
                                        break;
                                    case "popup_cart_1":
                                        Shopify.getCart((o2) => {
                                            n.updatePopupCart(o2, 1, i2),
                                                a.addClass("add-to-cart-show"),
                                                e2.removeClass("is-loading"),
                                                t(".background-overlay").removeClass("hold"),
                                                o2.item_count >= 100 &&
                                                    a
                                                        .find(".cart-count-bubble [data-cart-count]")
                                                        .text(window.cartStrings.item_99);
                                        });
                                }
                            },
                            r
                        );
        },
        actionAddToCart2: function (e2, o2) {
            const i2 = fetchConfig("javascript");
            (i2.headers["X-Requested-With"] = "XMLHttpRequest"),
                delete i2.headers["Content-Type"],
                window.variantStrings.submit,
                window.variantStrings.addingToCart,
                window.variantStrings.addedToCart,
                e2.hasClass("button-text-change") && e2.text(),
                e2.addClass("is-loading");
            let s = (o2 && o2[0]) || document.querySelector('[data-type="add-to-cart-form"]'),
                r = new FormData(s);
            if (
                (document.querySelectorAll('.line-item-property__field input[name^="properties"]').forEach((t2) => {
                    t2.value != null &&
                        (t2.type == "file" ? r.append(t2.name, t2.files[0]) : r.append(t2.name, t2.value));
                }),
                !n.checkSufficientStock(o2) && a.hasClass("quickshop-popup-show"))
            )
                return alert(window.cartStrings.addProductOutQuantity), void e2.removeClass("is-loading");
            const c = (t2) => {
                fetch(window.Shopify.routes.root + "cart/add.js", { ...i2, method: "POST", body: r })
                    .then((t3) => t3.json())
                    .catch((t3) => {
                        console.error("Error:", t3);
                    })
                    .finally(() => {
                        if (
                            (a.hasClass("quickshop-popup-show") && a.removeClass("quickshop-popup-show"),
                            a.hasClass("quick-view-show"))
                        )
                            window.after_add_to_cart.type == "cart"
                                ? n.redirectTo(window.routes.cart)
                                : Shopify.getCart((t3) => {
                                      a.find("[data-cart-count]").text(t3.item_count),
                                          e2.removeClass("is-loading"),
                                          cart.item_count >= 100 &&
                                              a
                                                  .find(".cart-count-bubble [data-cart-count]")
                                                  .text(window.cartStrings.item_99);
                                  });
                        else
                            switch (window.after_add_to_cart.type) {
                                case "cart":
                                    n.redirectTo(window.routes.cart);
                                    break;
                                case "quick_cart":
                                    window.quick_cart.show
                                        ? Shopify.getCart((t3) => {
                                              window.quick_cart.type == "popup" ||
                                                  (a.addClass("cart-sidebar-show"), n.updateSidebarCart(t3)),
                                                  t3.item_count >= 100 &&
                                                      a
                                                          .find(".cart-count-bubble [data-cart-count]")
                                                          .text(window.cartStrings.item_99),
                                                  e2.removeClass("is-loading");
                                          })
                                        : n.redirectTo(window.routes.cart);
                                    break;
                                case "popup_cart_1":
                                    Shopify.getCart((o3) => {
                                        n.updatePopupCart(o3, 1, t2),
                                            n.updateSidebarCart(o3),
                                            a.addClass("add-to-cart-show"),
                                            e2.removeClass("is-loading"),
                                            o3.item_count >= 100 &&
                                                a
                                                    .find(".cart-count-bubble [data-cart-count]")
                                                    .text(window.cartStrings.item_99);
                                    });
                            }
                    });
            };
            fetch(window.Shopify.routes.root + "cart.js", { method: "GET" })
                .then((t2) => t2.json())
                .then((e3) => {
                    const a2 = parseInt(t(s).serialize().split("id=")[1]),
                        i3 = e3.items.find((t2) => t2.variant_id == a2),
                        n2 = i3?.quantity,
                        r2 = i3?.product_id,
                        l = parseInt(o2.find("[data-inventory-quantity]").val()),
                        d = parseInt(o2.find("[data-inventory-quantity]").data("inventory-quantity")),
                        u = (document.getElementById("product-add-to-cart").dataset.available === "true") | !1;
                    if (!n2 || !d || u) return c(a2);
                    const sellingPolicy = window[`selling_array_${r2}`];
                    if (sellingPolicy && sellingPolicy[a2] == "deny")
                        if (n2 + l > d) {
                            if (!(d < 0)) {
                                const t2 = d - n2;
                                throw new Error(
                                    `You ${t2 > 0 ? `can only add ${t2}` : "cannot add"} more of the items into the cart`
                                );
                            }
                            c(a2);
                        } else c(a2);
                    else c(a2);
                })
                .catch((t2) => {
                    this.showWarning(t2);
                })
                .finally(() => {
                    e2.removeClass("is-loading");
                });
        },
        checkSufficientStock: function (t2) {
            return (
                t2.find("[data-inventory-quantity]").data("inventory-quantity") >=
                parseInt(t2.find("[data-inventory-quantity]").val())
            );
        },
        updateContentQuickshopOption3: function (e2) {
            var o2 = t("#halo-quickshop-popup-option-3"),
                i2 = o2.find(".halo-popup-content");
            t.ajax({
                type: "get",
                url: window.routes.root + "/products/" + e2 + "?view=ajax_quick_shop",
                beforeSend: function () {
                    t("[data-quick-view-popup] .halo-popup-content").empty();
                },
                success: function (t2) {
                    i2.html(t2);
                },
                error: function (e3, a2) {
                    n.showWarning(t.parseJSON(e3.responseText).description);
                },
                complete: function () {
                    var t2 = o2.find(".quickshop");
                    n.productImageGallery(t2),
                        setTimeout(() => {
                            a.addClass("quickshop-popup-show");
                        }, 150);
                },
            });
        },
        updateContentQuickBulk: function (e2, a2) {
            const o2 = t("#halo-quick-bulk-popup"),
                i2 = o2.find(".halo-popup-content");
            t.ajax({
                type: "get",
                url: window.routes.root + "/products/" + e2 + "?view=ajax_quick_bulk",
                beforeSend: function () {
                    a2.addClass("is-loading"), t("[data-quick-view-popup] .halo-popup-content").empty();
                },
                success: function (t2) {
                    i2.html(t2);
                },
                error: function (e3, a3) {
                    n.showWarning(t.parseJSON(e3.responseText).description);
                },
                complete: function () {
                    var t2 = o2.find(".quickshop");
                    n.productImageGallery(t2),
                        setTimeout(() => {
                            a2.removeClass("is-loading");
                        }, 100);
                },
            });
        },
        appendProductQuickShopOption2: function (e2) {
            if (window.innerWidth <= 767) {
                var i2 = o.find("#halo-card-mobile-popup"),
                    n2 = e2.clone();
                i2.find(".halo-popup-content").empty(),
                    n2.find(".card-product__group").remove(),
                    i2.find(".halo-popup-content").append(n2);
                var s = i2.find("[data-quickshop] form").eq("0"),
                    r = s.attr("id") + "mobile";
                s.attr("id", r);
                var c = s.find(".single-option"),
                    l = s.find(".single-label");
                c.each((e3, a2) => {
                    t(a2).attr("id", t(a2).attr("id") + "-mobile");
                }),
                    l.each((e3, a2) => {
                        t(a2).attr("for", t(a2).attr("for") + "-mobile");
                    }),
                    i2.addClass("show"),
                    a.addClass("quick_shop_popup_mobile"),
                    o.on("click", (o2) => {
                        t(o2.target).hasClass("background-overlay") &&
                            (i2.removeClass("show"),
                            a.removeClass("quick_shop_popup_mobile"),
                            e2.removeClass("quickshop-popup-show"));
                    });
            }
        },
        isRunningInIframe: function () {
            try {
                return window.self !== window.top;
            } catch {
                return !0;
            }
        },
        redirectTo: function (t2) {
            n.isRunningInIframe() && !window.iframeSdk ? (window.top.location = t2) : (window.location = t2);
        },
        initQuickCart: function () {
            if (n._quickCartBound) return;
            n._quickCartBound = !0,
                window.quick_cart.show && (window.quick_cart.type == "popup" || n.initSidebarCart()),
                n.initEventQuickCart();
        },
        initEventQuickCart: function () {
            n.removeItemQuickCart(), n.updateQuantityItemQuickCart(), n.editQuickCart();
        },
        productCollectionCartSlider: function () {
            t("[data-product-collection-cart]").each((e2, a2) => {
                var o2 = t(a2).find(".products-carousel"),
                    i2 = o2.data("item-dots"),
                    n2 = o2.data("item-arrows");
                o2.length > 0 &&
                    (o2.hasClass("slick-initialized") ||
                        o2.slick({
                            mobileFirst: !0,
                            adaptiveHeight: !1,
                            infinite: !1,
                            vertical: !1,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: !0,
                            arrows: !1,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [{ breakpoint: 1025, settings: { dots: i2, arrows: n2 } }],
                        }));
            }),
                updateStickyCart();
        },
        updatePopupCart: function (e2, o2, i2) {
            var n2 = e2.items.filter((t2) => t2.id == i2)[0],
                s = t("[data-add-to-cart-popup]").find(".product-added"),
                r = s.find(".product-title"),
                c = s.find(".product-image"),
                l = n2.title || n2.product_title,
                d = n2.featured_image,
                u = '<img src="' + d.url + '" alt="' + d.alt + '" title="' + d.alt + '"/>';
            c.attr("href", n2.url).html(u),
                r.find(".title").attr("href", n2.url).empty().append(l),
                Shopify.getCart((t2) => {
                    a.find("[data-cart-count]").text(t2.item_count);
                });
        },
        initSidebarCart: function () {
            if (n._sidebarCartBound) return;
            n._sidebarCartBound = !0;
            let i2 = !0;
            a.hasClass("template-cart") &&
                n.checkNeedToConvertCurrency() &&
                Currency.convertAll(
                    window.shop_currency,
                    t("#currencies .active").attr("data-currency"),
                    "span.money",
                    "money_format"
                );
            // Event delegation so cart works before window.onload and for sticky/cloned icons
            o.off("click.haloCartSidebar").on("click.haloCartSidebar", "[data-cart-sidebar]", (t2) => {
                if (a.hasClass("template-cart")) {
                    t2.preventDefault(), t2.stopPropagation(), t("html, body").animate({ scrollTop: 0 }, 700);
                    return;
                }
                t2.preventDefault(), t2.stopPropagation(), a.addClass("cart-sidebar-show");
                i2 &&
                    ((i2 = !1),
                    Shopify.getCart((cartData) => {
                        n.updateSidebarCart(cartData);
                        i2 = !0;
                    }),
                    t("body").hasClass("cursor-fixed__show") &&
                        (window.sharedFunctionsAnimation.onEnterButton(),
                        window.sharedFunctionsAnimation.onLeaveButton()));
            }),
                o.on("click", "[data-close-cart-sidebar]", (t2) => {
                    t2.preventDefault(),
                        t2.stopPropagation(),
                        a.hasClass("cart-sidebar-show") && a.removeClass("cart-sidebar-show");
                }),
                a.on("click", ".background-overlay", (e3) => {
                    !a.hasClass("cart-sidebar-show") ||
                        a.hasClass("quickshop-popup-show") ||
                        a.hasClass("quick_shop_popup_mobile") ||
                        a.hasClass("edit-cart-show") ||
                        a.hasClass("term-condition-show") ||
                        a.hasClass("has-warning") ||
                        (t(e3.target).closest("#halo-cart-sidebar").length === 0 &&
                            t(e3.target).closest("[data-cart-sidebar]").length === 0 &&
                            t(e3.target).closest("[data-edit-cart-popup]").length === 0 &&
                            t(e3.target).closest("[data-warning-popup]").length === 0 &&
                            t(e3.target).closest("[data-term-condition-popup]").length === 0 &&
                            a.removeClass("cart-sidebar-show"));
                });
        },
        updateSidebarCart: function (e2) {
            if (!t.isEmptyObject(e2)) {
                const o2 = t("#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper"),
                    i2 =
                        '<div class="loading-overlay loading-overlay--custom">                        <div class="loading-overlay__spinner">                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>                            </svg>                        </div>                    </div>',
                    s = "is-loading";
                o2.addClass(s).prepend(i2),
                    t.ajax({
                        type: "GET",
                        url: window.routes.root + "/cart?view=ajax_side_cart",
                        cache: !1,
                        success: function (e3) {
                            var a2 = t(e3);
                            o2.removeClass(s).html(a2), n.dispatchChangeForShippingMessage();
                        },
                        error: function (e3, a2) {
                            n.showWarning(t.parseJSON(e3.responseText).description);
                        },
                        complete: function () {
                            a.find("[data-cart-count]").text(e2.item_count),
                                e2.item_count >= 100 &&
                                    a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99),
                                e2.item_count == 1
                                    ? a.find("[data-cart-text]").text(window.cartStrings.item)
                                    : a.find("[data-cart-text]").text(window.cartStrings.items),
                                n.productCollectionCartSlider(),
                                n.updateGiftWrapper(),
                                n.checkNeedToConvertCurrency() &&
                                    Currency.convertAll(
                                        window.shop_currency,
                                        t("#currencies .active").attr("data-currency"),
                                        "span.money",
                                        "money_format"
                                    ),
                                document.dispatchEvent(new CustomEvent("cart-update", { detail: e2 })),
                                t("body").hasClass("cursor-fixed__show") &&
                                    (window.sharedFunctionsAnimation.onEnterButton(),
                                    window.sharedFunctionsAnimation.onLeaveButton());
                        },
                    });
            }
        },
        dispatchChangeForShippingMessage: function () {
            document.querySelectorAll("[data-free-shipping-wrapper]").forEach((t2) => {
                const e2 = new Event("change", { bubbles: !0 });
                t2.dispatchEvent(e2);
            });
        },
        updateGiftWrapper: function () {
            let e2;
            t("#gift-wrapping")
                .off("click")
                .on("click", (a2) => {
                    a2.stopPropagation(), a2.preventDefault();
                    const o2 = t(a2.currentTarget);
                    clearTimeout(e2),
                        (e2 = setTimeout(() => {
                            const t2 = a2.target.dataset.giftId;
                            Shopify.addItem(t2, 1, o2, () => {
                                Shopify.getCart((t3) => {
                                    n.updateSidebarCart(t3);
                                });
                            });
                        }, 250));
                }),
                t("#cart-gift-wrapping")
                    .off("click")
                    .on("click", (a2) => {
                        a2.stopPropagation(), a2.preventDefault();
                        var o2 = t(a2.currentTarget),
                            i2 = o2.attr("data-adding-text");
                        o2.text(i2),
                            clearTimeout(e2),
                            (e2 = setTimeout(() => {
                                const t2 = a2.target.dataset.giftId;
                                Shopify.addItem(t2, 1, o2, () => {
                                    Shopify.getCart((t3) => {
                                        n.updateCart(t3);
                                    });
                                });
                            }, 250));
                    });
        },
        removeItemQuickCart: function () {
            o.on("click", "[data-cart-remove]", (e2) => {
                e2.preventDefault(), e2.stopPropagation();
                var o2 = t(e2.currentTarget),
                    i2 = (o2.attr("data-cart-remove-id"), t("#cart-gift-wrapping").attr("data-add-text")),
                    s = o2.data("line"),
                    r = o2.data("index");
                t("#cart-gift-wrapping").text(i2),
                    Shopify.removeItem(s, r, (t2) => {
                        a.hasClass("template-cart")
                            ? n.updateCart(t2)
                            : a.hasClass("cart-modal-show") ||
                              (a.hasClass("cart-sidebar-show") && n.updateSidebarCart(t2));
                    });
            });
        },
        updateCart: function (e2) {
            if (!t.isEmptyObject(e2)) {
                const o2 = t("#main-cart-items").data("id"),
                    i2 = t("[data-cart]"),
                    s = i2.find("[data-cart-content]"),
                    r = i2.find("[data-cart-total]"),
                    c =
                        '<div class="loading-overlay loading-overlay--custom">                        <div class="loading-overlay__spinner">                            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>                            </svg>                        </div>                    </div>',
                    l = "is-loading";
                i2.addClass(l).prepend(c),
                    t.ajax({
                        type: "GET",
                        url: `/cart?section_id=${o2}`,
                        cache: !1,
                        success: function (a2) {
                            var o3 = a2.replaceAll("cart-coupon-discount", "div"),
                                n2 = t(o3);
                            if ((i2.removeClass(l), i2.find(".loading-overlay").remove(), e2.item_count > 0)) {
                                var c2 = n2.find("[data-cart-content] .cart").html(),
                                    d = n2.find("[data-cart-total] .cart-total-subtotal").html(),
                                    u = n2.find("[data-cart-total] .cart-total-grandtotal").html(),
                                    p = n2.find("[data-cart-total] .cart-total-savings").html();
                                if (
                                    (s.find(".cart").html(c2),
                                    r.find(".cart-total-subtotal").html(d),
                                    r.find(".cart-total-grandtotal").html(u),
                                    r.find(".cart-total-savings").html(p),
                                    n2.find(".haloCalculatorShipping").length > 0)
                                ) {
                                    var h = n2.find(".haloCalculatorShipping");
                                    i2.find(".haloCalculatorShipping").replaceWith(h);
                                }
                            } else {
                                c2 = n2.find("#main-cart-items").html();
                                var m = n2.find(".page-header").html();
                                (cartCountdownText1 = n2.find(".cart-countdown").data("coundown-text-empty-1")),
                                    (cartCountdownText2 = n2.find(".cart-countdown").data("coundown-text-empty-2")),
                                    (cartCountdownProductUrl = n2
                                        .find(".cart-countdown")
                                        .data("coundown-prd-empty-url")),
                                    (cartCountdownProductTitle = n2
                                        .find(".cart-countdown")
                                        .data("coundown-prd-empty-title"));
                                var w =
                                    cartCountdownText1 +
                                    ' <a href="' +
                                    cartCountdownProductUrl +
                                    '" class="cart-countdown-product link-effect p-relative"><span class="text">' +
                                    cartCountdownProductTitle +
                                    "</span></a> " +
                                    cartCountdownText2;
                                t("#main-cart-items").html(c2),
                                    t(".page-header").html(m),
                                    t(".cart-countdown .text-wrap").html(w);
                            }
                        },
                        error: function (e3, a2) {
                            n.showWarning(t.parseJSON(e3.responseText).description);
                        },
                        complete: function () {
                            if (
                                (a.find("[data-cart-count]").text(e2.item_count),
                                n.dispatchChangeForShippingMessage(),
                                n.checkNeedToConvertCurrency() &&
                                    Currency.convertAll(
                                        window.shop_currency,
                                        t("#currencies .active").attr("data-currency"),
                                        "span.money",
                                        "money_format"
                                    ),
                                a.hasClass("template-cart"))
                            ) {
                                const o3 = document.getElementById("cart-gift-wrapping"),
                                    i3 = o3?.dataset.isChecked,
                                    n2 = o3?.dataset.giftId;
                                if (i3 === "true") {
                                    t("#is-a-gift").hide();
                                    const e3 = document.querySelector(`[data-cart-remove-id="${n2}"]`),
                                        a2 = document.querySelector(`[data-cart-quantity-id="${n2}"]`);
                                    e3?.addEventListener("click", () => {
                                        o3.dataset.isChecked = "false";
                                    }),
                                        a2?.addEventListener("change", (t2) => {
                                            Number(t2.target.value) <= 0 && (o3.dataset.isChecked = "false");
                                        });
                                } else t("#is-a-gift").show();
                                e2.item_count >= 100 &&
                                    a.find(".cart-count-bubble [data-cart-count]").text(window.cartStrings.item_99);
                            }
                            document.dispatchEvent(new CustomEvent("cart-update", { detail: e2 }));
                        },
                    });
            }
        },
        updateQuantityItemQuickCart: function () {
            o.on("change", "[data-cart-quantity]", (e2) => {
                e2.preventDefault(), e2.stopPropagation();
                var o2 = t(e2.currentTarget),
                    i2 = (o2.attr("data-cart-quantity-id"), o2.data("line")),
                    s = parseInt(o2.val()),
                    r = parseInt(o2.data("inventory-quantity")),
                    c = o2.data("index");
                let l = !0;
                if (!o2.parents(".quick-order-list__contents").length) {
                    if (r < s && r > 0) {
                        var d = `cart_selling_array_${e2.currentTarget.closest("cart-update-quantity").dataset.product}`;
                        window[d][e2.currentTarget.closest("cart-update-quantity").dataset.variant] == "deny" &&
                            ((s = r), (l = !1));
                    }
                    Shopify.changeItem(i2, s, c, (t2) => {
                        a.hasClass("template-cart")
                            ? n.updateCart(t2)
                            : a.hasClass("cart-modal-show") ||
                              (a.hasClass("cart-sidebar-show") && n.updateSidebarCart(t2)),
                            l ||
                                n.showWarning(
                                    `${window.cartStrings.addProductOutQuantity.replace("[maxQuantity]", s)}`
                                );
                    });
                }
            });
        },
        editQuickCart: function () {
            let e2 = !0;
            o.on("click", "[data-open-edit-cart]", (o2) => {
                o2.preventDefault(), o2.stopPropagation();
                var i2 = t(o2.currentTarget),
                    s = i2.data("edit-cart-url"),
                    r = i2.data("edit-cart-id"),
                    c = i2.data("line"),
                    l = i2.data("index"),
                    d = i2.data("edit-cart-quantity");
                i2.parents(".previewCartItem").find("previewCartItem-variant").text();
                const u = t("[data-edit-cart-popup]").find(".halo-popup-content");
                if (e2) {
                    e2 = !1;
                    const t2 = document.querySelector(".halo-edit-cart-popup"),
                        a2 = t2.dataset.urlStyleEditCart,
                        o3 = t2.dataset.urlScriptEditCart;
                    n.buildStyleSheet(a2, t2), n.buildScript(o3);
                }
                t.ajax({
                    type: "get",
                    url: s,
                    cache: !1,
                    dataType: "html",
                    beforeSend: function () {
                        a.hasClass("template-cart");
                    },
                    success: function (t2) {
                        u.html(t2),
                            u
                                .find("[data-template-cart-edit]")
                                .attr({ "data-cart-update-id": r, "data-line": c, "data-index": l }),
                            u.find(".product-edit-item").find('input[name="quantity"]').val(d);
                    },
                    error: function (e3, o3) {
                        n.showWarning(t.parseJSON(e3.responseText).description), a.hasClass("template-cart");
                    },
                    complete: function () {
                        a.addClass("edit-cart-show"),
                            a.hasClass("template-cart"),
                            n.checkNeedToConvertCurrency() &&
                                Currency.convertAll(
                                    window.shop_currency,
                                    t("#currencies .active").attr("data-currency"),
                                    "span.money",
                                    "money_format"
                                ),
                            t("body").hasClass("cursor-fixed__show") &&
                                (window.sharedFunctionsAnimation.onEnterButton(),
                                window.sharedFunctionsAnimation.onLeaveButton());
                    },
                });
            }),
                o.on("click", "[data-close-edit-cart]", (t2) => {
                    t2.preventDefault(), t2.stopPropagation(), a.removeClass("edit-cart-show");
                }),
                o.on("click", (e3) => {
                    a.hasClass("edit-cart-show") &&
                        t(e3.target).closest("[data-edit-cart-popup]").length === 0 &&
                        t(e3.target).closest("[data-open-edit-cart]").length === 0 &&
                        a.removeClass("edit-cart-show");
                }),
                n.addMoreItemEditCart(),
                n.addAllItemCartEdit();
        },
        addMoreItemEditCart: function () {
            o.on("click", "[data-edit-cart-add-more]", (e2) => {
                e2.preventDefault(), e2.stopPropagation();
                var a2 = t("[data-template-cart-edit]"),
                    o2 = t(e2.target).parents(".product-edit-item"),
                    i2 = parseInt(a2.attr("data-count")),
                    s = o2.clone().removeClass("product-edit-itemFirst");
                (cloneProductId = s.attr("id") + i2),
                    s.attr("id", cloneProductId),
                    n.updateClonedProductAttributes(s, i2),
                    s.insertAfter(o2),
                    (i2 += 1),
                    a2.attr("data-count", i2),
                    t("body").hasClass("cursor-fixed__show") &&
                        (window.sharedFunctionsAnimation.onEnterButton(),
                        window.sharedFunctionsAnimation.onLeaveButton());
            }),
                o.on("click", "[data-edit-cart-remove]", (e2) => {
                    e2.preventDefault(), e2.stopPropagation(), t(e2.target).parents(".product-edit-item").remove();
                });
        },
        updateClonedProductAttributes: function (e2, a2) {
            var o2 = t(".shopify-product-form", e2),
                i2 = o2.attr("id") + a2;
            o2.attr("id", i2),
                t(".product-form__radio", e2).each((e3, o3) => {
                    var i3 = t(o3),
                        n2 = i3.next(),
                        s = n2.attr("for") + a2,
                        r = i3.attr("name");
                    n2.attr("for", s), i3.attr({ id: s, name: r + a2 });
                });
        },
        addAllItemCartEdit: function () {
            o.on("click", "#add-all-to-cart", (e2) => {
                e2.preventDefault(), e2.stopPropagation();
                var o2 = t(e2.currentTarget),
                    i2 = t("[data-template-cart-edit]"),
                    s = i2.find(".product-edit-item.isChecked"),
                    r = (i2.attr("data-cart-update-id"), i2.data("line")),
                    c = i2.data("index");
                s.length > 0
                    ? (o2.addClass("is-loading"),
                      Shopify.removeItem(r, c, (e3) => {
                          if (!t.isEmptyObject(e3)) {
                              var i3 = [];
                              s.each((e4, a2) => {
                                  var o3,
                                      n2 = t(a2),
                                      s2 = n2.find('input[name="id"]').val(),
                                      r2 = parseInt(n2.find('input[name="quantity"]').val());
                                  i3.push(
                                      ((o3 = {
                                          type: "post",
                                          url: window.routes.root + "/cart/add.js",
                                          data: "quantity=" + r2 + "&id=" + s2,
                                          dataType: "json",
                                          async: !1,
                                      }),
                                      t.ajax(o3))
                                  );
                              }),
                                  i3.length > 0 &&
                                      t.when.apply(t, i3).done((t2) => {
                                          setTimeout(function () {
                                              o2.removeClass("is-loading");
                                          }, 1e3),
                                              Shopify.getCart((t3) => {
                                                  a.removeClass("edit-cart-show"),
                                                      a.hasClass("template-cart")
                                                          ? n.updateCart(t3)
                                                          : a.hasClass("cart-modal-show") ||
                                                            (a.hasClass("cart-sidebar-show") &&
                                                                n.updateSidebarCart(t3));
                                              });
                                      });
                          }
                      }))
                    : alert(window.variantStrings.addToCart_message);
            });
        },
        initNotifyInStock: function () {
            o.on("click", "[data-open-notify-popup]", (e2) => {
                e2.preventDefault(), e2.stopPropagation();
                var a2 = t(e2.currentTarget);
                n.notifyInStockPopup(a2);
            }),
                o.on("click", "[data-close-notify-popup]", (e2) => {
                    e2.preventDefault(),
                        e2.stopPropagation(),
                        a.removeClass("notify-me-show"),
                        setTimeout(() => {
                            t(".halo-notify-popup .form-field").removeClass("hidden"),
                                t(".halo-notify-popup .form-message").addClass("hidden");
                        }, 700);
                }),
                o.on("click", (e2) => {
                    a.hasClass("notify-me-show") &&
                        t(e2.target).closest("[data-open-notify-popup]").length === 0 &&
                        t(e2.target).closest("[data-notify-popup]").length === 0 &&
                        (a.removeClass("notify-me-show"),
                        setTimeout(() => {
                            t(".halo-notify-popup .form-field").removeClass("hidden"),
                                t(".halo-notify-popup .form-message").addClass("hidden");
                        }, 700));
                });
        },
        notifyInStockPopup: function (e2) {
            var o2,
                i2 = e2.parents(".product-item"),
                n2 = i2.find(".card-title").data("product-title"),
                s = window.location.host + i2.find(".card-title").data("product-url"),
                r = t("[data-notify-popup]");
            (o2 = e2.hasClass("is-notify-me")
                ? i2.find(".card-swatch .swatch-label.is-active").attr("title")
                : e2.data("variant-id")),
                r.find(".halo-notify-product-title").val(t.trim(n2)),
                r.find(".halo-notify-product-link").val(s),
                o2 && r.find(".halo-notify-product-variant").val(o2),
                a.addClass("notify-me-show");
        },
        initAskAnExpert: function () {
            o.on("click", "[data-open-ask-an-expert]", (e2) => {
                e2.preventDefault(), e2.stopPropagation();
                var o2,
                    i2 = t("[data-ask-an-expert-popup]").find(".halo-popup-content");
                if (a.hasClass("template-product")) {
                    var n2 = t(".productView").data("product-handle");
                    o2 = window.routes.root + "/products/" + n2 + "?view=ajax_ask_an_expert";
                } else
                    a.hasClass("quick-view-show")
                        ? ((n2 = t(".halo-quickView").data("product-quickview-handle")),
                          (o2 = window.routes.root + "/products/" + n2 + "?view=ajax_ask_an_expert"))
                        : (o2 = window.routes.root + "/search?view=ajax_ask_an_expert");
                t.ajax({
                    type: "get",
                    url: o2,
                    beforeSend: function () {
                        i2.empty();
                    },
                    success: function (t2) {
                        i2.html(t2);
                    },
                    error: function (e3, a2) {
                        alert(t.parseJSON(e3.responseText).description);
                    },
                    complete: function () {
                        a.addClass("ask-an-expert-show");
                    },
                });
            }),
                o.on("click", "[data-close-ask-an-expert]", (t2) => {
                    t2.preventDefault(),
                        t2.stopPropagation(),
                        a.removeClass("ask-an-expert-show"),
                        a.hasClass("recently-popup-mb-show") && a.removeClass("recently-popup-mb-show");
                }),
                o.on("click", (e2) => {
                    a.hasClass("ask-an-expert-show") &&
                        t(e2.target).closest("[data-open-ask-an-expert]").length === 0 &&
                        t(e2.target).closest("#halo-ask-an-expert-popup").length === 0 &&
                        a.removeClass("ask-an-expert-show");
                });
        },
        resetForm: function (e2) {
            t(".form-field", e2).removeClass("form-field--success form-field--error"),
                t("input[type=email], input[type=text], textarea", e2).val("");
        },
        formMessage: function () {
            const e2 = window.location.href.indexOf("form_type=contact") > -1;
            if (window.location.href.indexOf("contact_posted=true") > -1 || e2) {
                const o2 = t(`[data-form-message="${t.cookie("contact_form")}"]`);
                let i2 = 400;
                switch ((a.hasClass("template-product") && (i2 = 1600), o2.data("form-message"))) {
                    case "ask":
                        setTimeout(() => {
                            a.addClass("ask-an-expert-show");
                        }, i2),
                            this.changeStateforContactForm(o2, e2),
                            t(".halo-notify-popup .form-message").addClass("hidden");
                        break;
                    case "contact":
                        o2.removeClass("hidden"),
                            this.changeStateforContactForm(o2, e2),
                            t(".halo-notify-popup .form-message").addClass("hidden");
                        break;
                    case "notifyMe":
                        t(".halo-notify-popup .form-field").addClass("hidden"),
                            setTimeout(() => {
                                a.addClass("notify-me-show");
                            }, i2),
                            this.changeStateforContactForm(o2, e2);
                }
            }
            t(document).on("click", "[data-button-message]", (e3) => {
                t.cookie("contact_form", t(e3.target).data("button-message"), { expires: 1, path: "/" });
            });
        },
        changeStateforContactForm(e2, a2) {
            window.history.pushState("object", document.title, location.href.split("?")[0]),
                a2 &&
                    (t(".newsletter-form__message--error").addClass("hidden"),
                    t("html, body").animate({ scrollTop: e2.offset().top - window.innerHeight / 2 }, 700));
        },
        initCompareProduct: function () {
            var e2 = t("[data-compare-link]");
            window.compare.show &&
                (n.setLocalStorageProductForCompare(e2),
                n.setAddorRemoveProductForCompare(e2),
                n.setProductForCompare(),
                o.on("click", "[data-close-compare-product-popup]", (t2) => {
                    t2.preventDefault(), t2.stopPropagation(), a.removeClass("compare-product-show");
                }),
                o.on("click", (e3) => {
                    a.hasClass("compare-product-show") &&
                        t(e3.target).closest("[data-compare-link]").length === 0 &&
                        t(e3.target).closest("[data-compare-product-popup]").length === 0 &&
                        a.removeClass("compare-product-show");
                }));
        },
        setLocalStorageProductForCompare: function (e2) {
            var a2 = JSON.parse(localStorage.getItem("compareItem")),
                o2 = t("[data-product-compare-handle]");
            a2 !== null &&
                o2.length > 0 &&
                (o2.each((e3, o3) => {
                    var i2 = t(o3),
                        n2 = i2.data("product-compare-handle");
                    a2.indexOf(n2) >= 0
                        ? (i2.find(".compare-icon").addClass("is-checked"),
                          i2.find(".text").text(window.compare.added),
                          i2.find("input").prop("checked", !0))
                        : (i2.find(".compare-icon").removeClass("is-checked"),
                          i2.find(".text").text(window.compare.add),
                          i2.find("input").prop("checked", !1));
                }),
                n.updateCounterCompare(e2));
        },
        setAddorRemoveProductForCompare: function (e2) {
            o.on("change", "[data-product-compare] input", (a2) => {
                var o2 = t(a2.currentTarget),
                    i2 = o2.parents(".card-compare"),
                    s = o2.val(),
                    r = JSON.parse(localStorage.getItem("compareItem"));
                (r = n.uniqueArray(r)),
                    a2.currentTarget.checked
                        ? (i2.find(".compare-icon").addClass("is-checked"),
                          i2.find(".text").text(window.compare.added),
                          i2.find("input").prop("checked", !0),
                          n.incrementCounterCompare(r, s, e2))
                        : (i2.find(".compare-icon").removeClass("is-checked"),
                          i2.find(".text").text(window.compare.add),
                          i2.find("input").prop("checked", !1),
                          n.decrementCounterCompare(r, s, e2));
            });
        },
        setProductForCompare: function () {
            o.on("click", "[data-compare-link]", (t2) => {
                t2.preventDefault(), t2.stopPropagation();
                var e2 = JSON.parse(localStorage.getItem("compareItem"));
                if (e2.length <= 1) return alert(window.compare.message), !1;
                n.updateContentCompareProduct(e2, 0);
            }),
                o.on("click", "[data-compare-remove]", (e2) => {
                    e2.preventDefault(), e2.stopPropagation();
                    var o2 = t(e2.currentTarget).data("compare-item"),
                        i2 = t("[data-compare-product-popup] .compareTable"),
                        s = i2.find('.compareTable-row[data-product-compare-id="' + o2 + '"]'),
                        r = s.data("compare-product-handle");
                    if (i2.find("tbody .compareTable-row").length == 1) {
                        s.remove();
                        var c = (d = JSON.parse(localStorage.getItem("compareItem"))).indexOf(r),
                            l = t("[data-compare-link]");
                        c > -1 &&
                            (d.splice(c, 1),
                            (d = n.uniqueArray(d)),
                            localStorage.setItem("compareItem", JSON.stringify(d)),
                            n.setLocalStorageProductForCompare(l),
                            n.updateCounterCompare(l)),
                            a.removeClass("compare-product-show");
                    } else {
                        s.remove();
                        var d;
                        (c = (d = JSON.parse(localStorage.getItem("compareItem"))).indexOf(r)),
                            (l = t("[data-compare-link]")),
                            c > -1 &&
                                (d.splice(c, 1),
                                (d = n.uniqueArray(d)),
                                localStorage.setItem("compareItem", JSON.stringify(d)),
                                n.setLocalStorageProductForCompare(l),
                                n.updateCounterCompare(l));
                    }
                });
        },
        updateCounterCompare: function (t2) {
            var e2 = JSON.parse(localStorage.getItem("compareItem"));
            e2.length > 1
                ? (t2.parent().addClass("is-show"), t2.find("span.countPill").html(e2.length))
                : t2.parent().removeClass("is-show");
        },
        uniqueArray: function (e2) {
            var a2 = [];
            return (
                t.each(e2, function (e3, o2) {
                    t.inArray(o2, a2) == -1 && a2.push(o2);
                }),
                a2
            );
        },
        incrementCounterCompare: function (t2, e2, a2) {
            t2.indexOf(e2),
                t2.push(e2),
                (t2 = n.uniqueArray(t2)),
                localStorage.setItem("compareItem", JSON.stringify(t2)),
                n.updateCounterCompare(a2);
        },
        decrementCounterCompare: function (t2, e2, a2) {
            const o2 = t2.indexOf(e2);
            o2 > -1 &&
                (t2.splice(o2, 1),
                (t2 = n.uniqueArray(t2)),
                localStorage.setItem("compareItem", JSON.stringify(t2)),
                n.updateCounterCompare(a2));
        },
        updateContentCompareProduct: function (e2, o2) {
            const i2 = t("[data-compare-product-popup] .compareTable"),
                s = window.routes.root + "/products/" + e2[o2] + "?view=ajax_product_card_compare";
            o2 == 0 && i2.find("tbody").empty(),
                e2.length > o2
                    ? t.ajax({
                          type: "get",
                          url: s,
                          cache: !1,
                          success: function (t2) {
                              i2.find("tbody").append(t2), o2++, n.updateContentCompareProduct(e2, o2);
                          },
                      })
                    : a.addClass("compare-product-show"),
                t("body").hasClass("cursor-fixed__show") &&
                    (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
        },
        initProductView: function (t2) {
            n.productImageGallery(t2),
                n.productLastSoldOut(t2),
                n.productCustomerViewing(t2),
                n.productCountdown(t2),
                n.productSizeChart(t2),
                n.productCustomCursor(t2),
                n.productVideoGallery(t2),
                n.initVariantImageGroup(t2, window.variant_image_group);
        },
        initQuickView: function () {
            if (window.__fiabilaQuickViewBound) return;
            window.__fiabilaQuickViewBound = !0;
            let e2 = !1;
            const ensureQuickViewAssetsLoaded = () => {
                if (e2) return !0;
                const t2 = document.querySelector(".halo-quick-view-popup");
                if (!t2) return !1;
                e2 = !0;
                const a3 = t2.dataset.urlStyleProduct,
                    o3 = t2.dataset.urlStyleQuickView,
                    i2 = t2.dataset.urlVariantsQuickView;
                document.body.matches(".qs3-loaded") || n.buildStyleSheet(a3, t2),
                    n.buildStyleSheet(o3, t2),
                    n.buildScript(i2),
                    document.body.classList.add("qv-loaded"),
                    document.body.matches(".sortable-loader") ||
                        (document.body.classList.add("sortable-loader"),
                        n.buildScript("https://cdn.jsdelivr.net/npm/sortablejs@latest/Sortable.min.js"));
                return !0;
            };
            const getProductHandle = (target) =>
                target?.getAttribute?.("data-product-handle") ||
                t(target).data("productHandle") ||
                t(target).data("product-handle");
            window.fiabilaOpenQuickView = (handle) => {
                if (!handle || !ensureQuickViewAssetsLoaded()) return;
                n.updateContentQuickView(handle);
            };
            o.on("click", "[data-open-quick-view-popup]", (a2) => {
                a2.preventDefault(), a2.stopPropagation();
                const o2 = getProductHandle(a2.currentTarget);
                if (o2) window.fiabilaOpenQuickView(o2);
            }),
                o.on("click", "[data-close-quick-view-popup]", (t2) => {
                    t2.preventDefault(), t2.stopPropagation(), a.removeClass("quick-view-show");
                }),
                t(".background-overlay")
                    .off("click.closeQuickView")
                    .on("click.closeQuickView", (t2) => {
                        !a.hasClass("quick-view-show") ||
                            a.hasClass("cart-sidebar-show") ||
                            a.hasClass("ask-an-expert-show") ||
                            a.hasClass("size-chart-show") ||
                            a.hasClass("compare-color-show") ||
                            a.hasClass("term-condition-show") ||
                            a.removeClass("quick-view-show");
                    });
        },
        updateContentQuickView: function (e2) {
            var o2 = t("[data-quick-view-popup]"),
                i2 = o2.find(".halo-popup-content");
            t.ajax({
                type: "get",
                url: window.routes.root + "/products/" + e2 + "?view=ajax_quick_view",
                beforeSend: function () {
                    i2.empty(), t("#halo-quickshop-popup-option-3").find(".halo-popup-content").empty();
                },
                success: function (t2) {
                    i2.html(t2);
                },
                error: function (e3, a2) {
                    alert(t.parseJSON(e3.responseText).description);
                },
                complete: function () {
                    var i3 = o2.find(".quickView");
                    const s = t(".halo-popup-content .halo-compare-color-popup li.item"),
                        r = t(".halo-popup-content .halo-compare-color-popup #sortTableList"),
                        c = t(".halo-popup-content .halo-compare-color-popup"),
                        l = t(".halo-popup-content .halo-size-chart-popup");
                    a.addClass("quick-view-show");
                    n.productImageGallery(i3);
                    requestAnimationFrame(function () {
                        i3.find(".productView-nav.slick-initialized, .productView-for.slick-initialized").each(
                            function () {
                                try {
                                    t(this).slick("setPosition");
                                } catch (e3) {}
                            }
                        );
                        i3.find(".productView-nav, .productView-for").each(function () {
                            const $slider = t(this);
                            $slider.find(".slick-next").slice(1).remove();
                            $slider.find(".slick-prev").slice(1).remove();
                        });
                    });
                    n.productLastSoldOut(i3);
                    n.productCustomerViewing(i3);
                    n.productCountdown(i3);
                    n.productSizeChart(i3);
                    n.setProductForWishlist(e2);
                    n.initVariantImageGroup(i3, window.variant_image_group_quick_view);
                    window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init();
                    r.attr("id", "quickViewSortTableList");
                    s.each((e3, a2) => {
                        const o3 = t(a2).find(".swatch-compare-color-option"),
                            i4 = t(a2).find(".swatch-compare-color-label"),
                            n2 = o3.attr("id");
                        o3.attr("id", `quickView-${n2}`).attr("name", `quickView-${n2}`),
                            i4.attr("for", `quickView-${n2}`);
                    });
                    c.attr("id", "quickView-halo-compare-color-popup");
                    l.attr("id", "quickView-halo-size-chart-popup");
                    if (t(".halo-productView .addthis_inline_share_toolbox").length) {
                        var d = t(".halo-productView .addthis_inline_share_toolbox").html();
                        t(".halo-popup-content .share-button__button").click(function () {
                            t(".halo-popup-content .addthis_inline_share_toolbox").append(d);
                        });
                    }
                    const u = document.getElementById("quickViewSortTableList"),
                        p = t(".halo-popup-content .halo-compareColors-image");
                    window.innerWidth >= 1025 && u
                        ? new Sortable(u, { animation: 150 })
                        : p.on("click", ".item", (e3) => {
                              e3.preventDefault();
                              var a2 = `swatch-compare-color-${e3.currentTarget.classList[1].replace("item-", "")}`;
                              t(document.getElementById(a2)).trigger("click");
                          });
                    t("body").hasClass("cursor-fixed__show") &&
                        (window.sharedFunctionsAnimation.onEnterButton(),
                        window.sharedFunctionsAnimation.onLeaveButton());
                },
            });
        },
        productImageGallery: function (a2) {
            var o2 = a2.find(".productView-nav"),
                s = a2.find('.productView-for:not(".mobile")'),
                r = a2.find(".productView-for.mobile"),
                isQuickView = a2.hasClass("quickView") || a2.closest(".halo-quick-view-popup").length > 0;
            o2.find(".slider-prev, .slider-next, .slider-dots").remove();
            if (!s.hasClass("slick-initialized") && !o2.hasClass("slick-initialized")) {
                const f2 = o2.data("arrows-desk"),
                    v2 = o2.data("arrows-mobi"),
                    g = o2.data("counter-mobi"),
                    b = o2.data("media-count"),
                    C = parseInt(s.data("max-thumbnail-to-show"));
                const thumbArrows = !isQuickView;
                let y, k, _;
                var c;
                (e = o2.html()),
                    (_ = o2.hasClass("productView-nav-gallery") ? Math.round(b / 2) : b),
                    (_ = o2.hasClass("productView-horizontal-tabs") && b == 2 ? 1 : b);
                let S =
                    `<div class="slick-counter">
                    <span class="slick-counter--current">1</span>
                    <span aria-hidden="true">/</span>
                    <span class="slick-counter--total">` +
                    _ +
                    `</span>
                </div>`;
                const x = () => {
                        setTimeout(() => {
                            let e2 = t(".productView-nav .slick-slide").length;
                            o2.hasClass("productView-nav-gallery") && (e2 = Math.round(e2 / 2)),
                                (S =
                                    `<div class="slick-counter">
                            <span class="slick-counter--current">1</span>
                            <span aria-hidden="true">/</span>
                            <span class="slick-counter--total">` +
                                    e2 +
                                    `</span>
                        </div>`);
                        }, 1e3);
                    },
                    T = () => {
                        clearTimeout(c),
                            (c = setTimeout(() => {
                                o2.append(S);
                            }, 1e3));
                    };
                if (
                    (o2.on("init", () => {
                        window.innerWidth < 768 &&
                            g &&
                            (variant_image_group && x(),
                            T(),
                            o2.on("reInit afterChange", function (t2, e2, a3, i2) {
                                var n2 = (a3 || 0) + 1;
                                o2.find(".slick-counter--current").text(n2);
                            }));
                    }),
                    o2.on("reInit", () => {
                        window.innerWidth < 768 && g && (variant_image_group && x(), T());
                    }),
                    (k = !o2.closest(".productView").is(".layout-4") && s),
                    o2.hasClass("productView-nav-gallery"))
                ) {
                    var l = (p = a2.find(".productView-nav.productView-nav-gallery")).data("media-count"),
                        d = 2,
                        u = 2;
                    l == 1 && ((d = 1), (u = 1)),
                        l == 2 && ((d = 2), (u = 1)),
                        p.data("1-item-mobi") && window.innerWidth < 551 && ((d = 1), (u = 1)),
                        p.slick({
                            dots: !0,
                            rows: u,
                            arrows: f2,
                            infinite: !0,
                            slidesPerRow: 1,
                            slidesToShow: d,
                            focusOnSelect: !1,
                            asNavFor: k,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [{ breakpoint: 767, settings: { arrows: v2 } }],
                        }),
                        (y = p);
                } else if (o2.hasClass("productView-horizontal-tabs")) {
                    var p;
                    (d = 2),
                        (u = 1),
                        (p = a2.find(".productView-nav.productView-horizontal-tabs")).slick({
                            dots: !0,
                            rows: u,
                            arrows: f2,
                            infinite: !1,
                            slidesPerRow: 1,
                            slidesToShow: d,
                            focusOnSelect: !1,
                            asNavFor: k,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [{ breakpoint: 767, settings: { arrows: v2 } }],
                        }),
                        (y = p);
                } else
                    !o2.is(".style-2, .style-3") || window.innerWidth < 768
                        ? (o2.slick({
                              fade: !o2.hasClass("image-fit-unset"),
                              dots: !1,
                              arrows: isQuickView ? window.innerWidth < 768 : f2,
                              infinite: !0,
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              adaptiveHeight: o2.hasClass("image-fit-unset"),
                              asNavFor: k,
                              nextArrow: window.arrows.icon_next,
                              prevArrow: window.arrows.icon_prev,
                              rtl: window.rtl_slick,
                              responsive: [{ breakpoint: 768, settings: { arrows: v2 } }],
                          }),
                          o2.hasClass("image-fit-unset") &&
                              o2.on("init reInit afterChange", function () {
                                  try {
                                      t(this).slick("setPosition");
                                  } catch (e4) {}
                              }),
                          (y = o2))
                        : (y = !1);
                if (
                    (a2.hasClass("layout-1") || a2.hasClass("layout-2")
                        ? (s.on("init", (t2, e2) => {
                              s.find(".animated-loading").removeClass("animated-loading");
                          }),
                          s.slick({
                              slidesToShow: C,
                              slidesToScroll: 1,
                              asNavFor: y,
                              arrows: thumbArrows,
                              dots: !1,
                              draggable: !1,
                              adaptiveHeight: !1,
                              focusOnSelect: !0,
                              vertical: !0,
                              verticalSwiping: !0,
                              infinite: !0,
                              nextArrow: window.arrows.icon_next,
                              prevArrow: window.arrows.icon_prev,
                              responsive: [
                                  {
                                      breakpoint: 1600,
                                      settings: { slidesToShow: C > 3 ? C - 1 : C, slidesToScroll: 1 },
                                  },
                                  {
                                      breakpoint: 1280,
                                      settings: { vertical: !1, verticalSwiping: !1, rtl: window.rtl_slick },
                                  },
                                  {
                                      breakpoint: 767,
                                      settings: {
                                          slidesToShow: 3,
                                          slidesToScroll: 1,
                                          vertical: !1,
                                          verticalSwiping: !1,
                                          rtl: window.rtl_slick,
                                      },
                                  },
                              ],
                          }))
                        : a2.hasClass("layout-3") &&
                          (s.on("init", (t2, e2) => {
                              s.find(".animated-loading").removeClass("animated-loading");
                          }),
                          s.slick({
                              slidesToShow: C,
                              slidesToScroll: 1,
                              asNavFor: y,
                              arrows: thumbArrows,
                              dots: !1,
                              focusOnSelect: !0,
                              infinite: !0,
                              nextArrow: window.arrows.icon_next,
                              prevArrow: window.arrows.icon_prev,
                              rtl: window.rtl_slick,
                              responsive: [
                                  {
                                      breakpoint: 1600,
                                      settings: { slidesToShow: C > 3 ? C - 1 : C, slidesToScroll: 1 },
                                  },
                                  { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                              ],
                          })),
                    r.on("init", (t2, e2) => {
                        r.find(".animated-loading").removeClass("animated-loading");
                    }),
                    r.slick({
                        slidesToShow: parseInt(r.data("max-thumbnail-to-show")),
                        slidesToScroll: 1,
                        asNavFor: y,
                        arrows: thumbArrows,
                        dots: !1,
                        draggable: !1,
                        adaptiveHeight: !1,
                        focusOnSelect: !0,
                        vertical: !0,
                        verticalSwiping: !0,
                        infinite: !0,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            { breakpoint: 1600, settings: { slidesToShow: C > 3 ? C - 1 : C, slidesToScroll: 1 } },
                            { breakpoint: 1280, settings: { vertical: !1, verticalSwiping: !1 } },
                            {
                                breakpoint: 767,
                                settings: { slidesToShow: 2.2, slidesToScroll: 1, vertical: !1, verticalSwiping: !1 },
                            },
                        ],
                    }),
                    a2.hasClass("layout-1") || a2.hasClass("layout-2"))
                ) {
                    var h = s.outerHeight(),
                        m = (o2.outerHeight() - h) / 2,
                        w = m + 80;
                    i.width() > 1279
                        ? s.find(".slick-arrow").length > 0
                            ? (s.parent().addClass("arrows-visible"), s.parent().css("top", m))
                            : (s.parent().addClass("arrows-disable"), s.parent().css("top", w))
                        : s.find(".slick-arrow").length > 0
                          ? s.parent().css("top", "unset")
                          : s.parent().css("top", w);
                }
                if (o2.find("[data-youtube]").length > 0)
                    if (window.onYouTubeIframeAPIReady === void 0) {
                        window.onYouTubeIframeAPIReady = n.initYoutubeCarousel.bind(window, o2);
                        const t2 = document.createElement("script");
                        t2.src = "https://www.youtube.com/player_api";
                        const e2 = document.getElementsByTagName("script")[0];
                        e2.parentNode.insertBefore(t2, e2);
                    } else n.initYoutubeCarousel(o2);
                o2.find("[data-vimeo]").length > 0 &&
                    (o2.on("beforeChange", (e2, a3) => {
                        var o3, i2;
                        (i2 = { method: "pause", value: "true" }),
                            (o3 = t(a3.$slider).find(".slick-current").find("iframe").get(0)) != null &&
                                o3.contentWindow.postMessage(JSON.stringify(i2), "*");
                    }),
                    o2.on("afterChange", (e2, a3) => {
                        var o3, i2;
                        (i2 = { method: "play", value: "true" }),
                            (o3 = t(a3.$slider).find(".slick-current").find("iframe").get(0)) != null &&
                                o3.contentWindow.postMessage(JSON.stringify(i2), "*");
                    })),
                    o2.find("[data-mp4]").length > 0 &&
                        (o2.on("beforeChange", (e2, a3) => {
                            var o3;
                            (o3 = t(a3.$slider).find(".slick-current").find("video").get(0)) != null && o3.pause();
                        }),
                        o2.on("afterChange", (e2, a3) => {
                            var o3;
                            (o3 = t(a3.$slider).find(".slick-current").find("video").get(0)) != null && o3.play();
                        }));
            }
            var f = a2.find("[data-fancybox]");
            f.length > 0 &&
                f.fancybox({
                    buttons: ["zoom", "share", "slideShow", "fullScreen", "thumbs", "close"],
                    loop: !0,
                    thumbs: { autoStart: !0 },
                });
            var v = a2.find("[data-zoom-image]");
            i.width() > 1024 &&
                v.each((e2, a3) => {
                    var o3 = t(a3);
                    i.width() > 1024
                        ? o3.zoom({ url: o3.attr("data-zoom-image"), touch: !1 })
                        : o3.trigger("zoom.destroy");
                }),
                i.on("resize", () => {
                    (a2.hasClass("layout-1") || a2.hasClass("layout-2")) &&
                        (i.width() > 1279
                            ? setTimeout(() => {
                                  if (s.find(".slick-arrow").length > 0) {
                                      var t2 = s.outerHeight(),
                                          e2 = (o2.outerHeight() - t2) / 2;
                                      s.parent().addClass("arrows-visible"), s.parent().css("top", e2);
                                  } else s.parent().addClass("arrows-disable");
                              }, 200)
                            : setTimeout(() => {
                                  s.find(".slick-arrow").length > 0 && s.parent().css("top", "unset");
                              }, 200));
                });
        },
        productVideoGallery: function (e2) {
            const o2 = e2.find("[data-video-thumbnail]").length,
                n2 = t(".productView-video").length;
            if (o2) {
                const o3 = e2.find(".productView-image-wrapper"),
                    s = t("[data-popup-video]"),
                    r = e2.find(".productView-nav");
                let c = o3.offset().top + o3.outerHeight();
                n2 && a.addClass("has-product-video"),
                    i.on("scroll", (o4) => {
                        const i2 = t(o4.currentTarget),
                            n3 = e2.find(".slick-current .productView-video"),
                            l = n3.data("type"),
                            d = n3.data("video-url");
                        if (d != null)
                            if (i2.scrollTop() > c) {
                                if (!s.is(".is-show")) {
                                    const t2 = r.find(".slick-slide.slick-active").data("youtube-player"),
                                        e3 = parseInt(t2.getCurrentTime()),
                                        o5 = `<div class="fluid-width-video-wrapper" style="padding-top: 56.24999999999999%">
                                                    ${
                                                        l == "youtube"
                                                            ? `<iframe
                                                            id="player"
                                                            type="text/html"
                                                            width="100%"
                                                            frameborder="0"
                                                            webkitAllowFullScreen
                                                            mozallowfullscreen
                                                            allowFullScreen
                                                            src="https://www.youtube.com/embed/${d}?autoplay=1&mute=1&start=${e3}">
                                                        </iframe>`
                                                            : `<iframe 
                                                            src="https://player.vimeo.com/video/${d}?autoplay=1&mute=1" 
                                                            class="js-vimeo" 
                                                            allow="autoplay; 
                                                            encrypted-media" 
                                                            webkitallowfullscreen 
                                                            mozallowfullscreen 
                                                            allowfullscreen">
                                                        </iframe>`
                                                    }
                                                </div>`;
                                    s.addClass("is-show"),
                                        s.find(".halo-popup-content").html(o5),
                                        a.addClass("video-show product-video-show"),
                                        t2.pauseVideo();
                                }
                            } else {
                                const t2 = r.find(".slick-slide.slick-active").data("youtube-player");
                                s.removeClass("is-show"),
                                    s.find(".halo-popup-content").empty(),
                                    a.removeClass("video-show product-video-show"),
                                    t2.playVideo();
                            }
                    });
            }
        },
        initVariantImageGroup: function (a2, i2 = !1) {
            if (i2) {
                var s,
                    r = a2.find("[data-filter]:checked"),
                    c = a2.find(".productView-for"),
                    l = a2.find(".productView-nav"),
                    d = a2.find(".productView-product .productView-options"),
                    u = a2.find("[data-filter]:checked").data("metafields-vig");
                switch (!0) {
                    case l.hasClass("productView-nav-gallery"):
                        s = "gallery";
                        break;
                    case l.closest(".product-full-width").length == 1 || l.closest(".product-full-width-2").length == 1:
                        s = "full-width";
                        break;
                    default:
                        s = "default";
                }
                const i3 = () => {
                        c.slick("slickUnfilter"),
                            (s == "full-width" && window.innerWidth > 767) ||
                                (l.hasClass("slick-filter") && l.find(".slick-counter").remove(),
                                l.slick("slickUnfilter").removeClass("slick-filter"));
                    },
                    p = (a3) => {
                        switch (s) {
                            case "gallery":
                                l.slick("unslick")
                                    .empty()
                                    .html(e)
                                    .find(".productView-image")
                                    .each(function () {
                                        t(this).is(a3) || t(this).remove();
                                    });
                                const o2 = l.data("arrows-desk"),
                                    i4 = l.data("arrows-mobi"),
                                    s2 = l.data("media-count"),
                                    r2 = 2,
                                    d2 = 2;
                                s2 == 1 && ((r2 = 1), (d2 = 1)),
                                    s2 == 2 && ((r2 = 2), (d2 = 1)),
                                    l.data("1-item-mobi") && window.innerWidth < 551 && ((r2 = 1), (d2 = 1)),
                                    l.slick({
                                        dots: !0,
                                        rows: d2,
                                        arrows: o2,
                                        infinite: !0,
                                        slidesPerRow: 1,
                                        slidesToShow: r2,
                                        focusOnSelect: !1,
                                        asNavFor: c,
                                        nextArrow: window.arrows.icon_next,
                                        prevArrow: window.arrows.icon_prev,
                                        rtl: window.rtl_slick,
                                        responsive: [{ breakpoint: 767, settings: { arrows: i4 } }],
                                    }),
                                    t(".cursor-wrapper").length && n.productCustomCursor(t(".halo-productView"));
                                break;
                            case "full-width":
                                if (window.innerWidth > 767) {
                                    let o3 = 1,
                                        i5 = 0;
                                    l.empty().html(e),
                                        e.length &&
                                            (a3.split(",").forEach((t2) => {
                                                e.includes(t2.replace(/\./g, "")) && i5++;
                                            }),
                                            i5 == 0
                                                ? l.removeClass("media-filter")
                                                : (l.addClass("media-filter"),
                                                  l.find(".productView-image").each(function () {
                                                      t(this).is(a3)
                                                          ? (t(this).attr("data-index", o3),
                                                            t(this).find("img").attr("data-index", o3),
                                                            o3++)
                                                          : t(this).remove();
                                                  }))),
                                        t(".cursor-wrapper").length &&
                                            (t(".cursor-wrapper .counter-total").text(
                                                l.find(".productView-image").length
                                            ),
                                            n.productCustomCursor(t(".halo-productView")));
                                    break;
                                }
                            default:
                                l.slick("slickFilter", a3).slick("refresh").addClass("slick-filter");
                        }
                        c && c.slick("slickFilter", a3).slick("refresh");
                    },
                    h = (t2, e2) => {
                        let a3 = t2.split(","),
                            o2 = [];
                        a3.forEach((t3) => {
                            o2.push(`.filter-${t3.toLowerCase().replace(/[^A-Z0-9]/gi, "-")}`);
                        }),
                            e2 && i3(),
                            p(o2.join(","));
                    },
                    m = (t2, e2) => {
                        d.data("lang") != d.data("default-lang") &&
                            e2.data("value-default-lang") &&
                            (t2 = `.filter-${e2.data("value-default-lang")}`),
                            i3(),
                            t2 !== void 0 && (l.find(t2).length || c.find(t2).length || s == "full-width") && p(t2);
                    };
                if (r.length > 0) {
                    let t2 = r.data("filter");
                    u && u.length ? h(u, !1) : m(t2, r);
                }
                o.on("change", "input[data-filter]", (e2) => {
                    let a3 = t(e2.currentTarget).data("filter"),
                        o2 = t(e2.currentTarget).data("metafields-vig");
                    o2 && o2.length ? h(o2, !0) : m(a3, t(e2.currentTarget));
                });
            }
        },
        initYoutubeCarousel: function (e2) {
            e2.each((e3, a2) => {
                const o2 = t(a2);
                o2.find("[data-youtube]").length > 0 &&
                    (o2.addClass("slick-slider--video"), n.initYoutubeCarouselEvent(a2));
            });
        },
        initYoutubeCarouselEvent: function (e2) {
            var a2 = t(e2),
                i2 = a2.find("[data-youtube]");
            function n2(e3) {
                t(e3.target.getIframe()).closest(".slick-slide").data("youtube-player", e3.target),
                    setTimeout(function () {
                        t(e3.target.getIframe()).closest(".slick-slide").hasClass("slick-active") &&
                            (a2.slick("slickPause"), e3.target.playVideo());
                    }, 200);
            }
            function s(t2) {
                t2.data === YT.PlayerState.PLAYING && a2.slick("slickPause"),
                    t2.data === YT.PlayerState.ENDED && a2.slick("slickNext");
            }
            function r() {
                i2.each((e3, a3) => {
                    const o2 = t(a3),
                        i3 = `youtube_player_${Math.floor(100 * Math.random())}`;
                    o2.attr("id", i3),
                        new YT.Player(i3, {
                            host: "http://www.youtube.com",
                            videoId: o2.data("youtube"),
                            wmode: "transparent",
                            playerVars: {
                                autoplay: 0,
                                controls: 0,
                                disablekb: 1,
                                enablejsapi: 1,
                                fs: 0,
                                rel: 0,
                                showinfo: 0,
                                iv_load_policy: 3,
                                modestbranding: 1,
                                wmode: "transparent",
                            },
                            events: { onReady: n2, onStateChange: s },
                        });
                });
            }
            function c() {
                const t2 = a2.find(".slick-slide.slick-active").data("youtube-player");
                t2 && (t2.stopVideo(), a2.removeClass("slick-slider--playvideo"));
            }
            function l() {
                const t2 = a2.find(".slick-slide.slick-active").data("youtube-player");
                t2 && (a2.slick("slickPause"), a2.addClass("slick-slider--playvideo"), t2.playVideo());
            }
            (function () {
                a2.hasClass("slick-initialized") && r(),
                    o.on("init", a2, r),
                    o.on("beforeChange", a2, c),
                    o.on("afterChange", a2, l);
            })();
        },
        productSizeChart: function (e2) {
            window.sizeChart = function () {
                e2.find("[data-open-size-chart-popup]").on("click", (e3) => {
                    e3.preventDefault(),
                        e3.stopPropagation(),
                        document.body.classList.add("size-chart-show"),
                        document.body.classList.contains("quick-view-show")
                            ? t(".halo-popup-content .halo-size-chart-popup").addClass("is-show")
                            : t("#MainContent .halo-size-chart-popup").addClass("is-show");
                }),
                    o.on("click", "[data-close-size-chart-popup]", () => {
                        a.removeClass("size-chart-show"), t(".halo-size-chart-popup").removeClass("is-show");
                    }),
                    o.on("click", (e3) => {
                        a.hasClass("size-chart-show") &&
                            t(e3.target).closest("[data-open-size-chart-popup]").length === 0 &&
                            t(e3.target).closest("[data-size-chart-popup]").length === 0 &&
                            a.removeClass("size-chart-show");
                    });
            };
            var i2 = document.body.classList.contains("quick-view-show"),
                n2 = t(".halo-productView .productView-sizeChart").length;
            document.body.classList.contains("template-product")
                ? ((!i2 && n2) || (i2 && n2 === 0)) && window.sizeChart()
                : window.sizeChart();
        },
        productLastSoldOut: function (t2) {
            var e2 = t2.find("[data-sold-out-product]");
            if (e2.length > 0) {
                var a2 = e2.data("item").toString().split(","),
                    o2 = Math.floor(Math.random() * a2.length),
                    i2 = e2.data("hours").toString().split(","),
                    n2 = Math.floor(Math.random() * i2.length);
                e2.find("[data-sold-out-number]").text(a2[o2]),
                    e2.find("[data-sold-out-hours]").text(i2[n2]),
                    e2.show();
            }
        },
        productCustomerViewing: function (t2) {
            var e2 = t2.find("[data-customer-view]");
            if (e2.length > 0) {
                var a2 = e2.data("customer-view"),
                    o2 = JSON.parse("[" + a2 + "]"),
                    i2 = e2.data("customer-view-time"),
                    n2 = 1e3 * parseInt(i2);
                setInterval(function () {
                    var t3 = Math.floor(Math.random() * o2.length);
                    e2.find(".text").text(window.customer_view.text.replace("[number]", o2[t3]));
                }, n2);
            }
        },
        productCountdown: function (t2) {
            var e2 = t2.find("[data-countdown-id]"),
                a2 = e2.data("countdown"),
                o2 = new Date(a2).getTime(),
                i2 = window.countdown.text;
            if (e2.length > 0)
                var n2 = setInterval(function () {
                    var t3 = new Date().getTime(),
                        a3 = o2 - t3;
                    if (a3 < 0) clearInterval(n2), e2.remove();
                    else {
                        var s,
                            r = Math.floor(a3 / 864e5),
                            c = Math.floor((a3 % 864e5) / 36e5),
                            l = Math.floor((a3 % 36e5) / 6e4),
                            d = Math.floor((a3 % 6e4) / 1e3);
                        (s = e2.is(".style-2, .style-3")
                            ? '<span class="text"><span>' +
                              i2 +
                              '</span></span><span class="num">' +
                              r +
                              "<span>" +
                              window.countdown.day_2 +
                              '</span></span>                                <span class="num">' +
                              c +
                              "<span>" +
                              window.countdown.hour_2 +
                              '</span></span>                                <span class="num">' +
                              l +
                              "<span>" +
                              window.countdown.min_2 +
                              '</span></span>                                <span class="num">' +
                              d +
                              "<span>" +
                              window.countdown.sec_2 +
                              "</span></span>"
                            : '<span class="text"><span>' +
                              i2 +
                              '</span></span><span class="num">' +
                              r +
                              "<span>" +
                              window.countdown.day +
                              '</span></span>                                <span class="num">' +
                              c +
                              "<span>" +
                              window.countdown.hour +
                              '</span></span>                                <span class="num">' +
                              l +
                              "<span>" +
                              window.countdown.min +
                              '</span></span>                                <span class="num">' +
                              d +
                              "<span>" +
                              window.countdown.sec +
                              "</span></span>"),
                            e2.html(s),
                            e2.addClass("show");
                    }
                }, 1e3);
        },
        productCustomCursor: function (e2) {
            if (t(".cursor-wrapper").length == 0) return;
            const { Back: a2 } = window;
            (this.cursorWrapper = document.querySelector(".cursor-wrapper")),
                (this.innerCursor = document.querySelector(".custom-cursor__inner")),
                (this.outerCursor = document.querySelector(".custom-cursor__outer")),
                (this.cursorWrapperBox = this.cursorWrapper.getBoundingClientRect()),
                (this.innerCursorBox = this.innerCursor.getBoundingClientRect()),
                (this.outerCursorBox = this.outerCursor.getBoundingClientRect()),
                document.addEventListener("mousemove", (t2) => {
                    (this.clientX = t2.clientX), (this.clientY = t2.clientY);
                });
            const o2 = () => {
                TweenMax.set(this.cursorWrapper, { x: this.clientX, y: this.clientY }), requestAnimationFrame(o2);
            };
            requestAnimationFrame(o2),
                (this.fullCursorSize = 60),
                (this.enlargeCursorTween = TweenMax.to(this.outerCursor, 0.3, {
                    width: this.fullCursorSize,
                    height: this.fullCursorSize,
                    ease: this.easing,
                    paused: !0,
                }));
            const i2 = () => {
                    this.enlargeCursorTween.play(),
                        t(".cursor-wrapper").addClass("handleMouseEnter").removeClass("handleMouseLeave");
                },
                n2 = () => {
                    this.enlargeCursorTween.reverse(),
                        t(".cursor-wrapper").addClass("handleMouseLeave").removeClass("handleMouseEnter");
                };
            document.querySelectorAll(".productView-image").forEach((t2) => {
                t2?.querySelector(".productView-video") ||
                    (t2.addEventListener("mouseenter", i2), t2.addEventListener("mouseleave", n2));
            }),
                (this.bumpCursorTween = TweenMax.to(this.outerCursor, 0.1, {
                    scale: 0.7,
                    paused: !0,
                    onComplete: () => {
                        TweenMax.to(this.outerCursor, 0.2, { scale: 1, ease: this.easing });
                    },
                })),
                t(document).on("mouseover", "[data-cursor-image]", (e3) => {
                    var a3 = t(e3.currentTarget),
                        o3 = new Array();
                    o3.push(a3.attr("data-index")), t("#count-image").text(o3[0]);
                }),
                (t.fn.isInViewport = function (e3) {
                    var a3 = t(this).offset().top,
                        o3 = a3 + t(this).height(),
                        i3 = t(document).scrollTop(),
                        n3 = i3 + t(window).height();
                    if (e3) {
                        var s = (o3 - i3) / t(this).height();
                        return o3 > i3 && a3 < n3 && s > 0.5;
                    }
                    return o3 > i3 && a3 < n3;
                }),
                (t(".product-full-width").length > 0 || t(".product-full-width-2").length > 0) &&
                    t(window).on("resize scroll", function () {
                        var e3 = new Array();
                        t(".productView-image").each(function () {
                            t(this).isInViewport(!0) &&
                                (e3.push(t(this).attr("data-index")), t("#count-image").text(e3[0]));
                        });
                    });
        },
        initWishlist: function () {
            window.wishlist.show &&
                (n.setLocalStorageProductForWishlist(),
                o.on("click", "[data-wishlist]", (e2) => {
                    e2.preventDefault(),
                        e2.stopPropagation(),
                        t(e2.currentTarget).hasClass("is-in-grid") ||
                            t("[data-wishlist-items-display]").removeClass("is-loaded");
                    var a2 = t(e2.currentTarget),
                        o2 = a2.data("product-id"),
                        i2 = a2.data("wishlist-handle"),
                        s = localStorage.getItem("wishlistItem")
                            ? JSON.parse(localStorage.getItem("wishlistItem"))
                            : [];
                    if (
                        ((index = s.indexOf(i2)),
                        (wishlistContainer = t("[data-wishlist-container]")),
                        (wishlistLayout = wishlistContainer.attr("data-wishlist-layout")),
                        a2.hasClass("wishlist-added"))
                    ) {
                        a2.removeClass("wishlist-added").find(".text").text(window.wishlist.add),
                            wishlistContainer.length > 0 &&
                                t('[data-wishlist-added="wishlist-' + o2 + '"]').length > 0 &&
                                (t('[data-wishlist-added="wishlist-' + o2 + '"]').remove(),
                                t(`[data-wishlist][data-product-id=${o2}]`).closest(".product").remove()),
                            s.splice(index, 1),
                            localStorage.setItem("wishlistItem", JSON.stringify(s));
                        const e3 = new CustomEvent("updatepagination", { bubbles: !0 });
                        if ((document.dispatchEvent(e3), wishlistContainer.length > 0))
                            if (
                                (s = localStorage.getItem("wishlistItem")
                                    ? JSON.parse(localStorage.getItem("wishlistItem"))
                                    : []).length > 0
                            ) {
                                const t2 = new Event("updatewishlistmail", { bubbles: !0 });
                                document.dispatchEvent(t2);
                            } else
                                t("[data-wishlist-container]")
                                    .addClass("is-empty")
                                    .html(
                                        `                                    <div class="wishlist-content-empty text-center">                                        <span class="wishlist-content-text">${window.wishlist.empty}</span>                                        <div class="wishlist-content-actions">                                            <a class="button button-2 button-continue" href="${window.routes.collection_all}">                                                ${window.wishlist.continue_shopping}                                            </a>                                        </div>                                    </div>                                `
                                    ),
                                    t("[data-wishlist-footer]").hide();
                    } else {
                        if (
                            (a2.addClass("wishlist-added").find(".text").text(window.wishlist.added),
                            wishlistContainer.length > 0)
                        ) {
                            const t3 = new CustomEvent("addwishlistitem", { detail: { handle: i2 }, bubbles: !0 });
                            document.dispatchEvent(t3);
                        }
                        s.push(i2), localStorage.setItem("wishlistItem", JSON.stringify(s));
                        const t2 = new CustomEvent("updatewishlistmail", { bubbles: !0 });
                        document.dispatchEvent(t2);
                    }
                    t("[data-wishlist-count]").text(s.length), n.setProductForWishlist(i2);
                }));
        },
        calculateCard06Padding() {
            if (!a.hasClass("product-card-layout-06")) return;
            const t2 = document.querySelector(".card .card-action.card-grid__hidden");
            t2.classList.remove("card-grid__hidden");
            const e2 = t2.scrollHeight;
            document
                .querySelector("[data-wishlist-items-grid-display]")
                .style.setProperty("--card-06-padding", e2 + "px"),
                t2.classList.add("card-grid__hidden");
        },
        setProductForWishlist: function (e2) {
            var a2 = JSON.parse(localStorage.getItem("wishlistItem")),
                o2 = t('[data-wishlist-handle="' + e2 + '"]'),
                i2 = a2?.indexOf(e2);
            i2 != null &&
                a2 != null &&
                (i2 >= 0
                    ? o2.addClass("wishlist-added").find(".text").text(window.wishlist.added)
                    : o2.removeClass("wishlist-added").find(".text").text(window.wishlist.add));
        },
        setLocalStorageProductForWishlist: function () {
            var e2 = localStorage.getItem("wishlistItem") ? JSON.parse(localStorage.getItem("wishlistItem")) : [];
            localStorage.setItem("wishlistItem", JSON.stringify(e2)),
                e2.length > 0 &&
                    (e2 = JSON.parse(localStorage.getItem("wishlistItem"))).forEach((t2) => {
                        n.setProductForWishlist(t2);
                    }),
                t("[data-wishlist-count]").text(e2.length);
        },
        initCountdown: function () {
            var e2 = t("[data-countdown-announcement]"),
                a2 = t("[data-countdown]").not("[data-countdown-id]"),
                o2 = t("[data-countdown-time]");
            e2.length &&
                e2.each(function () {
                    var e3 = t(this),
                        a3 = e3.data("countdown-value"),
                        o3 = new Date(a3).getTime(),
                        i2 = setInterval(function () {
                            var t2 = new Date().getTime(),
                                a4 = o3 - t2;
                            if (a4 < 0)
                                if ((clearInterval(i2), e3.hasClass("hide--countdown"))) e3.remove();
                                else {
                                    const t3 = e3.parents(".announcement-bar__message"),
                                        a5 = e3.parents("[data-announcement-bar]");
                                    a5.is(".slick-initialized")
                                        ? a5.slick("slickRemove", t3.data("slick-index"))
                                        : t3.remove();
                                }
                            else {
                                var n2,
                                    s = Math.floor(a4 / 864e5),
                                    r = `0${Math.floor((a4 % 864e5) / 36e5)}`.slice(-2),
                                    c = `0${Math.floor((a4 % 36e5) / 6e4)}`.slice(-2),
                                    l = `0${Math.floor((a4 % 6e4) / 1e3)}`.slice(-2);
                                (n2 =
                                    '<div class="clock-item"><span class="num">' +
                                    s +
                                    '</span><span class="text">' +
                                    window.countdown.days +
                                    '</span></div>                                            <div class="clock-item"><span class="num">' +
                                    r +
                                    '</span><span class="text">' +
                                    window.countdown.hours +
                                    '</span></div>                                            <div class="clock-item"><span class="num">' +
                                    c +
                                    '</span><span class="text">' +
                                    window.countdown.mins +
                                    '</span></div>                                            <div class="clock-item"><span class="num">' +
                                    l +
                                    '</span><span class="text">' +
                                    window.countdown.secs +
                                    "</span></div>"),
                                    e3.html(n2);
                            }
                        }, 1e3);
                }),
                a2.length &&
                    a2.each(function () {
                        var e3 = t(this),
                            a3 = e3.data("countdown-value"),
                            o3 = new Date(a3).getTime(),
                            i2 = setInterval(function () {
                                var a4 = new Date().getTime(),
                                    n2 = o3 - a4;
                                if (n2 < 0)
                                    clearInterval(i2),
                                        e3.hasClass("hide--countdown")
                                            ? e3.remove()
                                            : e3.parents(".shopify-section").remove();
                                else {
                                    var s = Math.floor(n2 / 864e5),
                                        r = `0${Math.floor((n2 % 864e5) / 36e5)}`.slice(-2),
                                        c = `0${Math.floor((n2 % 36e5) / 6e4)}`.slice(-2),
                                        l = `0${Math.floor((n2 % 6e4) / 1e3)}`.slice(-2),
                                        d = "";
                                    (d = e3.hasClass("product-countdown-block")
                                        ? t(".halo-block-header").hasClass("countdown_style_2")
                                            ? '<div class="clock-item"><span class="num">' +
                                              s +
                                              window.countdown.d +
                                              '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                                              r +
                                              window.countdown.h +
                                              '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                                              c +
                                              window.countdown.m +
                                              '</span><span class="icon">:</span></div>                                                <div class="clock-item"><span class="num">' +
                                              l +
                                              window.countdown.s +
                                              '</span><span class="icon"></span></div>'
                                            : `<div class="clock-item"><span class="num">${s}d&nbsp;</span></div>
                                    <div class="clock-item"><span class="num">${r}:</span></div>
                                    <div class="clock-item"><span class="num">${c}:</span></div>
                                    <div class="clock-item"><span class="num">${l}</span></div>`
                                        : '<div class="clock-item"><span class="num">' +
                                          s +
                                          '</span><span class="text">' +
                                          window.countdown.days +
                                          '</span></div>                                                <div class="clock-item"><span class="num">' +
                                          r +
                                          '</span><span class="text">' +
                                          window.countdown.hours +
                                          '</span></div>                                                <div class="clock-item"><span class="num">' +
                                          c +
                                          '</span><span class="text">' +
                                          window.countdown.mins +
                                          '</span></div>                                                <div class="clock-item"><span class="num">' +
                                          l +
                                          '</span><span class="text">' +
                                          window.countdown.secs +
                                          "</span></div>"),
                                        e3.html(d);
                                }
                            }, 1e3);
                    }),
                o2.length &&
                    o2.each(function () {
                        (function (e3) {
                            const a3 = t(e3),
                                o3 = new Date(a3.data("countdown-time")).getTime(),
                                i2 = setInterval(function () {
                                    const t2 = new Date().getTime(),
                                        e4 = o3 - t2;
                                    if (e4 < 0) clearInterval(i2), a3.remove();
                                    else {
                                        const t3 = Math.floor(e4 / 864e5),
                                            o4 = Math.floor((e4 % 864e5) / 36e5),
                                            i3 = Math.floor((e4 % 36e5) / 6e4),
                                            n2 = Math.floor((e4 % 6e4) / 1e3),
                                            s = `
                          <span class="item pos-relative d-inline-block v-a-top left w-auto">
                            <span class="num dis-i-block">${t3}</span>
                            <span class="dis-block text uppercase">${window.countdown.day}ays</span>
                          </span>
                          <span class="item pos-relative d-inline-block v-a-top left w-auto">
                            <span class="num dis-i-block">${o4}</span>
                            <span class="dis-block text uppercase">${window.countdown.hour}ours</span>
                          </span>
                          <span class="item pos-relative d-inline-block v-a-top left w-auto">
                            <span class="num dis-i-block">${i3}</span>
                            <span class="dis-block text uppercase">${window.countdown.min}ins</span>
                          </span>
                          <span class="item pos-relative d-inline-block v-a-top left w-auto">
                            <span class="num dis-i-block">${n2}</span>
                            <span class="dis-block text uppercase">${window.countdown.sec}econds</span>
                          </span>`;
                                        a3.find(".countdown").html(s),
                                            a3.parent().removeClass("hidden"),
                                            a3.find(".countdown").addClass("show");
                                    }
                                }, 1e3);
                        })(this);
                    });
        },
        collectionCountdown: function () {
            var e2 = t("[data-collection-countdown]");
            e2.length &&
                e2.each(function () {
                    var e3 = t(this),
                        a2 = (t2) => {
                            var e4 = t2.data("collection-countdown-value"),
                                o2 = new Date(e4).getTime(),
                                i2 = (window.countdown.text, o2 - new Date().getTime());
                            if (i2 < 0) clearInterval(a2), t2.hasClass("hide--countdown") && t2.remove();
                            else {
                                var n2 = Math.floor(i2 / 864e5),
                                    s = `0${Math.floor((i2 % 864e5) / 36e5)}`.slice(-2),
                                    r = `0${Math.floor((i2 % 36e5) / 6e4)}`.slice(-2),
                                    c = `0${Math.floor((i2 % 6e4) / 1e3)}`.slice(-2),
                                    l = "";
                                t2.hasClass("collection-countdown") &&
                                    (l =
                                        '<div class="clock-item"><span class="num">' +
                                        n2 +
                                        '</span><span class="text">' +
                                        window.countdown.days +
                                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                                        s +
                                        '</span><span class="text">' +
                                        window.countdown.hours +
                                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                                        r +
                                        '</span><span class="text">' +
                                        window.countdown.mins +
                                        '</span></div>                                                <div class="clock-item"><span class="num">' +
                                        c +
                                        '</span><span class="text">' +
                                        window.countdown.secs +
                                        "</span></div>"),
                                    t2.html(l);
                            }
                        };
                    setInterval(() => {
                        a2(e3);
                    }, 1e3);
                });
        },
        handleScrollDown: function () {
            var e2 = "[data-scroll-down]",
                a2 = t(e2);
            a2.each(function () {
                var e3 = t(this),
                    o2 = e3.closest(".shopify-section").next(".shopify-section").attr("id");
                e3.attr("href", "#" + o2),
                    a2.on("click", function (e4) {
                        e4.preventDefault();
                        var a3 = t(this.getAttribute("href"));
                        a3.length && t("html, body").stop().animate({ scrollTop: a3.offset().top }, 400);
                    });
            });
        },
        toggleSidebarMobile: function () {
            o.on("click", "[data-sidebar]", (t2) => {
                t2.preventDefault(), t2.stopPropagation(), a.addClass("open-mobile-sidebar");
            }),
                o.on("click", "[data-close-sidebar]", (t2) => {
                    t2.preventDefault(), t2.stopPropagation(), a.removeClass("open-mobile-sidebar");
                }),
                o.on("click", (e2) => {
                    a.hasClass("open-mobile-sidebar") &&
                        t(e2.target).closest("[data-sidebar]").length === 0 &&
                        t(e2.target).closest("#halo-sidebar").length === 0 &&
                        a.removeClass("open-mobile-sidebar");
                });
        },
        initBlogMasonry: function () {
            const e2 = t(".blog-layout-masonry .blog-block-item"),
                o2 = a.hasClass("layout_rtl");
            e2.masonry({
                columnWidth: ".blog-grid-sizer",
                itemSelector: "[data-masonry-item]",
                isRTL: o2,
                originLeft: !o2,
            });
        },
        articleGallery: function () {
            const e2 = t(".articleGallery-block"),
                a2 = t(".articleGallery-slider"),
                o2 = e2.length,
                i2 = a2.data("col");
            o2 > 0 &&
                a2.not(".slick-initialized") &&
                a2.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: !0,
                    arrows: !0,
                    infinite: !1,
                    mobileFirst: !0,
                    focusOnSelect: !1,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 767, settings: { slidesToShow: i2, slidesToScroll: i2 } },
                        { breakpoint: 319, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                    ],
                });
        },
        initCollapseSidebarBlock: function () {
            o.on("click", ".sidebarBlock-headingWrapper .sidebarBlock-heading", (e2) => {
                var a2 = t(e2.currentTarget),
                    o2 = a2.parent().siblings(),
                    i2 = a2.parents(".sidebarBlock");
                a2.hasClass("is-clicked")
                    ? (a2.removeClass("is-clicked"), o2.slideUp("slow"))
                    : (a2.addClass("is-clicked"),
                      o2.slideDown("slow"),
                      i2.hasClass("sidebar-product") && i2.find(".products-carousel").slick("refresh"));
            }),
                o.on("click", ".sidebarBlock-headingWrapper-slide .sidebarBlock-heading", (e2) => {
                    var a2 = t(e2.currentTarget),
                        o2 = a2.closest(".halo-sidebar-wrapper"),
                        i2 = a2.parent().siblings(),
                        n2 = i2.find(".sidebarBlock-slide__content-close"),
                        s = a2.parents(".sidebarBlock");
                    i2.toggleClass("is-show"),
                        o2.toggleClass("disable-scroll"),
                        s.toggleClass("has-slide"),
                        n2.on("click", function () {
                            i2.removeClass("is-show"), o2.removeClass("disable-scroll"), s.removeClass("has-slide");
                        });
                });
        },
        initCategoryActive: function () {
            t(".all-categories-list").length > 0 &&
                (o.on("click", ".all-categories-list .icon-dropdown", (e2) => {
                    var a2 = t(e2.currentTarget).parent();
                    a2.siblings().removeClass("is-clicked current-cate"),
                        a2.toggleClass("is-clicked"),
                        a2.siblings().find("> .dropdown-category-list").slideUp("slow"),
                        a2.find("> .dropdown-category-list").slideToggle("slow");
                }),
                t(".all-categories-list li").each((e2, a2) => {
                    t(a2).hasClass("current-cate") && t(a2).find("> .dropdown-category-list").slideToggle("slow"),
                        t(a2).hasClass("is-clicked") &&
                            (t(a2).closest(".navPages-item").addClass("is-clicked"), t(a2).parent().slideDown("slow"));
                }));
        },
        productBlockSilderSidebar: function () {
            var e2 = t("[data-product-slider-sidebar]"),
                a2 = e2.data("item-to-show"),
                o2 = e2.data("item-dots"),
                i2 = e2.data("item-arrows");
            e2.length > 0 &&
                e2.not(".slick-initialized") &&
                e2.slick({
                    mobileFirst: !0,
                    adaptiveHeight: !0,
                    vertical: !1,
                    infinite: !1,
                    slidesToShow: a2,
                    slidesToScroll: 1,
                    arrows: i2,
                    dots: o2,
                    autoplay: !0,
                    autoplaySpeed: 2e3,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                }),
                t("body").hasClass("cursor-fixed__show") &&
                    (window.sharedFunctionsAnimation.onEnterButton(), window.sharedFunctionsAnimation.onLeaveButton());
        },
        productBlockSilderArticle: function () {
            var e2 = t("[data-product-slider-article]"),
                a2 = e2.data("item-to-show"),
                o2 = e2.data("item-dots"),
                i2 = e2.data("item-arrows");
            e2.length > 0 &&
                e2.not(".slick-initialized") &&
                e2.slick({
                    adaptiveHeight: !0,
                    vertical: !1,
                    infinite: !1,
                    slidesToShow: a2,
                    slidesToScroll: 1,
                    arrows: i2,
                    dots: o2,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                        { breakpoint: 551, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    ],
                });
        },
        articleGallery: function () {
            const e2 = t(".articleGallery-block"),
                a2 = t(".articleGallery-slider"),
                o2 = e2.length,
                i2 = a2.data("col");
            o2 > 0 &&
                a2.not(".slick-initialized") &&
                a2.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: !0,
                    arrows: !0,
                    infinite: !1,
                    mobileFirst: !0,
                    focusOnSelect: !1,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                    responsive: [
                        { breakpoint: 767, settings: { slidesToShow: i2, slidesToScroll: i2 } },
                        { breakpoint: 319, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                    ],
                });
        },
        initInfiniteScrolling: function () {
            t(!0) &&
                i.on("scroll load", () => {
                    var e2 = i.scrollTop(),
                        a2 = t(".pagination-infinite"),
                        o2 = a2.find("[data-infinite-scrolling]");
                    if (o2.length > 0 && !o2.hasClass("is-loading") && e2 > a2.offset().top - 500) {
                        var s = o2.attr("href");
                        n.doAjaxInfiniteScrollingGetContent(s, o2);
                    }
                }),
                o.on("click", "[data-infinite-scrolling]", (e2) => {
                    var a2 = t(e2.currentTarget),
                        o2 = a2.attr("href");
                    e2.preventDefault(), e2.stopPropagation(), n.doAjaxInfiniteScrollingGetContent(o2, a2);
                });
        },
        doAjaxInfiniteScrollingGetContent: function (e2, a2) {
            t.ajax({
                type: "GET",
                url: e2,
                beforeSend: function () {
                    a2.text(a2.attr("data-loading-more")), a2.addClass("is-loading");
                },
                success: function (t2) {
                    n.ajaxInfiniteScrollingMapData(t2);
                },
                error: function (e3, a3) {
                    alert(t.parseJSON(e3.responseText).description);
                },
                complete: function () {
                    a2.text(a2.attr("data-load-more")),
                        a2.removeClass("is-loading"),
                        document.querySelector(".collection-masonry") && resizeAllGridItems();
                },
            });
        },
        ajaxInfiniteScrollingMapData: function (e2) {
            var a2 = t("#CollectionProductGrid"),
                o2 = a2.find(".productListing"),
                i2 = a2.find(".pagination"),
                s = t(e2).find("#CollectionProductGrid"),
                r = s.find(".productListing"),
                c = s.find(".pagination"),
                l = r.children(".product");
            if (l.length > 0) {
                if ((o2.append(l), i2.replaceWith(c), t("[data-total-start]").text(1), window.compare.show)) {
                    var d = t("[data-compare-link]");
                    n.setLocalStorageProductForCompare(d);
                }
                window.wishlist.show && n.setLocalStorageProductForWishlist(),
                    n.checkNeedToConvertCurrency() &&
                        Currency.convertAll(
                            window.shop_currency,
                            t("#currencies .active").attr("data-currency"),
                            "span.money",
                            "money_format"
                        );
            }
        },
        initQuickShopProductList: function () {
            o.on("click", "[data-open-quickshop-popup-list]", (e2) => {
                e2.preventDefault(), e2.stopPropagation();
                var a2 = t(e2.currentTarget).data("product-handle"),
                    o2 = t(e2.currentTarget).closest(".card");
                o2.hasClass("quick-shop-show") || n.updateContentQuickShop(o2, a2);
            }),
                o.on("click", "[data-close-quickshop-popup-list]", (e2) => {
                    e2.preventDefault(), e2.stopPropagation();
                    var a2 = t(e2.currentTarget).closest(".card");
                    a2.removeClass("quick-shop-show"), a2.find(".card-popup-content").empty();
                }),
                o.on("click", (e2) => {
                    t(".card").hasClass("quick-shop-show") &&
                        t(e2.target).closest("[data-open-quickshop-popup-list]").length === 0 &&
                        t(e2.target).closest(".card-popup").length === 0 &&
                        (t(".card").removeClass("quick-shop-show"), t(".card").find(".card-popup-content").empty());
                });
        },
        updateContentQuickShop: function (e2, a2) {
            var o2 = e2.find(".card-popup").find(".card-popup-content");
            t.ajax({
                type: "get",
                url: window.routes.root + "/products/" + a2 + "?view=ajax_quick_shop",
                beforeSend: function () {
                    t(".card").removeClass("quick-shop-show");
                },
                success: function (t2) {
                    o2.append(t2);
                },
                error: function (e3, a3) {
                    alert(t.parseJSON(e3.responseText).description);
                },
                complete: function () {
                    e2.addClass("quick-shop-show");
                },
            });
        },
        toggleVariantsForExpressOrder: function () {
            t(document).on("click", "[data-toggle-variant]", function (e2) {
                e2.preventDefault(), e2.stopPropagation();
                var a2 = t(this),
                    o2 = a2.data("target");
                a2.hasClass("show-options-btn")
                    ? (a2.text(window.inventory_text.hide_options),
                      t(o2).slideDown(700, function () {
                          a2.addClass("hide-options-btn").removeClass("show-options-btn");
                      }))
                    : (a2.text(window.inventory_text.show_options),
                      t(o2).slideUp(700, function () {
                          a2.addClass("show-options-btn").removeClass("hide-options-btn");
                      }));
            });
        },
        initExpressOrderAddToCart: function () {
            var e2 = "[data-express-addtocart]";
            t(document)
                .off("click.addToCartExpress", e2)
                .on("click.addToCartExpress", e2, function (e3) {
                    e3.preventDefault();
                    var a2 = t(this);
                    if (a2.attr("disabled") != "disabled") {
                        var o2 = a2.closest(".product-item");
                        o2.length == 0 && (o2 = a2.closest(".col-options"));
                        var i2 = o2.find("form"),
                            s = i2.find("select[name=id]").val();
                        s || (s = i2.find("input[name=id]").val());
                        var r = o2.find("input[name=quantity]");
                        r.length == 0 && (r = o2.siblings(".col-qtt").find("input[name=quantity]"));
                        var c = r.val();
                        c || (c = 1),
                            parseInt(c) !== 0
                                ? window.ajax_cart == "none"
                                    ? i2.submit()
                                    : (n.expressAjaxAddToCart(s, c, a2, i2), i2.next(".feedback-text").show())
                                : i2.next(".feedback-text").text("Quantity cannot be blank").show();
                    }
                    return !1;
                });
        },
        expressAjaxAddToCart: function (e2, o2, i2, s) {
            t.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + o2 + "&id=" + e2,
                dataType: "json",
                beforeSend: function () {
                    window.setTimeout(function () {
                        i2.text(window.inventory_text.adding + "...");
                    }, 100);
                },
                success: function (t2) {
                    switch (
                        (window.setTimeout(function () {
                            i2.text(window.inventory_text.thank_you),
                                i2.addClass("add_more"),
                                s.next(".feedback-text").text(window.inventory_text.cart_feedback).addClass("is-added");
                        }, 600),
                        window.setTimeout(function () {
                            i2.text(window.inventory_text.add_more + "...");
                        }, 1e3),
                        window.after_add_to_cart.type)
                    ) {
                        case "cart":
                            n.redirectTo(window.routes.cart);
                            break;
                        case "quick_cart":
                            window.quick_cart.show
                                ? Shopify.getCart((t3) => {
                                      window.quick_cart.type == "popup" ||
                                          (a.addClass("cart-sidebar-show"), n.updateSidebarCart(t3));
                                  })
                                : n.redirectTo(window.routes.cart);
                            break;
                        case "popup_cart_1":
                            Shopify.getCart((t3) => {
                                n.updatePopupCart(t3, 1, e2), n.updateSidebarCart(t3), a.addClass("add-to-cart-show");
                            });
                    }
                },
                error: function (e3, a2) {
                    alert(t.parseJSON(e3.responseText).description),
                        window.setTimeout(function () {
                            i2.text(window.inventory_text.add_to_cart);
                        }, 400);
                },
            });
        },
        initProductBundle: function () {
            var e2 = t("[data-product-bundle]"),
                a2 = e2.find("[data-bundle-slider]"),
                o2 = a2.data("dots"),
                i2 = a2.data("arrows");
            a2.length > 0 &&
                (a2.hasClass("slick-initialized") ||
                    (a2.slick({
                        dots: !0,
                        arrows: i2,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        mobileFirst: !0,
                        infinite: !1,
                        nextArrow: window.arrows.icon_next,
                        prevArrow: window.arrows.icon_prev,
                        rtl: window.rtl_slick,
                        responsive: [
                            { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1, dots: o2 } },
                            { breakpoint: 551, settings: { slidesToShow: 3, slidesToScroll: 1, dots: o2 } },
                        ],
                    }),
                    e2.find(".bundle-product-wrapper").removeClass("has-halo-block-loader"),
                    a2.on("afterChange", function () {
                        a2.find(".bundle-product-item").removeClass("is-open");
                    })));
        },
        initDynamicBrowserTabTitle: function () {
            if (window.dynamic_browser_title.show) {
                var t2 = document.title;
                window.dynamic_browser_title.text,
                    (window.onblur = function () {
                        document.title = window.dynamic_browser_title.text;
                    }),
                    (window.onfocus = function () {
                        document.title = t2;
                    });
            }
        },
        initWarningPopup: function () {
            (this.warningPopup = document.querySelector("[data-warning-popup]")),
                (this.warningPopupContent = this.warningPopup.querySelector("[data-halo-warning-content]")),
                (this.warningPopupCloseButton = this.warningPopup.querySelector("[data-close-warning-popup]")),
                this.warningPopupCloseButton.addEventListener("click", () => {
                    document.body.classList.remove("has-warning");
                }),
                document.body.addEventListener("click", () => {
                    event.target.closest("[data-warning-popup]") || document.body.classList.remove("has-warning");
                }),
                (this.warningTime = 3e3),
                (this.warningTimeout = void 0),
                (window.warningTimeout = this.warningTimeout);
        },
        showWarning: function (t2, e2 = this.warningTime) {
            this.warningTimeout && clearTimeout(this.warningTimeout),
                (this.warningPopupContent.textContent = t2),
                document.body.classList.add("has-warning"),
                e2 &&
                    (this.warningTimeout = setTimeout(() => {
                        document.body.classList.remove("has-warning");
                    }, e2));
        },
        backgroundOverlayHoverEffect: function () {
            const t2 = document.querySelector(".background-overlay"),
                e2 = t2.firstChild,
                a2 = () => {
                    e2.classList.remove("enlarge-cursor");
                },
                o2 = (t3, a3) => {
                    requestAnimationFrame(() => {
                        e2.style.setProperty("--translate-y", a3), e2.style.setProperty("--translate-x", t3);
                    });
                },
                i2 = (t3) => {
                    o2(t3.clientX, t3.clientY);
                };
            t2.addEventListener("mouseenter", (t3) => {
                o2(t3.clientX, t3.clientY), e2.classList.add("enlarge-cursor");
            }),
                t2.addEventListener("mouseleave", (t3) => {
                    o2(t3.clientX, t3.clientY), e2.removeEventListener("mousemove", i2), a2();
                }),
                t2.addEventListener("mousemove", i2),
                t2.addEventListener("click", a2);
        },
        backgroundOverlayHoverEffect1: function () {
            const t2 = document.querySelector(".background-overlay1");
            if (!t2) return;
            const e2 = t2.firstChild,
                a2 = () => {
                    e2.classList.remove("enlarge-cursor");
                },
                o2 = (t3, a3) => {
                    requestAnimationFrame(() => {
                        e2.style.setProperty("--translate-y", a3), e2.style.setProperty("--translate-x", t3);
                    });
                },
                i2 = (t3) => {
                    o2(t3.clientX, t3.clientY);
                };
            t2.addEventListener("mouseenter", (t3) => {
                o2(t3.clientX, t3.clientY), e2.classList.add("enlarge-cursor");
            }),
                t2.addEventListener("mouseleave", (t3) => {
                    o2(t3.clientX, t3.clientY), e2.removeEventListener("mousemove", i2), a2();
                }),
                t2.addEventListener("mousemove", i2),
                t2.addEventListener("click", a2);
        },
        productCustomInformation() {
            const e2 = t("[data-custom-information]"),
                i2 = t("#halo-product-custom-information");
            e2.on("click", (e3) => {
                const o2 = t(e3.currentTarget),
                    n2 = o2.find(".title")[0].innerText,
                    s = o2.find(".product-customInformation__popup").html();
                s !== "" &&
                    s != null &&
                    (i2.addClass("is-show"),
                    i2.find(".halo-popup-title").text(n2),
                    i2.find(".halo-popup-content").html(s),
                    a.addClass("is-custom-information"));
            }),
                o.on("click", "[data-close-custom-information]", () => {
                    a.removeClass("is-custom-information"), i2.removeClass("is-show");
                }),
                o.on("click", (e3) => {
                    a.hasClass("is-custom-information") &&
                        t(e3.target).closest("#halo-product-custom-information").length === 0 &&
                        t(e3.target).closest("[data-custom-information]").length === 0 &&
                        a.removeClass("is-custom-information");
                });
        },
        initLazyloadObserver(t2, e2) {
            const a2 = (t3) => {
                t3.closest(".card").classList.add("ajax-loaded");
            };
            this.lazyloadedObserver = new MutationObserver((t3, e3) => {
                t3.forEach((t4) => {
                    if (t4.type == "attributes") {
                        if (!t4.target.classList.contains("lazyloaded")) return;
                        a2(t4.target);
                    }
                });
            });
            const o2 = new MutationObserver((t3) => {
                t3.forEach((t4) => {
                    t4.type == "childList" &&
                        [...t4.addedNodes]
                            .map((t5) => t5.querySelector(".media--loading-effect img"))
                            .forEach((t5) => {
                                t5 && this.lazyloadedObserver.observe(t5, { childList: !0, attributes: !0 });
                            });
                });
            });
            e2 && o2.observe(e2, { subtree: !1, childList: !0 }),
                t2.length > 0 &&
                    t2.forEach((t3) => {
                        t3.classList.contains("lazyloaded")
                            ? a2(t3)
                            : this.lazyloadedObserver.observe(t3, { childList: !0, attributes: !0 });
                    });
        },
        observeImageLazyloaded(t2) {
            t2.forEach((t3) => {
                this.lazyloadedObserver.observe(t3, { childList: !0, attributes: !0 });
            });
        },
        iconZoomClickMobile() {
            t(".productView-iconZoom").on("click", (t2) => {
                document.querySelector(".productView-image .productView-img-container .media").click();
            });
        },
        calculateTranslateYHeight() {
            const t2 = document.querySelectorAll(".card .card-action:not(.variants-popup-form)");
            let e2 = 0;
            t2.length &&
                (t2.forEach((t3) => {
                    t3.classList.add("temporary-show");
                    const a2 = t3.clientHeight;
                    a2 > e2 && (e2 = a2), t3.classList.remove("temporary-show");
                }),
                document.body.style.setProperty("--translate-y-height", -1 * e2 + "px"));
        },
        checkScrollLayoutForRecenlyViewed() {
            const t2 = document.getElementById("recently-viewed-products-list-2");
            t2 &&
                t2.classList.contains("products-flex") &&
                new MutationObserver((t3, e3) => {
                    const a2 = t3[0];
                    a2.type == "attributes" &&
                        a2.target.classList.contains("recently-viewed-loaded") &&
                        e3.disconnect();
                }).observe(t2, { attributes: !0 });
        },
        clickIconScrollSection() {
            if (!document.querySelector(".arrow-icon-scroll")) return;
            let e2 = "next";
            const a2 = document.querySelectorAll(".wrapper-body .shopify-section"),
                i2 = a2.length,
                n2 = a2[0]?.getBoundingClientRect().height || 0,
                s = a2[i2 - 1]?.getBoundingClientRect().height || 0,
                r =
                    document.querySelectorAll(".shopify-section-group-footer-group")[0]?.getBoundingClientRect()
                        .height || 0;
            function c(t2, e3) {
                window.scrollTo({ top: t2, behavior: "smooth" });
            }
            function l(t2) {
                (e2 = t2),
                    t2 == "next"
                        ? document.querySelector(".arrow-icon-scroll").classList.remove("rotate")
                        : document.querySelector(".arrow-icon-scroll").classList.add("rotate");
            }
            window.pageYOffset + s >= document.documentElement.scrollHeight - r && l("prev"),
                t(window).scroll(function () {
                    window.pageYOffset + s >= document.documentElement.scrollHeight - r
                        ? l("prev")
                        : window.pageYOffset <= n2 / 2 && l("next");
                }),
                o.on("click", ".arrow-icon-scroll", (t2) => {
                    let o2 = !0;
                    const n3 =
                            window.innerWidth > 1024
                                ? document.querySelectorAll("sticky-header")[0]?.getBoundingClientRect().height
                                : document.querySelector("sticky-header-mobile")?.getBoundingClientRect().height || 0,
                        s2 =
                            document.querySelectorAll(".shopify-section-group-footer-group")[0]?.getBoundingClientRect()
                                .top || -1;
                    a2.forEach((t3, r2) => {
                        o2 &&
                            (t3.getBoundingClientRect().top >= 0
                                ? ((o2 = !1),
                                  e2 == "next"
                                      ? (t3.nextElementSibling != null && c(t3.nextElementSibling.offsetTop - n3),
                                        i2 == r2 + 2 || t3.nextElementSibling == null ? l("prev") : l("next"))
                                      : (t3.previousElementSibling != null &&
                                            c(t3.previousElementSibling.offsetTop - n3),
                                        r2 == 1 || t3.previousElementSibling == null ? l("next") : l("prev")))
                                : s2 >= 0 && c(a2[i2 - 1].offsetTop - n3));
                    });
                });
        },
        specialBanner() {
            const t2 = document.querySelectorAll("[sticky-special-banner]"),
                e2 = window.innerWidth,
                a2 = window.innerHeight,
                o2 =
                    e2 > 1024
                        ? document.querySelectorAll("sticky-header")[0]?.getBoundingClientRect().height
                        : document.querySelector("sticky-header-mobile")?.getBoundingClientRect().height || 0;
            function i2(t3, e3) {
                t3.classList.add("is-sticky"), (t3.style.top = `${e3}px`);
            }
            t2 &&
                t2.forEach((t3) => {
                    const n2 = t3.querySelector(".special-banner__img_box"),
                        s = t3.querySelector(".special-banner__img"),
                        r = t3.closest(".special-banner__wrapper").getBoundingClientRect().height,
                        c = s.getBoundingClientRect().height;
                    let l = o2 || 0;
                    e2 >= 1200
                        ? r > c && (a2 > c && (l = (a2 - c) / 2), i2(n2, l))
                        : e2 >= 768 && e2 < 1200
                          ? r > c && i2(n2, l)
                          : (t3.classList.remove("is-sticky"), (t3.style.top = ""));
                });
        },
        specialBannerSlider() {
            const e2 = t(".special-banner__products--grid"),
                a2 = window.innerWidth;
            e2 &&
                e2.each(function (e3, o2) {
                    const i2 = t(o2),
                        n2 = i2.closest(".special-banner__product");
                    n2.hasClass("ajax-loaded") &&
                        (a2 < 1200
                            ? i2.hasClass("slick-initialized") ||
                              (i2.addClass("products-carousel"),
                              (function (t2) {
                                  let e4 = t2.find(".products-carousel"),
                                      a3 = e4.data("item-to-show"),
                                      o3 = e4.data("item-dots"),
                                      i3 = e4.data("item-dots-mb"),
                                      n3 = e4.data("item-arrows"),
                                      s = e4.data("item-arrows-mb");
                                  e4.slick({
                                      mobileFirst: !0,
                                      adaptiveHeight: !0,
                                      infinite: !0,
                                      slidesToShow: 2,
                                      slidesToScroll: 2,
                                      arrows: s,
                                      dots: i3,
                                      nextArrow: window.arrows.icon_next,
                                      prevArrow: window.arrows.icon_prev,
                                      rtl: window.rtl_slick,
                                      responsive: [
                                          {
                                              breakpoint: 767,
                                              settings: { arrows: n3, dots: o3, slidesToShow: a3, slidesToScroll: a3 },
                                          },
                                      ],
                                  });
                              })(n2))
                            : i2.hasClass("slick-initialized") &&
                              (i2.slick("unslick"), i2.removeClass("products-carousel")));
                });
        },
        unsymmetricalSlider() {
            const e2 = t(".unsymmetrical-slider"),
                a2 = t(window).width();
            e2 &&
                e2.each(function (e3, o2) {
                    const i2 = t(o2),
                        n2 = i2.closest(".halo-block-content");
                    n2.hasClass("ajax-loaded") &&
                        (a2 < 1200
                            ? i2.hasClass("slick-initialized") ||
                              (i2.addClass("products-carousel"),
                              setTimeout(() => {
                                  (function (t2) {
                                      let e4 = t2.find(".products-carousel"),
                                          o3 = e4.data("item-to-show"),
                                          i3 = e4.data("item-dots"),
                                          n3 = e4.data("item-arrows");
                                      if (e4.hasClass("enable_progress_bar")) {
                                          var s = t2.find(".scrollbar-thumb");
                                          e4.on("init", (t3, e5) => {
                                              var a3 = (e5.currentSlide / (e5.slideCount - 1)) * 100 + "%";
                                              s.css("--percent", a3);
                                          });
                                      }
                                      e4.slick({
                                          mobileFirst: !0,
                                          adaptiveHeight: !0,
                                          infinite: !0,
                                          slidesToShow: 1.5,
                                          slidesToScroll: 1,
                                          arrows: n3,
                                          nextArrow: window.arrows.icon_next,
                                          prevArrow: window.arrows.icon_prev,
                                          rtl: window.rtl_slick,
                                          dots: i3,
                                          get initialSlide() {
                                              return (this.initialSlide = 0.5);
                                          },
                                          responsive: [
                                              {
                                                  breakpoint: 767,
                                                  settings: {
                                                      arrows: n3,
                                                      slidesToShow: o3,
                                                      dots: i3,
                                                      slidesToScroll: o3,
                                                      get slidesToScroll() {
                                                          return (this.slidesToScroll =
                                                              o3 != null &&
                                                              o3 !== "" &&
                                                              o3 !== 1.5 &&
                                                              o3 !== 2.5 &&
                                                              o3 !== 3.5
                                                                  ? o3
                                                                  : 1);
                                                      },
                                                      get initialSlide() {
                                                          return (this.initialSlide =
                                                              (o3 !== 1.5 && o3 == 2.5) || o3 == 3.5 ? 0.5 : 0);
                                                      },
                                                  },
                                              },
                                          ],
                                      }),
                                          e4.hasClass("enable_progress_bar") &&
                                              e4.on("afterChange", (t3, e5, i4) => {
                                                  let n4 = 0;
                                                  n4 = a2 > 767 ? (o3 == 1.5 || o3 == 2.5 || o3 == 3.5 ? 0.5 : 0) : 0.5;
                                                  var r = ((i4 - n4) / (e5.slideCount - 1)) * 100 + "%";
                                                  s.css("--percent", r);
                                              });
                                  })(n2);
                              }, 1e3))
                            : i2.hasClass("slick-initialized") &&
                              (i2.slick("unslick"), i2.removeClass("products-carousel")));
                });
        },
        productCountdownCard: function () {
            var e2 = t(".card .card-countDown").find("[data-countdown-id]"),
                a2 = e2.data("countdown"),
                o2 = new Date(a2).getTime(),
                i2 = window.countdown.text;
            if (e2.length > 0)
                var n2 = setInterval(function () {
                    var t2 = new Date().getTime(),
                        a3 = o2 - t2;
                    if (a3 < 0) clearInterval(n2), e2.remove();
                    else {
                        var s,
                            r = Math.floor(a3 / 864e5),
                            c = Math.floor((a3 % 864e5) / 36e5),
                            l = Math.floor((a3 % 36e5) / 6e4),
                            d = Math.floor((a3 % 6e4) / 1e3);
                        (s =
                            '<span class="text"><span>' +
                            i2 +
                            '</span></span><span class="num">' +
                            r +
                            "<span>" +
                            window.countdown.day +
                            '</span></span>                                <span class="num">' +
                            c +
                            '<span class="icon">:</span></span>                                <span class="num">' +
                            l +
                            '<span class="icon">:</span></span>                                <span class="num">' +
                            d +
                            "</span>"),
                            e2.html(s),
                            e2.addClass("show");
                    }
                }, 1e3);
        },
        typingAnimation() {
            t.fn.textType = function (a2, o2) {
                return this.each(function () {
                    var i2 = t(this);
                    new e2(i2, a2, o2);
                });
            };
            var e2 = function (e3, a2, o2) {
                (this.rotate = a2),
                    (this.$element = t(e3)),
                    (this.loopNum = 0),
                    (this.period = parseInt(o2, 10) || 2e3),
                    (this.text = ""),
                    this.tick(),
                    (this.isDeleting = !1);
            };
            (e2.prototype.tick = function () {
                var t2 = this.loopNum % this.rotate.length,
                    e3 = this.rotate[t2];
                this.isDeleting
                    ? (this.text = e3.substring(0, this.text.length - 1))
                    : (this.text = e3.substring(0, this.text.length + 1)),
                    this.$element.find("[data-text-convert]").html(`<span class="text">${this.text}</span>`);
                var a2 = this,
                    o2 = 200 - 100 * Math.random();
                this.isDeleting && (o2 /= 2),
                    this.isDeleting || this.text !== e3
                        ? this.isDeleting && this.text === "" && ((this.isDeleting = !1), this.loopNum++, (o2 = 500))
                        : ((o2 = this.period), (this.isDeleting = !0)),
                    setTimeout(function () {
                        a2.tick();
                    }, o2);
            }),
                t("type-writer").length &&
                    t("type-writer").each(function (a2, o2) {
                        const i2 = t(this).attr("data-type"),
                            n2 = t(this).attr("data-period");
                        i2 && new e2(t(this), JSON.parse(i2), n2);
                    });
        },
        spotlightproductSlider: function () {
            var e2 = t("[data-spotlight-product]");
            !e2.length > 0 ||
                (e2.each((e3, a2) => {
                    var o2 = t(a2).find(".spotlight-products__products--slider"),
                        i2 = o2.data("item-dots"),
                        n2 = o2.data("item-dots-mb"),
                        s = o2.data("item-arrows"),
                        r = o2.data("item-arrows-mb");
                    o2.length > 0 &&
                        (o2.hasClass("slick-initialized") ||
                            (o2.slick({
                                mobileFirst: !0,
                                adaptiveHeight: !1,
                                infinite: !1,
                                vertical: !1,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: n2,
                                arrows: r,
                                nextArrow: window.arrows.icon_next,
                                prevArrow: window.arrows.icon_prev,
                                rtl: window.rtl_slick,
                                focusOnSelect: !0,
                                responsive: [{ breakpoint: 1025, settings: { dots: i2, arrows: s } }],
                            }),
                            o2.on("beforeChange", function (e4, a3, o3, i3) {
                                const n3 = t(e4.target).parents(".spotlight-products");
                                n3.find(".point-button").removeClass("active"),
                                    n3.find(`[data-slide="${i3 + 1}"]`).addClass("active");
                            })));
                }),
                t(".spotlight-products__product_point .point-button").click(function (e3) {
                    e3.preventDefault();
                    const a2 = t(this);
                    a2.parents(".spotlight-products")
                        .find(".spotlight-products__products--slider")
                        .slick("slickGoTo", a2.data("slide") - 1);
                }));
        },
        activeCheckboxStickyCartMobile: function () {
            if (t(".enable_sticky_buttton").length) {
                var e2 = t(".button-disable"),
                    a2 = t(".sticky_button_checkout_mb"),
                    o2 = t(".halo-sticky-toolbar-mobile"),
                    i2 = o2.outerHeight();
                e2.on("click", function () {
                    a2.addClass("active");
                }),
                    o2.length > 0 ? a2.css("bottom", i2) : a2.css("bottom", "0px");
            }
        },
    };
})(jQuery);
function checkAndInitializeSwipers() {
    window.innerWidth <= 768 && initializeSwipers();
}
function initializeSwipers() {
    document.querySelectorAll(".TemplateList-module__template-list-container").forEach((t) => {
        if (!t.classList.contains("swiper-initialized")) {
            const e = document.createElement("div");
            for (e.classList.add("swiper-wrapper"); t.firstChild; ) {
                const a2 = document.createElement("div");
                a2.classList.add("swiper-slide"), a2.appendChild(t.firstChild), e.appendChild(a2);
            }
            const a = document.createElement("div");
            a.classList.add("swiper-container"), a.appendChild(e), t.appendChild(a);
            const o = document.createElement("div");
            o.classList.add("swiper-button-next"), a.appendChild(o);
            const i = document.createElement("div");
            i.classList.add("swiper-button-prev"), a.appendChild(i);
            const n = document.createElement("div");
            n.classList.add("swiper-pagination"),
                a.appendChild(n),
                new Swiper(a, {
                    loop: !0,
                    slidesPerView: 1,
                    spaceBetween: 10,
                    navigation: { nextEl: o, prevEl: i },
                    pagination: { el: n, clickable: !0 },
                }),
                t.classList.add("swiper-initialized");
        }
    });
}
document.addEventListener("DOMContentLoaded", function () {
    const t = document.getElementById("quantity"),
        e = document.getElementById("increase-quantity"),
        a = document.getElementById("decrease-quantity");
    if (!t || !e || !a) return;
    const o = parseInt(t.getAttribute("min")),
        i = parseInt(t.getAttribute("max"));
    function n() {
        let n2 = parseInt(t.value);
        (e.disabled = n2 >= i), (a.disabled = n2 <= o);
    }
    t.addEventListener("input", function () {
        let t2 = parseInt(this.value);
        isNaN(t2) || t2 < o ? (this.value = o) : t2 > i && (this.value = i), n();
    }),
        e.addEventListener("click", function () {
            let e2 = parseInt(t.value);
            e2 < i && (t.value = e2 + 1), n();
        }),
        a.addEventListener("click", function () {
            let e2 = parseInt(t.value);
            e2 > o && (t.value = e2 - 1), n();
        }),
        n();
}),
    document.addEventListener("DOMContentLoaded", function () {
        checkAndInitializeSwipers(), window.addEventListener("resize", checkAndInitializeSwipers);
    });
let mobile = 0;
const discountObserver = new MutationObserver((t) => {
        t.forEach((t2) => {
            (t2.type !== "childList" && t2.type !== "characterData" && t2.type !== "attributes") ||
                calculateTotal(mobile),
                t2.removedNodes.forEach((t3) => {
                    t3.nodeType === Node.ELEMENT_NODE &&
                        t3.matches(
                            ".SidebarKitSummary-module__pricing-row.SidebarKitSummary-module__discount-pricing-row"
                        ) &&
                        ((mobile = 0), removeTotalDiv(mobile)),
                        t3.nodeType === Node.ELEMENT_NODE &&
                            t3.matches(
                                ".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__discount-pricing-row"
                            ) &&
                            ((mobile = 1), removeTotalDiv(mobile));
                });
        });
    }),
    documentObserver = new MutationObserver((t) => {
        t.forEach((t2) => {
            t2.addedNodes.forEach((t3) => {
                t3.nodeType === Node.ELEMENT_NODE &&
                    t3.matches(
                        ".SidebarKitSummary-module__pricing-row.SidebarKitSummary-module__discount-pricing-row"
                    ) &&
                    (discountObserver.observe(t3, { childList: !0, subtree: !0, characterData: !0, attributes: !0 }),
                    (mobile = 0),
                    calculateTotal(mobile)),
                    t3.nodeType === Node.ELEMENT_NODE &&
                        t3.matches(
                            ".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__discount-pricing-row"
                        ) &&
                        (discountObserver.observe(t3, {
                            childList: !0,
                            subtree: !0,
                            characterData: !0,
                            attributes: !0,
                        }),
                        (mobile = 1),
                        calculateTotal(mobile));
            }),
                t2.removedNodes.forEach((t3) => {
                    t3.nodeType === Node.ELEMENT_NODE &&
                        t3.matches(
                            ".SidebarKitSummary-module__pricing-row.SidebarKitSummary-module__discount-pricing-row"
                        ) &&
                        ((mobile = 0), removeTotalDiv(mobile)),
                        t3.nodeType === Node.ELEMENT_NODE &&
                            t3.matches(
                                ".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__discount-pricing-row"
                            ) &&
                            ((mobile = 1), removeTotalDiv(mobile));
                });
        });
    });
function calculateTotal(t) {
    let e, a;
    if (
        (t && t == 1
            ? ((e = document.querySelector(
                  ".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__discount-pricing-row .money"
              )),
              (a = document.querySelector(
                  ".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__subtotal-pricing-row .money"
              )))
            : ((e = document.querySelector(
                  ".SidebarKitSummary-module__pricing-row.SidebarKitSummary-module__discount-pricing-row .money"
              )),
              (a = document.querySelector(
                  ".SidebarKitSummary-module__pricing-row.SidebarKitSummary-module__subtotal-pricing-row .money"
              ))),
        e && a)
    ) {
        var o = e.textContent.replace(/[^\d]/g, ""),
            i = a.textContent.replace(/[^\d]/g, ""),
            n = parseInt(o, 10),
            s = parseInt(i, 10);
        n = Math.floor(n / 100);
        var r = (s = Math.floor(s / 100)) + n;
        if (t && t == 1) {
            let t2 = document.getElementById("total-mobile");
            if (t2) t2.querySelector("#total-mobile-price").textContent = `Rs.${r.toFixed(2)}`;
            else {
                (t2 = document.createElement("div")),
                    (t2.id = "total-mobile"),
                    (t2.className = ".KitPrice-module__kitenzo-kitprice"),
                    (t2.innerHTML = `
              <span class="money-total" id="total-mobile-price" style="font-size: 20px; text-decoration: line-through;">Rs.${r.toFixed(2)}</span>
          `);
                const e2 = a.closest(".KitPrice-module__kitenzo-kitprice");
                e2.parentNode.insertBefore(t2, e2);
            }
        } else {
            let t2 = document.getElementById("total-div");
            if (t2) t2.querySelector("#total").textContent = `Rs.${r.toFixed(2)}`;
            else {
                (t2 = document.createElement("div")),
                    (t2.id = "total-div"),
                    (t2.className = "SidebarKitSummary-module__pricing-row"),
                    (t2.innerHTML = `
              <div class="Text-module__kitenzo-text-component" style="--font-color: inherit; --font-size: 20px;">
                  <span>Total</span>
              </div>
              <span class="money" id="total" style="font-size: 20px;">Rs.${r.toFixed(2)}</span>
          `);
                const a2 = e.closest(".SidebarKitSummary-module__pricing-row");
                a2.parentNode.insertBefore(t2, a2);
            }
        }
    }
}
function removeTotalDiv() {
    const t = document.getElementById("total-div"),
        e = document.getElementById("total-mobile");
    t && t.remove(), e && e.remove();
}
documentObserver.observe(document.body, { childList: !0, subtree: !0 });
const priceObserver = new MutationObserver((t, e) => {
    for (const e2 of t)
        if (e2.type === "childList") {
            const t2 = document.querySelector(
                ".SidebarKitSummary-module__footer-pricing-row.SidebarKitSummary-module__subtotal-pricing-row .money"
            );
            if (t2) {
                const e3 = t2.textContent.replace(/[^\d]/g, "");
                var a = parseInt(e3, 10) / 100;
                console.log("moneyElement found:", a),
                    new MutationObserver((e4) => {
                        for (const o of e4)
                            if (o.type === "childList" || o.type === "characterData") {
                                const e5 = t2.textContent.replace(/[^\d]/g, "");
                                var a2 = parseInt(e5, 10) / 100;
                                console.log("Change detected in moneyElement:", a2);
                            }
                    }).observe(t2, { childList: !0, subtree: !0, characterData: !0 }),
                    priceObserver.disconnect();
            }
        }
});
document.addEventListener("DOMContentLoaded", function () {
    const quantitySelectors = [
            ".form-input.quantity__input",
            ".form-input.quantity",
            ".form-input.quantity.cart-item-qty-input",
        ],
        decrementButtonSelector = ".minus.btn-quantity",
        incrementButtonSelector = ".plus.btn-quantity";
    function handleQuantityInput(event2) {
        let value = parseInt(event2.target.value) || 0;
        value > 30 ? (event2.target.value = 30) : value < 1 && (event2.target.value = 1);
    }
    function adjustQuantity(button, increment) {
        let inputField;
        if (
            (button.closest(".quantity__container")
                ? (inputField = button.closest(".quantity__container").querySelector("input"))
                : button.closest("cart-update-quantity")
                  ? (inputField = button.closest("cart-update-quantity").querySelector("input"))
                  : button.closest(".cart-item-qty") &&
                    (inputField = button.closest(".cart-item-qty").querySelector("input")),
            inputField)
        ) {
            let value = parseInt(inputField.value) || 0;
            value > 30 ? (value = 30) : value < 1 && (value = 1),
                (inputField.value = value),
                inputField.dispatchEvent(new Event("input"));
        }
    }
    function addListenersToQuantityFields() {
        quantitySelectors.forEach((selector) => {
            document.querySelectorAll(selector).forEach((inputField) => {
                inputField.dataset.listenerAdded ||
                    (inputField.addEventListener("input", handleQuantityInput),
                    (inputField.dataset.listenerAdded = "true"));
            });
        }),
            document.querySelectorAll(decrementButtonSelector).forEach((button) => {
                button.dataset.listenerAdded ||
                    (button.addEventListener("click", function () {
                        adjustQuantity(button, !1);
                    }),
                    (button.dataset.listenerAdded = "true"));
            }),
            document.querySelectorAll(incrementButtonSelector).forEach((button) => {
                button.dataset.listenerAdded ||
                    (button.addEventListener("click", function () {
                        adjustQuantity(button, !0);
                    }),
                    (button.dataset.listenerAdded = "true"));
            });
    }
    addListenersToQuantityFields(),
        new MutationObserver(function (mutations) {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    node.nodeType === 1 &&
                        (quantitySelectors.forEach((selector) => {
                            node.matches(selector) &&
                                (handleQuantityInput({ target: node }),
                                node.dataset.listenerAdded ||
                                    (node.addEventListener("input", handleQuantityInput),
                                    (node.dataset.listenerAdded = "true"))),
                                node.querySelectorAll(selector).forEach((inputField) => {
                                    handleQuantityInput({ target: inputField }),
                                        inputField.dataset.listenerAdded ||
                                            (inputField.addEventListener("input", handleQuantityInput),
                                            (inputField.dataset.listenerAdded = "true"));
                                });
                        }),
                        node.matches(decrementButtonSelector) &&
                            (node.dataset.listenerAdded ||
                                (node.addEventListener("click", function () {
                                    adjustQuantity(node, !1);
                                }),
                                (node.dataset.listenerAdded = "true"))),
                        node.matches(incrementButtonSelector) &&
                            (node.dataset.listenerAdded ||
                                (node.addEventListener("click", function () {
                                    adjustQuantity(node, !0);
                                }),
                                (node.dataset.listenerAdded = "true"))),
                        node.querySelectorAll(decrementButtonSelector).forEach((button) => {
                            button.dataset.listenerAdded ||
                                (button.addEventListener("click", function () {
                                    adjustQuantity(button, !1);
                                }),
                                (button.dataset.listenerAdded = "true"));
                        }),
                        node.querySelectorAll(incrementButtonSelector).forEach((button) => {
                            button.dataset.listenerAdded ||
                                (button.addEventListener("click", function () {
                                    adjustQuantity(button, !0);
                                }),
                                (button.dataset.listenerAdded = "true"));
                        }));
                });
            });
        }).observe(document.body, { childList: !0, subtree: !0 });
}),
    document.addEventListener("DOMContentLoaded", (t) => {
        const e = document.querySelector(".list-menu .menu-lv-item:first-child");
        if (e) {
            e.classList.add("color-red");
            const t2 = e.querySelector("a");
            if (t2) {
                const e2 = document.createElement("span");
                (e2.className = "menu-off-blinking-text blink"), (e2.innerText = "UPTO 15% OFF"), t2.appendChild(e2);
            }
        }
    });
class TableOfContents {
    constructor(options = {}) {
        (this.selector = options.selector || "#table-of-contents"),
            (this.headingSelector = ".toc-main-content h2,.toc-main-content h3"),
            (this.title = options.title || "Table of Contents"),
            (this.container = document.querySelector(this.selector)),
            this.container && (this.generateTOC(), this.addScrollSpy());
    }
    generateTOC() {
        const headings = document.querySelectorAll(this.headingSelector);
        if (headings.length === 0) return;
        const tocHTML = this.buildTOCHTML(headings);
        this.container.innerHTML = tocHTML;
    }
    buildTOCHTML(headings) {
        let tocHTML = `<div class="blog-toc">
                    <div class="blog-toc-header" id="toc-header">
                        ${this.title}
                        <span class="blog-toc-toggle">\u25BC</span>
                    </div>
                    <ul id="toc-content">`;
        return (
            headings.forEach((heading, index2) => {
                const headingId = this.generateHeadingId(heading, index2);
                heading.id = headingId;
                const level = heading.tagName.toLowerCase(),
                    text = heading.textContent.trim();
                tocHTML += `<li>
                        <a href="#${headingId}" class="toc-${level}" data-target="${headingId}">
                            ${text}
                        </a>
                    </li>`;
            }),
            (tocHTML += "</ul></div>"),
            tocHTML
        );
    }
    generateNumber(numbering, currentLevel) {
        const levelNum = parseInt(currentLevel.substring(1));
        let number = "";
        for (let i = 2; i <= levelNum; i++)
            numbering[`h${i}`] > 0 && (number && (number += "."), (number += numbering[`h${i}`]));
        return number;
    }
    generateHeadingId(heading, index2) {
        let id = heading.id;
        return (
            id ||
                ((id = heading.textContent
                    .toLowerCase()
                    .replace(/[^\w\s-]/g, "")
                    .replace(/\s+/g, "-")
                    .replace(/-+/g, "-")
                    .trim()),
                document.getElementById(id) && (id += `-${index2}`)),
            id
        );
    }
    addScrollSpy() {
        const tocLinks = this.container.querySelectorAll("a[data-target]"),
            headings = document.querySelectorAll(this.headingSelector),
            tocHeader = this.container.querySelector("#toc-header"),
            tocContent = this.container.querySelector("#toc-content"),
            tocToggle = this.container.querySelector(".blog-toc-toggle");
        (tocContent.style.maxHeight = tocContent.scrollHeight + "px"),
            tocHeader.addEventListener("click", () => {
                tocContent.classList.contains("collapsed")
                    ? (tocContent.classList.remove("collapsed"),
                      tocToggle.classList.remove("collapsed"),
                      (tocContent.style.maxHeight = tocContent.scrollHeight + "px"))
                    : (tocContent.classList.add("collapsed"),
                      tocToggle.classList.add("collapsed"),
                      (tocContent.style.maxHeight = "0px"));
            }),
            tocLinks.forEach((link) => {
                link.addEventListener("click", (e) => {
                    e.preventDefault();
                    const targetId = link.getAttribute("data-target"),
                        targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        const elementPosition = targetElement.offsetTop - 180;
                        window.scrollTo({ top: elementPosition, behavior: "smooth" });
                    }
                });
            });
        const observerOptions = { rootMargin: "-100px 0px -66%", threshold: 0 },
            observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        tocLinks.forEach((link) => link.classList.remove("active"));
                        const activeLink = this.container.querySelector(`a[data-target="${entry.target.id}"]`);
                        activeLink && activeLink.classList.add("active");
                    }
                });
            }, observerOptions);
        headings.forEach((heading) => {
            heading.id && observer.observe(heading);
        });
    }
}
document.addEventListener("DOMContentLoaded", () => {
    new TableOfContents({ selector: "#table-of-contents", headingSelector: "h2, h3", title: "Table of Contents" });
}),
    typeof Shopify < "u" &&
        document.addEventListener("shopify:section:load", () => {
            new TableOfContents();
        });
//# sourceMappingURL=/cdn/shop/t/55/assets/theme.js.map?v=44477034617083041851775039671
